const bg = {
  errors: {
    missingPermission: "Нямате право за това действие ({{permission}}).",
  },
  common: {
    scrollLeft: "Превърти наляво",
    scrollRight: "Превърти надясно",
    unsavedTitle: "Незапазени промени",
    unsavedDesc: "Имате незапазени промени. Да затворите ли без запазване?",
    unsavedLeave: "Затвори",
    unsavedStay: "Остани",
    appName: "UnrealSoft",
    installBannerKicker: "PWA",
    installBannerTitle: "Инсталирай UnrealSoft",
    installBannerDesc: "Добави приложението на началния екран за бърз достъп.",
    installBannerCta: "Инсталирай приложението",
    restaurantSystem: "Система за управление на ресторанти",
    logout: "Изход",
    fullscreen: "Цял екран",
    exitFullscreen: "Изход от цял екран",
    language: "Език",
    chooseLanguage: "Изберете език",
    theme: "Тема",
    chooseTheme: "Изберете тема",
    themeLight: "Светла",
    themeDark: "Тъмна",
    // Цветовете на темата — ключовете са THEME_COLORS (lib/themePalettes.ts);
    // всеки има светла и тъмна.
    themes: {
      orange: "Оранжево",
      green: "Зелено",
      sky: "Небесно синьо",
      cream: "Кремаво",
      violet: "Виолетово",
      silver: "Сребристо",
      red: "Червено",
    },
    newVersionTitle: "Налична е нова версия",
    newVersionMessage: "Моля, презаредете приложението, за да я получите.",
    newVersionReload: "Презареди",
    moduleLoadFailed: "Модулът не можа да се зареди.",
    qrTitle: "QR код",
    qrSubtitle: "Сканирайте, за да отворите ресторанта",
    backoffice: "Backoffice",
    cancel: "Отказ",
    confirm: "Потвърди",
    back: "Назад",
    close: "Затвори",
    save: "Запази",
    delete: "Изтрий",
    edit: "Редактирай",
    add: "Добави",
    search: "Търси",
    loading: "Зареждане...",
    error: "Грешка",
    forbidden: "Нямате права за тази операция",
    success: "Успешно",
    warning: "Внимание",
    info: "Информация",
    yes: "Да",
    no: "Не",
    ok: "OK",
    total: "Общо",
    date: "Дата",
    refresh: "Обнови",
    apply: "Приложи",
    clear: "Изчисти",
    filters: "Филтри",
    noData: "Няма данни",
    product: "Продукт",
    today: "Днес",
    yesterday: "Вчера",
    print: "Печат",
    options: "Опции",
    quantity: "Количество",
    price: "Цена",
    amount: "Сума",
    status: "Статус",
    comment: "Коментар",
    details: "Детайли",
    view: "Виж",
    min: "мин",
    selected: "Избрани",
    select: "Избери",
    max: "Макс",
    totalRecords: "Общо {{count}} записа",
    totalReports: "Общо {{count}} отчета",
    securedJwt: "Защитено с JWT • Anti-brute-force активен",
    callPhone: "Обади се на {{phone}}",
  },

  login: {
    welcomeKicker: "ДОБРЕ ДОШЛИ",
    eyebrow: "Ресторантска система",
    heroHeadline: "Управление на ресторанта, събрано на едно място.",
    feature1: "Поръчки, сметки и продажби в реално време",
    feature2: "Справки и анализ на приходите",
    feature3: "Конфигурация на меню, маси и оператори",
    title: "Вход в системата",
    subtitle: "Моля, въведете вашите данни за достъп.",
    usernameLabel: "Потребител",
    usernamePlaceholder: "admin",
    usernameRequired: "Въведете потребител",
    usernameMin: "Минимум 3 символа",
    passwordLabel: "Парола",
    passwordPlaceholder: "••••••••",
    passwordRequired: "Въведете парола",
    passwordMin: "Паролата трябва да е поне 3 символа",
    loginButton: "Вход",
    loginSuccess: "Успешен вход",
    loginSuccessDesc: "Добре дошли обратно!",
    loginFailed: "Неуспешен вход",
    loginFailedDesc: "Проверете потребителското име и паролата.",
    heroDescription:
      "Управлявай всички процеси в твоя ресторант лесно и бързо.",
    activeSession: "Активна сесия",
    activeSessionDesc:
      "Има активна сесия с този потребител. Сигурни ли сте, че искате да я прекратите?",
    terminateAndLogin: "Прекрати и Влез",
    insufficientLicenses: "Недостатъчен брой лицензи",
    selectUserToLogout:
      "Моля, изберете потребител, който да излезе от системата:",
    forceLogout: "Изход и влез",
    lastActivity: "Последна активност:",
  },

  // Изтичащ лиценз — модалът с „Разбрах" веднага след входа (src/lib/licenseNotice.ts)
  licenseNotice: {
    modal: {
      titleCountdown: "Достъпът ще спре след",
      titleBlocked: "Достъпът е спрян",
      expiresAt: "Лицензът изтича на {{date}} в {{time}} ч.",
      expiredAt: "Лицензът изтече на {{date}} в {{time}} ч.",
      blockedOn: "Лицензът изтече на {{date}} и входът в системата е спрян.",
      contact: "Свържете се с UnrealSoft, за да подновите лиценза без прекъсване.",
      contactBlocked: "Свържете се с UnrealSoft, за да подновите лиценза.",
      // Режим „само преглед" след гратиса („Справки“/„Склад“, src/lib/licenseReadOnly.ts)
      titleReadOnly: "Само преглед",
      readOnly:
        "Можете да разглеждате „Справки“ и „Склад“. Промените, действията и останалите модули са недостъпни до подновяването на лиценза — свържете се с UnrealSoft.",
      readOnlyOn: "Лицензът изтече на {{date}} — разрешен е само преглед.",
      acknowledge: "Разбрах",
    },
  },

  dashboard: {
    greeting: "Здравейте, {{name}}",
    subtitle: "Изберете модул и продължете към съответната функционалност.",
  },

  modules: {
    pageTitle: "Модули",
    welcomeKicker: "Добре дошли",
    ordering: "Маркиране",
    orderingDesc:
      "Създавайте поръчки, маркирайте продукти по маси и управлявайте сметки в реално време",
    configuration: "Конфигурация",
    configurationDesc:
      "Конфигурирайте монитори, фискални принтери и системни настройки на заведението",
    monitors: "Монитори",
    monitorsDesc:
      "Наблюдавайте активни поръчки по станции и управлявайте статуса им в реално време",
    reports: "Справки",
    reportsDesc:
      "Преглеждайте история на маси, персонални и заведенски отчети, сторно и разделени сметки",
    reservations: "Резервации",
    reservationsDesc:
      "Планирайте и управлявайте резервации на маси, графици и наличност по дати",
    inventory: "Складова база",
    inventoryDesc:
      "Следете складови наличности, управлявайте доставки и контролирайте движението на стоки",
    discounts: "Отстъпки",
    discountsDesc:
      "Създавайте и управлявайте отстъпки, промоции и клиентски програми за лоялност",
    delivery: "Доставки",
    deliveryDesc:
      "Организирайте доставки, проследявайте куриери и управлявайте поръчки за доставка",
    monitoring: "Мониторинг",
    monitoringDesc:
      "Одит на действията и фискални проблеми — служебен достъп за администратора",
    aiIntegrations: "AI интеграции",
    aiIntegrationsDesc:
      "Изкуствен интелект, който прогнозира, анализира и поема рутинната работа вместо вас",
    aiModal: {
      title: "AI интеграции",
      subtitle:
        "Изкуственият интелект идва във всеки модул — по-малко ръчна работа и повече време за гостите.",
      available: "Вече работи",
      footnote: "Работим по тях — ще ви уведомим, щом станат налични.",
      features: {
        voice: {
          title: "Гласови поръчки",
          desc: "Сервитьорът изговаря поръчката — системата я маркира сама.",
        },
        forecast: {
          title: "Прогноза на оборота",
          desc: "Предвижда натоварените дни и часове, за да планирате смени и зареждане.",
        },
        restock: {
          title: "Умно зареждане на склада",
          desc: "Предлага какво и колко да поръчате според продажбите и наличностите.",
        },
        menu: {
          title: "Анализ на менюто",
          desc: "Показва кои ястия носят печалба и кои е време да промените.",
        },
        reservations: {
          title: "AI асистент за резервации",
          desc: "Приема резервации по телефона и в чата — денонощно.",
        },
        invoices: {
          title: "Доставки от снимка",
          desc: "Снимате фактурата на доставчика и доставката влиза в склада.",
        },
      },
    },
    noRoles: "Нямате добавени роли",
    noRolesDesc:
      "За да имате достъп до модулите, трябва да ви бъдат добавени роли/права. Моля, свържете се с администратор.",
    comingSoonKicker: "Очаквайте скоро",
    comingSoonTitle: "{{module}} още се разработва",
    comingSoonDesc:
      "Работим по модула. Следете за актуализации — ще уведомим, щом бъде наличен.",
    comingSoonCta: "Разбрах",
    accessOn: "Тестов режим",
    revokeAccess: "Изход от тестов режим",
    rolesLabel: "Роли",
    accessModal: {
      title: "Тестов режим",
      subtitle: "Въведете кода за тестов режим",
      clear: "Изчисти",
      backspace: "Назад",
      submit: "Вход",
      close: "Затвори",
    },
  },

  navbar: {
    reportsAndAnalysis: "Справки и анализи",
    configurationSubtitle: "Конфигурация на системата",
    monitorsSubtitle: "Наблюдение на поръчки",
    deliverySubtitle: "Управление на доставки",
    discountsSubtitle: "Управление на отстъпки",
    inventorySubtitle: "Складова база",
    reservationsSubtitle: "Управление на резервации",
  },

  sidebar: {
    dashboard: "Табло",
    sales: "Продажби",
    settings: "Настройки",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
  },

  ordering: {
    depositLoad: "Депозит",
    // Нова маса без интернет (`NewTableModal`): текстът СЛУЖИ и за
    // разпознаване — под него се показва редът какво може да направи управител.
    tableCheckOffline:
      "Няма връзка с облака — масата не е създадена. Провери интернета и опитай пак.",
    tableCheckOfflineHint:
      "Ако интернетът е спрял, управител може да превключи обекта на работа срещу касата.",
    // Сървърът е отговорил, но проверката за свободно име е счупена: масата се
    // създава въпреки това — заето име се отказва от самото създаване.
    tableCheckSkipped:
      "Не е проверено дали името е свободно ({{reason}}) — масата е създадена; заето име щеше да бъде отказано.",
    // „Нова маса“ с предложен номер (настройка „Предлагане на номер за нова
    // маса“): редът под полето, докато номерът още е предложението.
    newTableSuggestedHint:
      "Първият свободен номер — ОК го приема, въведете друг, за да го смените",
    // „Нова маса" с правото „Откриване и закриване на сметки на други
    // оператори": първо на кой сервитьор е масата, после номерът.
    newTableWaiter: {
      subtitle: "На кой сервитьор е масата?",
      you: "Вие",
      openTables_one: "{{count}} отворена маса",
      openTables_other: "{{count}} отворени маси",
      noOpenTables: "няма отворени маси",
      dash: "Тире",
      offlineBlocked:
        "Без интернет маса на друг сервитьор не може да се отвори. Изчакайте връзката и натиснете пак „Поръчай“.",
    },
    // Преименуване на маса (`RenameTableModal`): проверката за свободно име е
    // пропаднала. НЕ е отказ — „Премести" остава активно.
    renameCheckOffline:
      "Няма връзка с облака — не е проверено дали името е свободно. „Премести“ пак работи: заетата маса се отказва при самото местене.",
    renameCheckFailed:
      "Проверката за свободно име не мина: {{reason}}. „Премести“ пак работи.",
    // Бързо закриване без облак: номерът на новата маса е сметнат от масите на
    // ТОЗИ екран, не от BE-то.
    nextTableNameOffline:
      "Няма връзка с облака — номерът е избран от масите на този екран: {{name}}. Провери с колегите, преди да го обявиш.",
    nextTableNameLocal:
      "Номерът е избран от масите на този екран ({{name}}): {{reason}}",
    // Поръчка, тръгнала към облака, който не отговори. Не се повтаря сама —
    // затова текстът праща човека да погледне масата.
    orderCloudUnreachable:
      "Няма връзка с облака. Не е сигурно дали поръчката е стигнала — виж масата, преди да я пуснеш пак.",
    tableKicker: "Маса",
    loadingMenu: "Зареждане на меню...",
    searchProduct: "Търси продукт...",
    noProductsFound: "Няма намерени продукти",
    searchTable: "Търси маса, сметка или сервитьор...",
    cardNoReceiptTag: "Карта — без бон",
    tableClosing: "Закрива се",
    // Нещата за сметката върху кутийката на масата в „Списък"
    // (tables/cardInfo/tableCardFacts.ts): текстът на реда и подсказките
    cardInfo: {
      billDiscount: "на цялата сметка",
      billDiscountTitle: "Отстъпка на цялата сметка: {{amount}}",
      lineDiscount: "по продукти",
      lineDiscountTitle: "Отстъпки по продуктите: средно {{percent}}",
      lineSurchargeTitle: "Надбавки по продуктите: средно {{percent}}",
      clientTitle: "Клиент: {{name}} ({{percent}})",
      depositNumber: "№ {{id}}",
      depositTitle: "{{title}}: {{amount}}",
      guestsTitle: "Брой гости: {{count}}",
      moreTitle: "Още:\n{{list}}",
    },
    // Дръжките за размера на екрана с масите (десктоп, „Списък")
    tablesLayout: {
      resizeRail: "Плъзнете за ширината на масите. Двоен клик — по подразбиране.",
      resizeCardWidth: "Плъзнете за кутийки на ред. Двоен клик — по подразбиране.",
      resizeCardHeight: "Плъзнете за височината на кутийките. Двоен клик — по подразбиране.",
      resizeCard: "Плъзнете за размера на кутийките. Двоен клик — по подразбиране.",
    },
    // Подсказката на настанената резервация върху кутийката на масата
    seatedReservationTag: "Настанена резервация — {{name}}",
    noTablesFound: "Няма намерени сметки",
    noTablesFoundHint: "Опитай с друга дума или изчисти търсенето.",
    noOpenTables: "Все още няма отворени сметки",
    noOpenTablesHint:
      "Създай нова маса от бутона отдолу, за да започнеш поръчка.",
    info: "Инфо",
    // „Инфо" в режим със склад: съставките на рецептата (едно ниво)
    infoIngredients: "Съставки",
    infoSubRecipe: "Рецепта",
    modify: "Промени",
    order: "Поръчай",
    newTable: "Нова маса",
    guestCount: {
      title: "Брой гости",
      quickPick: "Бърз избор",
      keyboardHint: "Напишете броя и натиснете Enter, ↑ ↓ за промяна.",
      confirm_one: "Потвърди · {{count}} гост",
      confirm_other: "Потвърди · {{count}} гости",
      saveError: "Броят гости не е записан",
      saved: "Броят гости е записан",
    },
    closeTable: "Закрий",
    cancelItem: "Сторно",
    split: "Раздели и прехвърли",
    clients: "Клиенти",
    billDiscountClient: "Клиент",
    billDiscountBase: "Основа",
    billDiscountLabel: "Отстъпка",
    billSurchargeLabel: "Надбавка",
    discounts: "Отстъпки",
    lockedPriceNoDiscount:
      "На този продукт не може да се приложи отстъпка — заключена цена.",
    customPrice: "Промяна на цена",
    preliminaryBill: "Предварителна сметка",
    preliminaryBillPrinting: "Печат на предварителна сметка…",
    preliminaryBillSuccess: "Предварителната сметка е отпечатана.",
    preliminaryBillError: "Грешка при печат на предварителната сметка.",
    report: "Отчет",
    interimReport: "Междинен отчет",
    interimReportCode: "Въведете кода си",
    operations: "Фискални операции",
    invoicing: "Фактуриране",
    restore: "Възстановяване",
    selectTableToView:
      "Създайте нова маса от бутона отдолу, за да започнете нова поръчка.",
    noTableSelected: "Няма избрана маса",
    noTableSelectedHint:
      "Избери маса отляво, за да видиш поръчаните продукти, или създай нова от бутона отдолу.",
    noOrdersForTable: "Няма поръчки за тази маса",
    noOrdersForTableHint:
      "Добави продукти от менюто, за да започнеш поръчка на тази маса.",
    tableNumber: "Номер на маса",
    tableCreatedSuccess: 'Маса "{{name}}" е създадена и продуктите са добавени',
    tableJoinedSuccess: 'Маса "{{name}}" е отворена и продуктите са добавени',
    productsAddedSuccess: "Продуктите са добавени към масата",
    selectProductsWarning: "Моля, изберете продукти за поръчка",
    home: "Начало",
    modifiers: "Модификатори:",
    addonRequired: "изберете",
    addonRecommended: "препоръчани",
    addonOptional: "по избор",
    itemComment: "Коментар",
    itemCommentPlaceholder: "Допълнителна бележка към продукта",
    orderPreview: "Преглед на поръчката",
    summarized: "Обобщено",
    orderComment: "Коментар към поръчката:",
    commentPlaceholder: "Въведете коментар...",
    reservationNotice: {
      blockedTitle: "Масата е към настанена резервация",
      linkedTable: "Маса {{table}} е към настанената резервация на {{guest}} — сметката е на маса {{billTable}}. Поръчвай там.",
      understood: "Разбрах",
      title: "Масата има резервация",
      question: "{{notice}}. Продължаваш ли?",
      continue: "Продължи",
      seated: "Маса {{table}} е заета от резервацията на {{guest}} (настанени {{time}})",
      upcoming_one: "Маса {{table}} е резервирана за {{time}} — {{guest}}, {{count}} гост",
      upcoming_other: "Маса {{table}} е резервирана за {{time}} — {{guest}}, {{count}} гости",
      // „Отказ" при бързото отваряне → предложение за следващия свободен номер
      openInstead: "Маса {{reserved}} е резервирана. Да отворим ли маса {{free}}?",
      openTable: "Отвори маса {{name}}",
      noFreeTable: "Няма свободна маса без резервация — отвори ръчно",
      searchingFreeTable: "Търся свободна маса без резервация…",
    },
    tableAlreadyExists: 'Маса "{{name}}" вече съществува',
    pleaseChooseDifferentName: "Моля, изберете друго име за масата",
    add: "Добави",
    options: "Опции",
    // Влачене между „Опции" и лентата под масите (TableFooterBar)
    optionsDragHint: "Задръж бутон и го довлечи където искаш в лентата долу — и между основните. Обратно пак с влачене. „Нова маса“, „Добави“, „Закрий“ и „Опции“ също се местят в лентата.",
    optionsDropHere: "Пусни тук, за да върнеш бутона в „Опции“",
    optionsEmpty: "Всички бутони са в лентата. Довлечи бутон тук, за да го върнеш.",
    footerLayoutSaveError: "Подредбата на лентата не се записа",
    // Гласова поръчка (микрофонът до търсачката на масите)
    voiceOrder: "Гласова поръчка",
    voiceListening: "Говорете…",
    voiceHold: "Задръжте и говорете",
    voiceListeningHint:
      "Например: „Отвори маса 1 и добави 2 пъти салата цезар с 2 коли“",
    voiceTranscribing: "Разпознаване на речта…",
    voiceProcessing: "Разпознаване на поръчката…",
    voiceNotSupported:
      "Този браузър не дава достъп до микрофона. Отворете приложението през https:// в актуален браузър.",
    voiceNoSpeech: "Не чух нищо. Опитайте отново.",
    voiceMicDenied:
      "Няма достъп до микрофона — разрешете го от настройките на браузъра.",
    voiceMicUnavailable:
      "Микрофонът не е достъпен — проверете дали друго приложение не го ползва.",
    voiceErrAudioTooLarge: "Записът е твърде дълъг — опитайте с по-кратка поръчка.",
    voiceErrUnsupportedAudio:
      "Форматът на записа не се поддържа от този браузър.",
    voiceParseError: "Неуспешно разпознаване на поръчката. Опитайте отново.",
    // Кодовете идват от BE-то (502 → detail.code); непознат код пада към
    // voiceParseError. Виж cloudTS-restaurant-be/docs/cross-repo-contract.md.
    voiceErrTooLong:
      "Поръчката е твърде дълга — разделете я на няколко по-къси.",
    voiceErrUnreadable: "Неразбираем отговор от модела. Опитайте отново.",
    voiceErrEmpty: "Празен отговор от модела. Опитайте отново.",
    voiceErrRefused: "Заявката беше отказана от модела. Опитайте отново.",
    voiceErrUpstream:
      "Услугата за разпознаване е недостъпна в момента. Опитайте отново.",
    voiceErrNotConfigured:
      "Гласовите поръчки не са настроени. Обърнете се към администратор.",
    voiceNoItems: "Не са разпознати продукти в казаното.",
    // „Настани резервацията на …" по глас (voice/useVoiceSeat.tsx).
    voiceSeatNotFound: "Няма резервация за настаняване на име „{{name}}“",
    voiceSeatNotAllowed: "Нямаш право да настаняваш резервации",
    voiceRetry: "Отново",
    voiceContinue: "Продължи",
    voiceChooseHint:
      "Казаното съвпада с няколко възможности — изберете кое имате предвид.",
    voiceNeedsConfig: "Изберете задължителните добавки",
    voiceTable: "Маса",
    voiceTableNew: "нова маса",
    voiceTableExisting: "допоръчка към отворената маса",
    voiceTablePlaceholder: "напишете маса…",
    voiceNoMatch: "няма съвпадение в менюто",
    voiceConfirm: "Поръчай",
    voiceCancel: "Отказ",
    voiceSuccess: "Поръчката за маса „{{name}}“ е изпратена.",
    itemServed: "Продуктът е маркиран като сервиран",
    itemUnserved: "Сервирането е отменено",
    itemServedError: "Грешка при маркиране на продукта като сервиран",
    servedStatus: "Сервирано",
    // Станция със сервитьорски монитор: редът се сервира чак от неговия
    // „сервира след" статус (OrderItemRow, serveRule.ts)
    serveAfterStatus: "Сервира се след статус „{{status}}“",
    statusLegend: "Легенда на статусите",
    statusNotStarted: "Незапочнато",
    statusInProgress: "В процес",
    statusCooked: "Сготвено",
    statusIssued: "Издадено",
    closeTableSuccess: "Сметката е затворена успешно.",
    closeTableError: "Грешка при затваряне на сметката.",
    renameTable: "Смяна на маса",
    renameTableTitle: "Преименуване на маса",
    renameTableSubtitle: "Ново име на масата",
    renameTableSuccess: 'Масата е преименувана на "{{name}}"',
    renameTableError: "Грешка при преименуване на масата",
    // „Смяна на маса" (manage/RenameTableModal.tsx): откъде → накъде.
    moveTableSubtitle: "Маса {{name}} → към друга маса",
    moveTableButton: "Премести",
    moveTableTaken: "Маса {{name}} е заета",
    moveTableTakenBy: "Маса {{name}} е заета от {{waiter}}",
    // „Към друга маса" от „Раздели" (NewTableModal с `moveFrom`).
    moveToTableTitle: "Към друга маса",
    moveToTableButton: "Премести на маса {{name}}",
    // Проверката докато се пише не мина — само предупреждение.
    tableCheckLiveFailed: "Няма връзка — не е проверено дали масата е свободна.",
    transferBill: "Смяна на сервитьор",
    transferBillTitle: "Прехвърляне на сметка на друг сервитьор",
    transferBillSubtitle: "Сервитьори: {{count}}",
    transferBillConfirm: "Прехвърли",
    transferBillSuccess: "Сметката е прехвърлена успешно",
    transferBillError: "Грешка при прехвърляне на сметката",
    transferAllBills: "Прехвърли всичките ми {{count}} маси",
    transferAllBillsSuccess: "Прехвърлени са {{count}} маси",
    transferAllBillsError: "Грешка при прехвърляне на масите",
    discardItemsConfirmTitle: "Излизане от поръчката",
    discardItemsConfirmContent:
      "Сигурни ли сте? Маркираните продукти ще бъдат премахнати.",
    productsShortCount: "{{count}} прод.",
    itemsShortCount: "{{count}} арт.",
    orderSheetTitle: "Поръчка",
    modifyDone: "Добави · {{price}}",
    modifyOrder: "Поръчай · {{price}}",
    reorderUnavailable: "Продуктът не е наличен в менюто",
    allCategories: "Всички категории",
    noGroup: "Без група",
    emptyOrder: "Изберете продукти отляво, за да започнете поръчка.",
    emptyOrderShort: "Все още няма продукти.",
    allRows: "Всички",
    sortName: "АБВ",
    sortPlu: "КОД",
    sortIndex: "СОРТ ИНДЕКС",
    allStations: "Всички станции",
    viewTiles: "Плочки",
    viewTable: "Таблица",
    // Масите като списък или върху схемата — превключвателят в горната лента
    tablesViewList: "Списък",
    tablesViewSchema: "Схема",
    // Режимът „Схема" на екрана с масите (components/tables/schema/)
    schema: {
      // Надписът над името на масата в панела (с главни букви през CSS)
      tableKicker: "Маса",
      temporaryTables: "Временни маси",
      temporaryTablesHint: "Открити извън схемата",
      // Сивата лента под „Временни маси": закритите без касова бележка
      nonFiscalTables: "Нефискализирани маси",
      nonFiscalTablesHint: "Закрити без касова бележка",
      // Полето горе вдясно: чии маси се показват (право view_all_users_bills)
      waiterFilter: "Масите на сервитьор",
      unknownWaiter: "Неизвестен сервитьор",
      freeTableHint:
        "Свободна маса. Кликнете два пъти върху нея в схемата, за да я откриете и да маркирате поръчка.",
      noTableSelectedHint:
        "Избери маса от схемата, за да видиш поръчаните продукти или да отвориш свободна маса.",
      noSchemaHint:
        "Масите се отварят от „Списък“, докато районите и масите не бъдат нарисувани в Резервации → Схема на заведението.",
      offlineHint:
        "Касата няма копие на схемата — масите се отварят от „Списък“, докато интернетът се върне.",
    },
    keyboard: "Клавиатура",
    hideKeyboard: "Скрий",
    space: "Интервал",
    clearSearch: "Изчисти",
    backspace: "Изтрий знак",
    searchKicker: "Търси",
    searchHint: "въведи име или код",
    kbBds: "БДС",
    kbPhonetic: "Фонетична",
    kbLatin: "ABC",
    previewStations: "Станции",
    previewGroups: "Групи",
    // „Задържане на поръчка" (docs/ordering.md §Поток: задържане на поръчка):
    // времето за кухнята на редовете в „Преглед на поръчката", „Промени" и
    // „Пусни сега" в масата
    kitchenHold: {
      held: "Задържана",
      release: "Пусни сега",
      // Задържана партида в масата: „Промени" разгъва седемте избора; срокът
      // вляво — „09:11" и „след 29 мин"
      change: "Промени",
      releaseIn: "след {{count}} мин",
      // Ръчно задържана (∞): от колко време чака
      heldFor: "от {{count}} мин",
      heldJustNow: "току-що",
      manualHint: "Ръчно — докато някой не натисне „Пусни сега“",
      changeError: "Времето не беше сменено",
      // Времето за кухнята на ред: „Сега", минути или „Ръчно" (∞ — до „Пусни сега")
      now: "Сега",
      minutesShort: "{{count}}′",
      manualShort: "Ръчно",
      // Хапчето в заглавието, когато редовете са с различни времена
      mixed: "различно",
      allRowsLabel: "Едно време за всички редове",
      sameForAll: "Същото време за всички редове",
      rowTime: "Време за кухнята",
      // Под „Поръчай": „1 сега · 3 ∞" (ръчно), „4 след 10′"
      summaryNow: "{{count}} сега",
      summaryMinutes: "{{count}} след {{minutes}}′",
      summaryManual: "{{count}} ∞",
      // Броячът стигна 0 — сървърът я пуска по своя таймер
      entering: "Влиза…",
      serveBlocked: "Поръчката е задържана — първо я освободи",
      released: "Поръчката влезе в кухнята",
      releaseError: "Поръчката не беше освободена",
      offlineDropped:
        "Без интернет поръчка не се задържа — времената са върнати на „Сега“ и следващото „Поръчай“ пуска всичко веднага.",
      // Питането преди „Закрий" и „Плати избраните"
      confirmTitle: "Задържани поръчки",
      confirmMessage_one: "{{count}} поръчка още не е влязла в кухнята.",
      confirmMessage_other: "{{count}} поръчки още не са влезли в кухнята.",
      confirmQuestion_one: "Ако продължиш, тя влиза веднага.",
      confirmQuestion_other: "Ако продължиш, те влизат веднага.",
      confirmContinue: "Пусни и продължи",
    },
  },

  codeKeypad: {
    title: "Въведете код",
    enterCode: "Въведете код",
    invalidCode: "Невалиден код",
    codeVerified: "Кодът е верифициран успешно",
    submit: "Вход",
    kicker: "Вход с личен код",
    clear: "Изчисти",
    venue: "Заведение",
    online: "Онлайн",
    hint: "Може да въвеждате и от клавиатурата",
  },

  logoutConfirm: {
    title: "Потвърждение за изход",
    subtitle: "Моля, въведете паролата си за потвърждение",
    passwordPlaceholder: "Парола",
    invalidPassword: "Невалидна парола",
    verificationError: "Грешка при верификация на паролата",
  },

  closeTable: {
    // Закаченият депозит в „Закрий" (payment/useCloseDeposit.ts) и изборът
    // „Използвай депозит" (tables/deposits/DepositPickerModal.tsx)
    deposit: {
      chosen: "Депозит № {{id}} · {{name}}",
      // Номерът на депозита (id) — само показване, не се редактира
      number: "Депозит № {{id}}",
      // Номерът на касовия бон на депозита (Бон 1) до номера му — само показване
      receiptNumber: "Бон № {{number}}",
      // Сметката „Сметка − Депозит = За доплащане" и какво ще стане
      // (payment/DepositPaymentSummary.tsx)
      billAmount: "Сметка",
      due: "За доплащане",
      ofTotal: "от {{amount}} EUR",
      outcomeTitle: "При закриване",
      outcomeCovers: "Сметката се плаща изцяло с депозита — гостът не доплаща.",
      outcomeUsedUp: "Депозитът се изразходва изцяло.",
      outcomePartial: "Депозитът покрива {{amount}} EUR от сметката.",
      outcomeRemainder: "Остатъкът {{amount}} EUR се плаща с „{{method}}“.",
      pickRemainderMethod: "Изберете с какво се доплаща остатъкът.",
      outcomeRetry: "Повторен опит — бонът се издава със записаните депозит и метод.",
      remainderMethodTitle: "С какво се доплащат {{amount}} EUR:",
      burned: "Неизползваните {{amount}} EUR от депозита изгарят — не се връщат на госта.",
      offline:
        "Без интернет касата не приспада депозита — сметката се плаща изцяло, а депозитът остава свободен.",
      zeroBill:
        "Сметката е 0.00 — махнете депозита от „Депозит“ → „Използвай депозит“ (или го закачете към масата с поръчките).",
      changed:
        "Депозитът на сметката е сменен на друг терминал — проверете и потвърдете отново.",
      pickerSubtitle: "Свободни депозити: {{count}}",
      searchPlaceholder: "Търсене по име, описание, № на депозит или бон",
      noMatches: "Няма депозит по търсенето",
      noDeposits: "Няма активни депозити",
      validUntil: "За дата {{date}}",
      noExpiry: "Без срок",
      takenOn: "Взет {{date}} · {{method}}",
      closeCovered: "Закриване с депозит",
    },
    table: "Маса:",
    operator: "Оператор:",
    paymentMethod: "Метод на плащане:",
    selectMethod: "Изберете метод:",
    notSelected: "Не е избран",
    noMethodsTitle: "Няма налични методи на плащане",
    noMethodsDescription:
      "Добавете и активирайте методи от Конфигурация → Методи на плащане.",
    selectPaymentWarning: "Моля, изберете метод на плащане",
    sumMismatch: "Сумата трябва да е {{total}} Въведена сума: {{entered}}.",
    totalChanged:
      "Сметката е променена — новата сума е {{total}}. Провери и потвърди отново.",
    closeSuccess: "Сметката беше успешно закрита",
    closeError: "Грешка при закриване на сметката",
    alreadyClosed: "Сметката вече е закрита",
    printerError: "Сметката е закрита, но принтерът върна грешка",
    printerTimeout: "Сметката е закрита, но принтерът не отговори навреме",
    closeButton: "Закриване",
    // Изходът от закриване във фон — модалът вече е затворен, затова
    // известието казва за коя маса е (payment/backgroundBillClose.ts).
    paymentFailed: "Неуспешно плащане — маса {{table}}: {{text}}",
    stillClosing: "Тази маса още се закрива — изчакайте бона.",
    fiscalInvoiceOffline:
      "Фискална фактура се издава само с интернет — сметката не е закрита и нищо не е отпечатано. Затворете я отново, когато връзката се върне.",
    // Сметката изчезна/смени състоянието си, докато се питаше „Брой гости"
    // (payment/useCloseBillTarget) — „Закрий" не се отваря за друга маса.
    billNoLongerOpen:
      "Маса {{table}} вече не е отворена (закрита или прехвърлена от друг терминал) — „Закрий“ е отменено.",
    tableNotice: "Маса {{table}} — {{text}}",
    paymentDistribution: "Разпределение на плащането:",
    cash: "В брой",
    card: "С карта",
    mixedTotal: "Общо: {{entered}} / {{total}}",
    totalToPay: "Общо за плащане:",
    banknotes: "Банкноти:",
    received: "Получено:",
    remaining: "Остава за доплащане",
    amountBeforeDiscount: "Сума без отстъпка",
    amountBeforeSurcharge: "Сума без надбавка",
    clientDiscount: "Отстъпка на клиента ({{percent}})",
    clientSurcharge: "Надбавка на клиента ({{percent}})",
    change: "Ресто за връщане",
    // Дизайнът „Закрий" (payment/CashTipPanel, GivenAmountField): сумите горе,
    // полето „Сума дадена от клиента" (и за бакшиша), банкнотите под него.
    changeShort: "Ресто:",
    remainingShort: "Остава:",
    givenByClient: "Сума дадена от клиента",
    clearReceived: "Изчисти",
    banknotesTitle: "Банкноти",
    banknotesCash: "Банкноти в брой",
    // „Смесено": полето, допълнено до сметката от другото (payment/MixedTipPanel).
    remainder: "остатък",
    exactAmount: "Точно",
    cardTerminalHint: "Плащане чрез терминал за карти.",
    // Бакшиш в „Закрий" и „Раздели и плати" (payment/TipEntrySection.tsx).
    // errors.* са каталогът на BE (app/features/tips/rules.py) 1:1 — FE ги
    // ползва за своите проверки преди затварянето на модала.
    tip: {
      title: "Бакшиш",
      ordered: "Поръчано след отстъпки",
      totalWithTipHint:
        "Въведете сумата, която клиентът желае да плати за поръчаното и бакшиша. Разликата спрямо поръчаното е бакшиш.",
      methodMixedBillHint:
        "Сметката е със смесено плащане — изберете един начин за целия бакшиш.",
      someMethodsWrongRoute:
        "Неактивните начини минават по друг път от плащането на сметката (с или без касов бон).",
      confirm: "Потвърждавам бакшиш {{amount}} €",
      reviewed: "Прегледано",
      dropped:
        "Въведеният бакшиш отпадна — в момента бакшиш не може да се въвежда.",
      recorded: "Бакшиш, записан при закриването",
      recordedHint: "{{method}} · повторният опит не променя бакшиша.",
      // Повторен опит: методът на ЗАПИСАНИЯ бакшиш не минава по пътя на
      // избрания метод на сметката — сменя се само той (или „Възстановяване").
      recordedWrongPath:
        "Бакшишът е записан с „{{method}}“ и не може да мине по същия път като избрания начин за плащане на сметката (с или без касов бон). Изберете друг начин за сметката или възстановете сметката.",
      breakdownTip: "Бакшиш ({{method}})",
      breakdownTotalWithTip: "Общо с бакшиш",
      // Дизайнът „Закриване — всички комбинации": бялата карта „Бакшиш"
      chooseMethod: "Изберете",
      // Скрит зад бутона „Добави бакшиш"; отворен — „Сума дадена от клиента"
      // и екранната клавиатура (разпъната/свита — помни се на компютъра).
      addTip: "Добави бакшиш",
      removeTip: "Премахни",
      underBill: "Сумата е по-малка от сметката ({{amount}} EUR)",
      // <num> — сумата с моно шрифта на числата, <tip> — бакшишът в оранжево (payment/tipDue.ts).
      dueWithTip: "Сметка <num>{{ordered}}</num> + бакшиш <tip>{{tip}}</tip>",
      dueSeparateTip: "Бакшиш <tip>{{tip}}</tip> EUR отделно · {{method}}",
      recordedShort: "Записан при закриването · {{method}}",
      errors: {
        tip_disabled: "Бакшишите не са разрешени.",
        tip_negative:
          "Общата сума не може да е по-малка от поръчаното — бакшишът не може да е отрицателен.",
        tip_method_required: "Изберете начин на плащане на бакшиша.",
        tip_method_mixed:
          "Бакшишът се плаща изцяло с един метод — „Смесено“ не е допустимо.",
        tip_method_not_allowed: "Този начин на плащане не е разрешен за бакшиш.",
        tip_over_max:
          "Бакшишът {{amount}} € е над максималния {{max}} € за една сметка.",
        tip_confirmation_required:
          "Бакшишът {{amount}} € е над {{threshold}} € — потвърдете сумата изрично.",
        tip_method_wrong_path:
          "Бакшишът с „{{method}}“ не може да мине по същия път като плащането на сметката (с или без касов бон). Изберете друг начин за бакшиша.",
        tip_method_not_on_printer:
          "Начинът „{{method}}“ не е настроен на фискалното устройство — бакшишът не може да влезе в касовия бон.",
        tip_on_account_not_allowed:
          "Клиентът на сметката не може да плаща „По сметка“.",
        tip_requires_items:
          "Бакшиш може да се добави само към сметка с поръчани артикули.",
        bill_total_changed:
          "Поръчаното по сметката е променено ({{old}} € → {{new}} €). Прегледайте отново общата сума с бакшиш.",
        tip_change_on_retry:
          "Бакшишът е записан при закриването и не може да се променя при повторен опит.",
      },
    },
  },

  // Конфигурация → Видове плащания → секцията „Бакшиш"
  // (configuration/components/payment-methods/tip/). errors.* са текстовете
  // на BE за 422 на PUT /payment-methods/tip-settings (огледалната проверка).
  tipSettings: {
    // Секцията в страницата (обобщението) и модалът „Настрой" — дизайнът
    // „Бакшиш – настройки".
    title: "Бакшиш",
    configure: "Настрой",
    statusOn: "Включено",
    statusOff: "Изключено",
    statusLineOn: "Включено — при закриване на сметка може да се въвежда бакшиш.",
    statusLineOff:
      "Изключено — при закриване на сметка не може да се въвежда бакшиш. Записаните сметки, фактури и отчети пазят данните си.",
    loadError:
      "Настройките за бакшиш не можаха да се заредят. Опитайте отново по-късно.",
    unsupported: "Сървърът още не поддържа настройки за бакшиш.",
    columnReceipt: "Позиция в бона",
    columnPayment: "Плащане и данъчна група",
    columnLimits: "Разпределение и лимити",
    summaryName: "Наименование",
    summaryNote: "Текст под реда",
    summaryNoNote: "Без текст",
    summaryNoMethods: "Няма избрани",
    summaryExpense: "Дял за разходи",
    summaryExpenseStaff: "{{percent}}% за персонала",
    summaryDeduct: "Картов бакшиш при отчитане",
    summaryDeductOn: "Приспада се",
    summaryDeductOff: "Не се приспада",
    summaryWarn: "Предупреждение над",
    summaryMax: "Максимум за сметка",
    modalSubtitle:
      "Позицията в касовия бон, начините за плащане и лимитите — на един екран.",
    close: "Затвори",
    enabledName: "Разреши бакшиш",
    enabledHint: "Сервитьорите могат да добавят бакшиш при закриване на сметка.",
    disabledHint: "Нов бакшиш не може да се въвежда; записаните данни остават.",
    receiptNameBgLabel: "Наименование — БГ",
    receiptNameBgHint: "Отпечатва се като отделна позиция в касовия бон.",
    receiptNameEnLabel: "Наименование — EN",
    receiptNameEnPlaceholder: "празно — като БГ",
    receiptNoteBgLabel: "Допълнителен текст под реда",
    receiptNoteBgHint: "Само текст — не добавя сума.",
    optional: "по избор",
    charsCount: "{{count}}/{{max}}",
    previewName: "Преглед в бона",
    previewHint: "пример с 10.00 €",
    methodsName: "Начини за плащане",
    methodsSelected: "{{count}} от {{total}}",
    methodsSearch: "Търси начин на плащане",
    methodsAll: "Избери всички",
    methodsNone: "Изчисти",
    methodsShownOf: "Показани {{shown}} от {{total}}",
    methodsNoMatch: "Няма съвпадения.",
    methodSeparateTag: "отделно",
    methodSeparateTitle:
      "Отчита се отделно: в отчетите бакшишът с този метод не участва в прихващането на брой и карта.",
    methodsHint:
      "При закриване бакшишът се показва само при избран един от тези начини и се плаща с него. „В брой“ е само с ресто, „Смесено“ не е допустимо. Потребителските методи и „По сметка“ се отчитат отделно.",
    noMethods: "Няма видове плащания.",
    taxGroupName: "Данъчна група",
    taxGroupLetter: "Група {{letter}}",
    taxGroupNoVat: "без ДДС",
    taxGroupVat: "ДДС {{rate}}%",
    taxGroupNoVatHint: "Група {{letter}} — бакшишът е без ДДС.",
    taxGroupTaxableHint: "Група {{letter}} — бакшишът е с {{rate}}.",
    taxGroupDeviceHint:
      "Използва се за реда в бона и трябва да съвпада с програмирането на устройството.",
    expenseName: "Дял за разходи",
    expenseExample:
      "Пример: от {{tip}} € бакшиш {{expense}} € остават за разходи, {{staff}} € — за персонала.",
    deductName: "Приспадай картовия бакшиш при отчитане",
    deductHint:
      "Делът на персонала от картовите бакшиши намалява парите в брой за предаване.",
    warnName: "Предупреждавай при бакшиш над",
    warnHint: "Иска потвърждение. Празно — без.",
    maxName: "Максимален бакшиш",
    maxHint: "За една сметка — по-голям не се записва.",
    footerStatus: "Статус",
    footerMethods: "Методи",
    footerTaxGroup: "Група",
    unsaved: "Незапазени промени",
    cancel: "Отказ",
    save: "Запази",
    saveSuccess: "Настройките за бакшиш са записани",
    saveError: "Грешка при запис на настройките за бакшиш",
    fixErrors: "Поправете отбелязаните полета, за да запишете.",
    errors: {
      tip_tax_group_invalid: "Изберете данъчна група А, Б или В.",
      tip_name_required: "Въведете наименование на позицията в касовия бон.",
      tip_text_too_long: "Текстът е по-дълъг от {{max}} знака.",
      tip_text_control_chars:
        "Текстът съдържа управляващи символи (табулация, нов ред и подобни) — махнете ги.",
      tip_text_unprintable:
        "Текстът съдържа знаци, които фискалното устройство не може да отпечата. Използвайте кирилица, латиница, цифри и обичайните препинателни знаци.",
      tip_method_mixed:
        "Бакшишът се плаща изцяло с един метод — „Смесено“ не е допустимо.",
      tip_method_unknown: "Начин на плащане {{id}} не съществува.",
      tip_methods_required: "Изберете поне един начин за плащане на бакшиш.",
      tip_percent_range:
        "Делът за разходи трябва да е от 0 до 100% с до два знака след запетаята.",
      tip_max_range:
        "Максималният бакшиш трябва да е над 0 € и до 99999.99 € с до два знака след запетаята.",
      tip_warn_range:
        "Прагът за предупреждение трябва да е над 0 € и не повече от максималния бакшиш, с до два знака след запетаята.",
    },
  },

  cancelItem: {
    titleAssortments: "Сторно на асортименти",
    titleRecipes: "Сторно на рецепти",
    subtitle: "Маса {{name}} · Сметка №{{id}} · общо {{total}} €",
    ofQuantity: "от {{max}}",
    confirmButton: "Сторнирай",
    defective: "Брак",
    selectAll: "Избери всичко",
    reasonLabel: "Причина",
    reasonWrongMark: "Грешно маркирано",
    reasonCustomerRefused: "Отказ от клиент",
    reasonOrderChanged: "Промяна на поръчката",
    reasonOther: "Друго",
    reasonPlaceholder: "Опиши причината...",
    // Пропаднало сторно: прозорецът ОСТАВА отворен със селекцията.
    failed:
      "Сторното не мина. Прозорецът остава отворен — виж сметката и опитай пак.",
    failedReason:
      "Сторното не мина: {{reason}}. Виж сметката — кредитното известие може и да е излязло.",
  },

  splitBill: {
    title: "Разделяне и прехвърляне",
    subtitle: "Маса {{name}} · {{total}} €",
    sumLabel: "Сума:",
    modeByProducts: "По продукти",
    modeEqual: "По равно",
    modifiersLabel: "Модификатори:",
    addonsLabel: "Добавки:",
    selectedProducts: "Избрани продукти: {{count}}",
    selectAll: "Избери всичко",
    splitButton: "Към друга маса",
    cancelButton: "Отказ",
    splitError: "Грешка при разделяне на сметка",
    transferWaiterTitle: "Прехвърли към сервитьор",
    transferWaiterSubtitle: "Сервитьори: {{count}}",
    transferWaiterSearch: "Търси сервитьор...",
    transferWaiterNone: "Няма намерени сервитьори",
    transferWaiterSkip: "Прескочи",
    transferWaiterConfirm: "Прехвърли",
    transferWaiterCurrent: "Текущ",
    transferWaiterResponsibility: "Отговорността за {{total}} EUR се прехвърля",
    transferWaiterFrom: "От",
    transferWaiterTo: "На",
    transferWaiterNoTarget: "избери сервитьор",
    transferWaiterTablesOne: "1 маса",
    transferWaiterTables: "{{count}} маси",
    transferWaiterConfirmTo: "Прехвърли на {{name}}",
    splitAndPayButton: "Плати избраните",
    // Закачен депозит — приспада се от цялата сметка при „Закрий"
    depositBlocksPay:
      "Сметката е с депозит — „Плати избраните“ е заключено. Платете цялата сметка през „Закрий“ или преместете част от редовете „Към друга маса“ и ги платете там.",
    // Отстъпката в € на цялата сметка остава на тази сметка
    billDiscountBlocksPay:
      "Сметката е с отстъпка на цялата сметка — „Плати избраните“ е заключено. Платете цялата сметка през „Закрий“ или преместете част от редовете „Към друга маса“ (отстъпката остава на тази сметка).",
    splitAndPayTitle: "Раздели и плати",
    splitAndPaySubtitle: "От сметка #{{name}}",
    splitAndPaySuccess: "Сметката е разделена и платена успешно",
    splitAndPayError: "Грешка при разделяне и плащане",
    billChanged:
      "Сметката е променена — провери избраните продукти и опитай отново.",
  },

  confirmSplit: {
    title: "Масата е заета",
    transferQuestion:
      "Желаете ли да прехвърлите избраните продукти към вече отворената маса?",
    transferButton: "Прехвърли",
    occupiedByOtherWaiter: "Маса „{{name}}“ вече е заета от друг сервитьор.",
    noTransferPermission:
      "Нямате право да прехвърляте разделени продукти към друг сервитьор.",
    understoodButton: "Разбрах",
  },
  duplicateTableName: {
    title: "Масата ще се дублира",
    transferMessage:
      "Сервитьорът, към когото прехвърляте, вече има отворена маса „{{name}}“.",
    restoreMessage: "Вече има отворена маса „{{name}}“.",
    transferAllMessage:
      "Сервитьорът, към когото прехвърляте, вече има отворени маси с някои от вашите имена.",
    transferAllQuestion:
      "Ако продължите, ще има по две отворени маси с едно и също име.",
    question:
      "Ако продължите, ще има две отворени маси с име „{{name}}“.",
    confirm: "Продължи",
  },

  itemDiscounts: {
    title: "Отстъпки",
    subtitle: "Маса {{name}} · {{total}} €",
    emptyBill: "В тази сметка няма продукти.",
    generalTitle: "Обща отстъпка",
    generalHint: "Важи за избраните редове без собствена отстъпка",
    ownPercentCount_one: "{{count}} ред е със собствена отстъпка и не се променя",
    ownPercentCount_other: "{{count}} реда са със собствена отстъпка и не се променят",
    none: "Без",
    free: "Безплатно",
    selectAll: "Избери всички",
    discountedOfTotal: "{{discounted}} от {{total}} с отстъпка",
    removeAll: "Премахни всички",
    forThisRow: "За този ред",
    followGeneral: "Обща · {{percent}}%",
    ownSuffix: "ред",
    currentPercentTitle: "Сега: −{{percent}}%",
    discountLabel: "Отстъпка",
    customPriceHint: "променена цена",
    applySuccess: "Отстъпките са записани",
    // „На цялата сметка" — сума в € (BE `apply-amount-discount`)
    modeItems: "По продукти",
    modeBill: "На цялата сметка",
    billTitle: "Отстъпка на цялата сметка",
    billHint: "Сума в €, извадена от сметката · до {{max}} €",
    billRowsTotal: "Сметка",
    billToPay: "За плащане",
    billReceiptNote:
      "На касовия бон излиза като един ред „Отстъпка“ под междинната сума. Отстъпките по продукти остават.",
    billKeptNote: "Отстъпка на цялата сметка −{{amount}} € — вади се след тези",
    billApplySuccess: "Отстъпката на сметката е записана",
    billRemoveSuccess: "Отстъпката на сметката е премахната",
    billCloseOffline:
      "Сметката е с отстъпка на цялата сметка — закрива се, когато има интернет",
  },

  customPrice: {
    title: "Промяна на цена",
    subtitle: "Натиснете молива до продукт или добавка и въведете нова цена",
    emptyBill: "В тази сметка няма продукти.",
    changedCount: "Променени цени: {{count}}",
    invalidRows: "Невалидна цена на {{count}} реда — празно или 0.",
    restore: "Върни цената от менюто",
    applySuccess: "Цените са променени",
  },

  clients: {
    title: "Клиенти с отстъпки",
    total: "Общо: {{count}}",
    noClients: "Няма намерени клиенти",
    onAccountBadge: "По сметка",
    select: "Избери",
    searchPlaceholder: "Търси по име или карта...",
    // Кутийките под търсачката и обобщението във футъра (ClientsModal).
    filterAll: "Всички",
    filterDiscount: "С отстъпка",
    filterSurcharge: "С надбавка",
    summaryAfterDiscount: "Маса {{name}} след отстъпка",
    summaryAfterSurcharge: "Маса {{name}} след надбавка",
    summaryWithout: "Маса {{name}} без корекция",
    applyPercent: "Приложи {{percent}}",
    removeButton: "Премахни",
    applySuccess: "Отстъпката е приложена успешно",
    applySurchargeSuccess: "Надбавката е приложена успешно",
    removeDiscount: "Премахнете приложената отстъпка ({{discount}})",
    removeDiscountNamed: "Премахни отстъпка - {{name}} ({{discount}})",
    removeSurcharge: "Премахнете приложената надбавка ({{discount}})",
    removeSurchargeNamed: "Премахни надбавка - {{name}} ({{discount}})",
    removeSuccess: "Отстъпката е премахната успешно",
    removeSurchargeSuccess: "Надбавката е премахната успешно",
    active: "Активен",
    inactive: "Неактивен",
    from: "От",
    to: "До",
    monday: "Пон",
    tuesday: "Вто",
    wednesday: "Сря",
    thursday: "Чет",
    friday: "Пет",
    saturday: "Съб",
    sunday: "Нед",
    // Лентата „закачен клиент" (масите + модалът за закриване)
    bannerDiscountAssortments: "отстъпка {{percent}} на всички асортименти",
    bannerDiscountRecipes: "отстъпка {{percent}} на всички рецепти",
    bannerSurchargeAssortments: "надбавка {{percent}} на всички асортименти",
    bannerSurchargeRecipes: "надбавка {{percent}} на всички рецепти",
    // Част от редовете са с друг процент (отстъпка по ред / промяна на цена)
    bannerDiscountPartialAssortments:
      "отстъпка {{percent}} на {{count}} от {{total}} асортимента",
    bannerDiscountPartialRecipes:
      "отстъпка {{percent}} на {{count}} от {{total}} рецепти",
    bannerSurchargePartialAssortments:
      "надбавка {{percent}} на {{count}} от {{total}} асортимента",
    bannerSurchargePartialRecipes:
      "надбавка {{percent}} на {{count}} от {{total}} рецепти",
    bannerNoDiscount: "без отстъпка",
    bannerSaved: "Спестени",
    bannerSurcharged: "Надбавка",
  },

  reportType: {
    selectType: "Изберете вид отчет",
    personal: "Персонален отчет",
    establishment: "Отчет на заведението",
  },

  invoicing: {
    selectBillTitle: "Избор на сметка",
    selectBillSubtitle:
      "Нефактурираните закрити сметки, още извън личен отчет. Сметка от вече пуснат отчет се фактурира от „Справки → Справка сметки“. Избери една или няколко за да продължиш.",
    selectBillSubtitleWindow:
      "Нефактурирани затворени сметки от последните {{days}} дни. Избери една или няколко за да продължиш.",
    searchPlaceholder: "Търси по име на маса, сервитьор или плащане",
    selectAll: "Избери всички",
    selectRow: "Избери сметка",
    colId: "Час",
    colTable: "Маса",
    colWaiter: "Сервитьор",
    colPayment: "Плащане",
    colTotal: "Сума",
    confirm: "Избор",
    confirmWithCount: "Избор ({{count}})",
    selectedCount: "Избрани сметки: {{count}}",
    emptyAll: "Няма нефактурирани затворени сметки.",
    emptyFiltered: "Няма сметки, отговарящи на търсенето.",
    loadError: "Грешка при зареждане на сметките",
    needDefaultCompany: "Първо създайте текуща фирма в Конфигурации → Фирми.",
    warnAlreadyInvoiced: "Фактурата вече е издадена",
    warnOnlyClosed: "Само затворени сметки могат да се фактурират",
    warnCashNoReceipt:
      "Сметката е закрита в брой без касова бележка и не подлежи на фактуриране",
    warnWindowExpired: "Изтекъл срок за фактуриране ({{days}} дни)",
  },

  freeInvoice: {
    title: "Свободна фактура",
    subtitle: "Без сметка — редовете се въвеждат на ръка",
    paymentHint: "само „По сметка“",
    issue: "Издай фактура",
    issued: "Фактурата е издадена",
  },

  invoicesReport: {
    title: "Справка по фактури",
    listKicker: "Списък фактури",
    resultOne: "{{count}} фактура",
    results: "{{count}} фактури",
    searchPlaceholder: "Търси по № на фактура, получател, ЕИК или бон",
    kindInvoice: "Фактура",
    kindSimplified: "Опростена фактура",
    kindUnused: "Неизползван номер",
    kindFree: "Свободна фактура",
    creditNoteOf: "към № {{number}}",
    sourceFiscal: "ФУ",
    sourceSoftware: "Софтуерна",
    statusCredited: "Кредитирана",
    statusUnused: "Не е документ",
    creditedBy: "КИ № {{number}}",
    createdAt: "съставена {{moment}}",
    kpiInvoices: "Фактури",
    kpiInvoicesSub: "издадени, без анулираните",
    kpiGrandSub: "с ДДС · след кредитните известия",
    kpiCreditNotes: "Кредитни известия",
    kpiCreditNotesSub: "{{amount}} · извадени от сумите",
    kpiOutside: "Извън сумите",
    kpiCancelledPart: "{{count}} анулирани",
    kpiUnusedPart: "{{count}} неизползвани номера",
    clearFilters: "Изчисти филтри",
    cancelledOnly: "Само анулирани",
    empty: "Няма издадени фактури в избрания период.",
    view: "Виж",
    colNumber: "Фактура №",
    colDate: "Дата",
    colTime: "Час",
    colDateTime: "Дата и час",
    colSource: "Източник",
    colDevice: "ФУ",
    colReceipt: "Бон №",
    colCreditNoteOf: "Към фактура №",
    colCreditedBy: "Кредитно известие №",
    colType: "Тип",
    colCustomer: "Получател",
    colEik: "ЕИК",
    colTaxable: "Облагаема",
    colNonTaxable: "Необлагаема",
    colVatRate: "ДДС %",
    colVat: "ДДС",
    colGrand: "Общо",
    colView: "Действия",
    kpiCount: "Фактури",
    kpiTaxable: "Облагаема",
    kpiNonTaxable: "Необлагаема",
    kpiVat: "ДДС",
    kpiGrand: "Общо",
    cardRevenueTitle: "Общ оборот от фактури",
    cardRevenueCountLabel: "Брой",
    cardRevenueAvgLabel: "Среден размер",
    cardVatTitle: "Разбивка облагаема / ДДС / необлагаема",
    // Последният ред на Excel файла — като реда „Общо" на екрана, без анулираните
    excelTotal: "Общо (документи в сила)",
  },

  invoicePreview: {
    title: "Фактура № {{number}}",
    subtitle: "Издадена на {{date}}",
    recipient: "Получател",
    supplier: "Изпълнител",
    editCustomer: "Редакция на получател",
    editCustomerSubtitle:
      "Само данните на получателя — суми, редове, номер и дати не се променят.",
    editCustomerSuccess: "Получателят е обновен",
    editCustomerError: "Грешка при запис на получателя",
    titleOriginal: "ФАКТУРА ОРИГИНАЛ",
    titleDuplicate: "ФАКТУРА ДУБЛИКАТ",
    titleSimplified: "ОПРОСТЕНА ФАКТУРА",
    docNumber: "Номер",
    docDate: "Дата",
    supplyDate: "Дата на дан. събитие",
    supplyPlace: "Място на сделката",
    colDescription: "Вид стока / услуга",
    colVatRate: "ДДС %",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    colTotal: "Сума",
    totalWords: "Обща стойност словом",
    sumTotal: "Всичко сума",
    sumTaxable: "Дан. основа",
    sumNonTaxable: "Необлагаема сума",
    sumVat: "ДДС",
    sumGrand: "Обща стойност (EUR)",
    goodsReceived: "Стоката / услугата получена:",
    receivedAt: "На дата",
    receivedBy: "От",
    paymentMethod: "Начин на плащане",
    noteLabel: "Коментар",
    preparedBy: "Съставил",
    print: "Печат",
    printPos: "Печат (POS)",
    originalPrintedTitle: "Отпечата ли се оригиналът?",
    originalPrintedDescription: "Ако не — следващият печат от „Справки → Фактури“ пак ще е оригинал.",
    originalPrintedSaveError: "Печатът на оригинала не се записа — опитайте пак",
    printPosSuccess: "Фактурата е изпратена към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
    cancel: "Анулирай",
    cancelConfirmTitle: "Анулиране на фактура № {{number}}",
    cancelConfirmStays:
      "Фактурата остава в „Справка фактури“ със стикер „АНУЛИРАНА“, а номерът ѝ не се ползва повторно.",
    cancelConfirmBills_one: "Сметката по нея става нефактурирана — може да я фактурирате наново.",
    cancelConfirmBills_other:
      "Сметките по нея ({{count}}) стават нефактурирани — може да ги фактурирате наново.",
    cancelConfirmNoPrint: "Касовият бон не се пипа и нищо не се печата.",
    cancelConfirmFinal: "Анулирането не може да се отмени.",
    cancelConfirmContent: "Сигурни ли сте, че искате да анулирате фактурата?",
    cancelSuccess: "Фактурата е анулирана",
    cancelError: "Грешка при анулиране на фактурата",
    cancelledBadge: "АНУЛИРАНА",
  },

  invoiceCreate: {
    title: "Издаване на фактура",
    subtitle: "Документ върху {{count}} избрани сметки",
    secDocument: "Документ",
    secCustomer: "Клиент",
    secItems: "Артикули",
    fieldNumber: "Номер",
    numberHint: "автоматично +1 от последно издадена",
    fieldType: "Тип",
    typeTax: "Данъчна фактура",
    typeSimplified: "Опростена фактура",
    fieldIssueDate: "Дата на издаване",
    fieldSupplyDate: "Дата на сделката",
    fieldSupplyPlace: "Място на сделката",
    fieldPaymentMethod: "Начин на плащане",
    paymentFromBills: "от бона на сметката",
    optional: "по желание",
    fieldName: "Име на фирмата",
    fieldVat: "ДДС №",
    fieldCity: "Населено място",
    fieldAddress: "Адрес",
    fieldMol: "МОЛ",
    fieldPickCompany: "Търсене в издадените фактури",
    fieldPickCompanyPh: "Име или ЕИК от предишна фактура",
    fieldCustomerEik: "ЕИК №",
    phCustomerEik: "9 или 13 цифри",
    phCustomerCity: "Напр. София",
    phCustomerName: 'Напр. "Тест ООД"',
    phCustomerAddress: "Седалище и адрес на управление",
    phCustomerMol: "Имена на лицето",
    noCustomers: "Все още няма издадени фактури — попълнете данните по-долу",
    noCustomersForQuery: "Няма такава фирма в издадените фактури — попълнете данните по-долу",
    noDefaultCompany: "Все още няма зададена текуща фирма",
    lookupTitle: "Извлечи данни от Търговски регистър",
    lookupInvalidEik: "Първо въведете валиден ЕИК",
    lookupSuccess: "Данните са попълнени от Търговски регистър",
    lookupFailed: "Неуспешно извличане. Опитайте отново или въведете ръчно.",
    fieldReceivedBy: "Получил",
    fieldReceivedByPh: "Имена на лицето",
    fieldReceivedAt: "Дата на получаване",
    colName: "Наименование",
    colUnit: "Ед.",
    colVat: "ДДС %",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    // Полето в „Нов ред“ / „Промяна на ред“ — цената се въвежда С ДДС (колоната
    // в таблицата е нетната, `InvoiceLineRow`).
    unitPriceGross: "Ед. цена с ДДС",
    colVatAmount: "Сума на ДДС",
    colTotal: "Сума",
    colGross: "Сума с ДДС",
    noLines: "Няма артикули.",
    totalSum: "Всичко сума",
    totalTaxable: "Дан. основа",
    totalNonTaxable: "Необлагаема сума",
    totalVat: "ДДС",
    totalGrand: "Обща стойност",
    totalWords: "Обща стойност словом",
    note: "Забележка",
    actionEdit: "Промяна",
    actionDelete: "Изтриване",
    actionSummarize: "Обобщаване",
    actionAdd: "Нов ред",
    save: "Запис",
    editLineTitle: "Редакция на ред",
    editLineSubtitle:
      "Промяна на наименование, мярка, ДДС, количество и ед. цена. Сумата се изчислява автоматично.",
    newLineTitle: "Нов ред",
    newLineSubtitle:
      "Добавете артикул ръчно. Само наименованието е задължително.",
    addLine: "Добави",
    summarizeTitle: "Обобщаване на сметката",
    summarizeSubtitle:
      "Изберете как да бъдат показани артикулите в готовата фактура.",
    summarizePerItem: "По име и цена",
    summarizePerItemDesc:
      "Всеки артикул на отделен ред — както е поръчан от клиента.",
    summarizeSingle: "Всичко на един ред",
    summarizeSingleDesc:
      'Един ред "Консумация" с количество 1 и общата сума на сметката.',
    summarizeApply: "Приложи",
    summarizedName: "Консумация",
    deleteConfirmTitle: "Изтриване на ред",
    deleteConfirmDesc: 'Сигурни ли сте, че искате да изтриете "{{name}}"?',
    deleteConfirmOk: "Изтрий",
    mismatchOneBill: "сметката",
    mismatchManyBills: "сметките",
    mismatchTitle: "Тотала на фактурата е различен от сумата на {{context}}",
    mismatchBody: "Желаете ли да продължите със записа?",
    mismatchBillsTotal: "Сума на сметката(те)",
    mismatchInvoiceTotal: "Тотал на фактурата",
    errInvoiceNumber: "Въведете валиден номер на фактурата",
    errDates: "Изберете дати на издаване и сделката",
    errPaymentMethod: "Изберете начин на плащане",
    errCustomerEik: "Невалиден ЕИК на клиента",
    errCustomerVat: "ДДС № трябва да е във формат BG + 9 или 10 цифри",
    errCustomerFields: "Попълнете име на фирмата, населено място и адрес",
    errNoLines: "Добавете поне един артикул",
    saveSuccess: "Фактурата е записана успешно",
    saveError: "Грешка при запис на фактурата",
  },

  operations: {
    selectType: "Изберете вид операция",
    xReport: "X отчет (без нулиране)",
    zReport: "Z отчет (с нулиране)",
    // Отчет от фискалната памет за период — друг документ, не X с дати.
    fmReport: "Справка отчети за дата",
    fmReportDetail: "Вид на отчета",
    fmReportShort: "Съкратен",
    fmReportFull: "Подробен",
    fmReportShortHint: "Сумите за периода в един кратък отчет.",
    fmReportFullHint:
      "По един блок за всеки Z отчет в периода — за дълъг период това са метри хартия.",
    fmReportPeriod: "Период на отчета",
    fmPresetLastMonth: "Предходен месец",
    fmPresetThisMonth: "Този месец",
    fmPresetPeriod: "Период",
    fmPresetLastMonthHint:
      "От {{from}} до {{to}}. Месечният отчет се пуска до {{deadlineDay}}-о число на следващия месец.",
    fmPresetThisMonthHint: "От {{from}} до днес ({{to}}).",
    fmPeriodFrom: "От",
    fmPeriodTo: "До",
    fmPeriodLongSpanHint:
      "Без ограничение. Подробен отчет над {{days}} дни иска потвърждение преди печат.",
    // Дълъг подробен отчет — въпрос към оператора, не забрана.
    fmLongPeriodTitle: "Дълъг подробен отчет",
    fmLongPeriodMessage:
      "Избраният период е {{days}} дни. Подробният отчет печата по един блок за всеки Z отчет в него — това са метри хартия и няколко минути печат.",
    fmLongPeriodQuestion:
      "Да отпечатаме ли въпреки това? Ако ви трябват само сумите за периода, изберете „Съкратен“.",
    fmLongPeriodConfirm: "Печатай",
    fmReportPeriodRequired: "Изберете период",
    fmReportInvalidPeriod: "Крайната дата е преди началната",
    fmReportFuturePeriod: "Периодът е в бъдещето",
    fmReportSuccess: "Отчетът за периода е отпечатан",
    xReportSuccess: "X отчетът е отпечатан",
    zReportSuccess: "Z отчетът е отпечатан",
    cashIn: "Служебно въвеждане",
    cashOut: "Служебно извеждане",
    enterAmount: "Въведете сума",
    amountRequired: "Моля, въведете сума по-голяма от 0",
    cashInSuccess: "Служебното въвеждане е успешно",
    cashOutSuccess: "Служебното извеждане е успешно",
    error: "Грешка при изпълнение на операцията",
  },

  generateReport: {
    title: "Генериране на отчет",
    establishmentTitle: "Генериране на отчет на заведението",
    selectUser: "Изберете потребител:",
    selectUserWarning: "Моля, изберете потребител",
    reportDate: "Дата на отчет:",
    selectDate: "Изберете дата",
    previewReport: "Преглед на отчет",
    // В режим „със склад" продаваемото е рецепта → същият чекбокс, друго име.
    showSoldAssortments: "Покажи продадените асортименти",
    showSoldRecipes: "Покажи продадените рецепти",
    loadUsersError: "Грешка при зареждане на потребителите",
    previewError: "Грешка при преглед на отчета",
    establishmentPreviewError: "Грешка при преглед на отчета на заведението",
    reportCreated: "Отчетът е създаден успешно",
    establishmentReportCreated: "Отчетът на заведението е създаден успешно",
    generateError: "Грешка при генериране на отчета",
    establishmentGenerateError:
      "Грешка при генериране на отчета на заведението",
    resetReport: "Нулиране на отчета",
    resetFromReport: "Нулиране от отчета?",
    confirmAgain: "Потвърдете още веднъж?",
    resetButton: "Нулирай",
    noUsersAvailable: "Няма потребители с неотчетени сметки",
    resetConfirmDescription:
      "Тази операция ще нулира всички неотчетени сметки и ще генерира нов отчет. Действието не може да бъде отменено.",
    resetConfirmEstablishmentDescription:
      "Тази операция ще генерира отчет на заведението от всички персонални отчети за избраната дата. Действието не може да бъде отменено.",
    resetConfirmEstablishmentWithPersonalDescription:
      "Тази операция ще генерира всички персонални отчети и отчет на заведението за избраната дата. Действието не може да бъде отменено.",
    unreportedUsersTitle: "Има неприключени отчети на тези сервитьори:",
    unreportedUsersTitleSingle: "Има неприключен отчет на този сервитьор:",
    zReportConfirmTitle: "Нулиране на дневен финансов отчет",
    zReportConfirmDescription:
      "Нулиране на дневния финансов отчет (Z-отчет)? Тази операция изпраща Z-отчет към фискалното устройство.",
    printPosConfirmTitle: "Печат на отчет",
    printPosConfirmDescription: "Печат на отчет през POS принтер?",
  },

  personalReport: {
    title: "Персонален отчет № {{number}} / {{date}} г.",
    testRestaurant: "Тестов Ресторант",
    turnoverByPayment: "Обороти по видове плащания",
    paymentType: "Вид плащане",
    bills: "Сметки",
    alone: "Сам",
    inBrigade: "В бригада",
    cashPayment: "В брой",
    cardPayment: "Карта",
    cancelledByStation: "Сторнирани асортименти по станции",
    bar: "Бар",
    qty: "Кол.",
    firstLastOrder: "Първа / последна поръчка",
    cashDescription: "Опис на парите в брой",
    coins: "центове",
    firstLastBill: "Първа / последна сметка",
    amountToReport: "Сума за отчитане:",
    accepted: "Приел:",
    created: "Създал:",
    dateLabel: "Дата:",
    printPos: "Принтирай (POS)",
    printPosSuccess: "Отчетът е изпратен към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
  },

  establishmentReport: {
    title: "Отчет на заведението № {{number}} / {{date}} г.",
    includedPersonalReports: "Включени персонални отчети: {{count}}",
    turnoverByPayment: "Обороти по видове плащания",
    paymentType: "Вид плащане",
    bills: "Сметки",
    amount: "Сума",
    cashPayment: "В брой",
    cardPayment: "Карта",
    otherPayment: "Друго",
    firstLastOrder: "Първа / последна поръчка",
    firstLastBill: "Първа / последна сметка",
    stationBreakdown: "Разбивка по станции",
    station: "Станция",
    totalBills: "Общо сметки",
    totalAmount: "Обща сума",
    userBreakdown: "Разбивка по потребители",
    user: "Потребител",
    reports: "Отчети",
    cancelledByStation: "Анулирани продукти по станции",
    totalForStation: "Общо за {{name}}",
    // В режим „със склад" продаваемото е рецепта → същата секция, друго име.
    soldAssortments: "Продадени асортименти",
    soldRecipes: "Продадени рецепти",
    assortment: "Асортимент",
    recipe: "Рецепта",
    printPos: "Принтирай (POS)",
    printPosSuccess: "Отчетът е изпратен към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
    resetWillFinalizePersonalReports:
      "Нулирането на <b>Отчета на заведението</b> ще приключи всички <b>Персонални отчети</b> за деня",
  },

  // „Депозити" (Маркиране → Опции, ordering/components/tables/deposits/)
  depositLoad: {
    title: "Зареждане с депозит",
    // Заглавието, след като депозитът е записан (номерът е id-то му)
    titleSaved: "Депозит № {{id}}",
    name: "Име",
    namePlaceholder: "Име на госта или събитието",
    amount: "Сума",
    description: "Описание",
    descriptionPlaceholder: "Повод, брой гости, телефон…",
    validUntil: "За дата",
    validUntilPlaceholder: "Без срок",
    validUntilHint: "След тази дата депозитът става невалиден. Празно — без срок.",
    invoice: "Фактуриране",
    invoiceHint: "След касовия бон се отваря фактура за депозита — без нов бон",
    save: "Запиши депозит",
    saveError: "Депозитът не е записан",
    // Касовият бон на депозита (deposits/useDepositSave.ts)
    savedWithReceipt: "Депозит № {{id}} „{{name}}“ ({{amount}} EUR) е записан, касовият бон е издаден",
    savedWithoutReceipt:
      "Депозит № {{id}} „{{name}}“ ({{amount}} EUR) е записан — без касов бон (методът не се фискализира)",
    receiptUnknown: "Депозит № {{id}} „{{name}}“ е записан, но принтерът не потвърди касовия бон",
    receiptFailed: "Депозит № {{id}} „{{name}}“ е записан, но касовият бон не излезе: {{error}}",
    noAnswer: "Сървърът не отговори — депозитът може вече да е записан. Натиснете „Провери депозита“.",
    checkDeposit: "Провери депозита",
    checkReceipt: "Провери бона",
    issueAgain: "Издай бона наново",
    finishReceipt: "Довърши бона",
    noticeNoAnswer:
      "Сървърът не отговори — депозитът и касовият бон може вече да са записани. „Провери депозита“ пита за същия запис и не прави втори депозит или бон.",
    noticeUnknown:
      "Депозитът е записан, но принтерът не потвърди касовия бон. Погледнете лентата и натиснете „Провери бона“ — повторът не печата втори бон.",
    noticeFailed:
      "Депозитът е записан, но касовият бон не излезе ({{error}}). „Издай бона наново“ опитва пак; бонът може да се издаде и по-късно — от „Депозит“ → „Използвай депозит“ или от „Справка депозити“.",
    noticeCardCharged:
      "Картата е изтеглена, но касовият бон не излезе ({{error}}). НЕ теглете картата повторно — „Довърши бона“ издава бона без ново теглене.",
    hintWithoutReceipt: "Този начин на плащане не се фискализира — депозитът се записва без касов бон.",
    hintCard: "С карта: първо терминалът тегли сумата, после излиза касовият бон.",
    closedWithoutReceipt:
      "Депозитът е записан без касов бон — дотогава не плаща сметка. Бонът се издава с „Издай бон“ в „Депозит“ → „Използвай депозит“ или в „Справка депозити“.",
    closeConfirmTitle: "Затваряне без потвърждение?",
    closeConfirmBody:
      "Сървърът не потвърди записа — депозитът може вече да е записан, а бонът — на хартия. Затворите ли, ново въвеждане ще е нов депозит. Първо натиснете „Провери депозита“ или проверете в „Справка депозити“.",
    closeConfirmOk: "Затвори",
    closeConfirmStay: "Назад",
    errName: "Въведете име",
    errAmount: "Въведете сума над 0",
    errMethod: "Изберете начин на плащане",
  },

  // „Депозит" в „Опции" (tables/deposits/useDepositAction.tsx): „Създай нов
  // депозит" / „Използвай депозит" (закача депозит към отворената маса), лентата
  // в масата
  // „Фактуриране“ — изборът „Текуща сметка“ / „Закрита сметка“
  // (ordering/components/tables/invoicing/InvoicingChoiceModal.tsx)
  invoicingChoice: {
    title: "Фактуриране",
    subtitle: "Фактура за текущата маса, за вече закрита сметка или свободна",
    subtitleSoftware: "Фактура за вече закрита сметка или свободна, без сметка",
    currentKicker: "Фискална фактура при закриване",
    currentKickerTable: "Маса {{table}} · фискална фактура",
    current: "Текуща сметка",
    currentHint: "{{amount}} EUR — въвеждате купувача и закривате; фактурата излиза от фискалното устройство.",
    currentHintPrinter: "{{amount}} EUR — въвеждате купувача и закривате; фактурата излиза от „{{printer}}“.",
    currentHintNoTable: "Фактура за избраната маса — излиза от фискалното устройство при закриването ѝ.",
    closedKicker: "Софтуерна фактура · A4 или ПОС",
    closed: "Закрита сметка",
    closedHint: "Една или повече закрити сметки — редовете и плащането са от тях.",
    freeKicker: "Софтуерна фактура · без сметка",
    free: "Свободна фактура",
    freeHint:
      "Въвеждате редовете на ръка; само „По сметка“ (банков път), без касов бон. В брой или с карта — фактура към сметката; аванс — от „Депозити“.",
    unavailable: {
      noBill: "Изберете отворена маса",
      billClosed: "Масата е закрита",
      closing: "Масата се закрива в момента",
      zeroBill: "Сметката е 0.00 — няма за какво да се издаде фактура",
      billDiscount:
        "Сметката е с отстъпка на цялата сметка — фискална фактура за нея не се издава. Махнете отстъпката („Отстъпки“ → „На цялата сметка“) или закрийте сметката без фактура.",
    },
  },
  depositAction: {
    title: "Депозит",
    subtitle: "Капаро или аванс, платен предварително",
    load: "Създай нов депозит",
    loadKicker: "Гостът плаща сега",
    loadHint: "Взимате капаро/аванс и издавате касов бон. По-късно депозитът се приспада от сметка.",
    use: "Използвай депозит",
    useKicker: "Вече платен депозит",
    useHint: "Изберете депозит — сумата му се приспада от сметката на маса {{table}} при „Закрий“.",
    useHintNoTable: "Сумата му се приспада от сметката на избраната маса при „Закрий“.",
    useKickerAttached: "Закачен към маса {{table}}",
    useAttached: "Смени или махни депозита",
    useHintAttached: "{{deposit}} · {{amount}} EUR",
    useTitle: "Използвай депозит — маса {{table}}",
    unavailable: {
      noBill: "Изберете отворена маса",
      billClosed: "Масата е закрита",
      zeroBill: "Сметката е 0.00 — няма какво да се приспадне",
      closing: "Масата се закрива в момента",
    },
    attachedElsewhere: "Закачен към маса {{table}}",
    attached: "Депозит № {{id}} „{{name}}“ е закачен към маса {{table}} — приспада се при „Закрий“",
    attachError: "Депозитът не е закачен",
    remove: "Махни депозита",
    removed: "Депозит № {{id}} е махнат от маса {{table}} — пак е свободен",
    removeError: "Депозитът не е махнат",
  },

  // „Издай бон" за депозит без бон — изборът в „Използвай депозит" и „Справка депозити"
  // (hooks/useIssueDepositReceiptAction.tsx)
  depositReceipt: {
    issue: "Издай бон",
    issued: "Касовият бон за депозит № {{id}} „{{name}}“ е издаден (бон № {{number}})",
    notRequired: "Депозит № {{id}} „{{name}}“ е без касов бон — методът не се фискализира",
    unknown:
      "Депозит № {{id}} „{{name}}“ — принтерът не потвърди касовия бон: {{error}}. Погледнете лентата, преди да опитате отново.",
    failed: "Депозит № {{id}} „{{name}}“ — касовият бон не излезе: {{error}}",
    cardCharged:
      "Депозит № {{id}} „{{name}}“ — картата е изтеглена, но касовият бон не излезе: {{error}}. Не теглете картата повторно — „Издай бон“ довършва бона.",
    failedGeneric: "Касовият бон за депозита не е издаден",
    noAnswer:
      "Депозит № {{id}} „{{name}}“ — сървърът не отговори, касовият бон може вече да е излязъл. Погледнете лентата, преди да опитате отново.",
    noDetails: "без подробности",
    confirmUnknownTitle: "Касовият бон може вече да е излязъл",
    confirmUnknownBody:
      "Последният опит за бона на този депозит е без потвърден изход. Погледнете лентата: ако бон има, не издавайте втори. На същата каса повторът пита апарата за същия бон и не печата втори.",
    notReadyHint: "Първо издайте бона на депозита",
    notReadyCardCharged: "Картата е изтеглена, бонът не е — първо издайте бона (без ново теглене)",
  },

  // „Анулирай" депозит в „Справка депозити" (deposits/useCancelDepositAction.tsx)
  depositCancel: {
    action: "Анулирай",
    title: "Анулиране на депозит № {{id}}",
    summary: "{{name}} · {{amount}} — депозитът изчезва от „Използвай депозит“ и вече не плаща сметка.",
    receiptStays:
      "Бон 1 № {{number}} остава в касовия апарат — автоматично сторно няма. Върнете парите със сторно на този бон: от портала на касата („Сторно“) или от самия апарат.",
    receiptStaysNoNumber:
      "Касовият бон на депозита остава в апарата — автоматично сторно няма. Върнете парите със сторно от апарата.",
    noReceipt: "Касов бон за депозита няма — върнете парите без сторно.",
    receiptMaybe:
      "Ако при фактурирането на депозита е излязъл касов бон, той остава в апарата — върнете парите със сторно от апарата.",
    invoiceToo: "Фактура № {{number}} за депозита се анулира заедно с него.",
    reasonLabel: "Причина (задължително)",
    reasonPlaceholder: "Напр. грешна сума, двоен депозит, отменено събитие",
    confirm: "Анулирай",
    done: "Депозит № {{id}} е анулиран",
    doneStorno:
      "Депозит № {{id}} е анулиран. Не забравяйте сторното на Бон 1 № {{number}} — парите се връщат с него.",
    failed: "Депозитът не е анулиран",
    blockedAttached: "Закачен към маса — първо махнете депозита от масата",
    blockedReceipt: "Бонът на депозита е без потвърден изход — първо „Издай бон“",
  },

  // Въпросът преди необратимо действие: какво точно ще стане (components/ConfirmConsequences.tsx)
  confirmConsequences: {
    intro: "Какво ще стане:",
  },

  // „Сторнирай всичко“ / „Възстанови“ в „История на операциите“
  // (billOperations/billActionConsequences.ts — огледало на BE)
  billActionConfirm: {
    stornoTitle: "Сторниране на цялата сметка „{{name}}“",
    stornoClosed: "Всички продукти се сторнират — сметката остава закрита, сумата ѝ става 0.00.",
    stornoOpen: "Всички продукти се сторнират — масата остава отворена, сумата ѝ става 0.00.",
    stornoReceipt: "Касовият апарат издава сторно бон за целия бон № {{receipt}}, плащане „В брой“.",
    creditNote:
      "Касовият апарат издава кредитно известие към фискална фактура № {{number}} за цялата сметка, плащане „В брой“.",
    noReceipt: "Сметката няма касов бон — нищо не се печата.",
    noReceiptOpen: "Нищо не се печата — масата още няма касов бон.",
    cardRefundRrn:
      "Платена е с карта (RRN {{rrn}}): върнете парите на госта в брой от касата, не през терминала.",
    cardRefund: "Платена е с карта: върнете парите на госта в брой от касата, не през терминала.",
    stornoInvoice: "Фактура № {{number}} се анулира — ако е и за други сметки, и те стават нефактурирани.",
    depositReleased:
      "Депозитът ({{amount}}) не се връща със сторното — освобождава се и пак може да плати сметка.",
    tipVoided: "Бакшишът ({{amount}}) също се анулира.",
    stornoFinal: "Сторното не може да се отмени.",
    stornoQuestion: "Сигурни ли сте, че искате да сторнирате цялата сметка?",
    stornoOk: "Сторнирай всичко",
    restoreTitle: "Възстановяване на сметка „{{name}}“",
    restoreReopens:
      "Сметката се отваря наново в „Маркиране“ със същите продукти — после я закривате пак с правилното плащане.",
    restoreInvoice: "Фактура № {{number}} се анулира — след новото закриване може да издадете нова.",
    depositKept: "Депозитът ({{amount}}) остава закачен към сметката и се приспада пак при закриването.",
    tipRemoved: "Бакшишът ({{amount}}) се маха — въвежда се наново при закриването.",
    restoreReports: "Сметката излиза от отчетите, в които е влязла (те се преизчисляват).",
    restoreQuestion: "Сигурни ли сте, че искате да възстановите сметката?",
    restoreOk: "Възстанови",
  },

  // Фактура за депозит (invoicing/InvoiceCreateModal.tsx с `deposit`)
  depositInvoice: {
    subtitle: "Към касовия бон на депозит № {{id}}",
    notice: "Фактура към вече издадения касов бон на депозита — нов касов бон не излиза.",
    errTotal: "Общата стойност на фактурата за депозит трябва да е сумата на депозита — {{amount}} EUR",
    lockedDeduction:
      "Платеното с депозит е приспаднато на отделен ред — авансът е с отделен касов бон; редът не се променя и не се трие.",
  },

  // Фискална фактура при закриване — разширеният фискален бон с номер от
  // ОБЩАТА поредица на обекта (lib/fiscalInvoice.ts, docs/invoicing.md)
  fiscalInvoice: {
    // „Конфигурация → Фирми“ (companies/InvoiceIssuingSection.tsx, InvoiceDevicePin.tsx)
    company: {
      section: "Къде се издават фактурите",
      modes: {
        software: {
          title: "Софтуерно (A4 / ПОС принтер)",
          hint: "Както досега — от „Фактуриране“, на A4 или на ПОС принтера.",
        },
        fiscal: {
          title: "Фискално устройство",
          hint: "Само фискални — бон-фактура при закриване на сметката. Няма фактура за вече закрита сметка (само през „Възстанови“), при плащане през картовия терминал и за аванс (депозит). За FP-2000 „И двете“ дава същите фискални фактури и софтуерни след бона.",
        },
        both: {
          title: "И двете (обща поредица)",
          hint: "Фискални и софтуерни фактури — в една поредица.",
        },
      },
      devices:
        "Номерата дава облакът — една поредица, без дупки. Datecs FP-2000 (и FP-800, FP-650, FP-700, FMP-10, SK1-21F, SK1-31F) — и трите режима; FP-700X и останалите от X/MX серията — само „Фискално устройство“. DP-2015, Tremol и Eltrade — без фискална фактура.",
      // „Последен номер на фактура“ на общата поредица (NumberingSection.tsx)
      numberBySeries:
        "Номерата дава облакът. Тук номерът само се вдига — когато фискалното устройство вече е издало фактури до по-голям номер.",
      numberLockedByDevice:
        "Закрепеното устройство държи следващия номер — за да го смените, първо „Освободи устройството“ в „Къде се издават фактурите“.",
      numberOnlyUp: "Само нагоре — поредицата е на {{number}}.",
      // Потвърждението при вдигане на брояча (CompanyModal → „Запази“)
      skipTitle: "Прескачане на номера на фактури",
      skipOne:
        "Номер {{number}} ще се води издаден — той трябва вече да е издаден от фискалното устройство. Облакът няма да го дава. Продължавате ли?",
      skipMany:
        "Ще прескочите {{count}} номера ({{from}}–{{to}}) — те трябва вече да са издадени от фискалното устройство. Облакът няма да ги дава, а броячът не се връща назад. Продължавате ли?",
      skipOk: "Запази",
      // Закаченото устройство на фактурите (апарат от X/MX серията)
      device: {
        title: "Устройство на фактурите",
        label: "ФУ {{serial}} („{{name}}“)",
        labelNoSerial: "„{{name}}“",
        hintFiscal:
          "Фактурите на фирмата се издават само от него — апарат от X/MX серията държи поредицата сам.",
        hintOtherMode: "Има значение само във „Фискално устройство“.",
        release: "Освободи устройството",
        confirm:
          "Освободете го само при смяна на апарата. След записа следващата фискална фактура закача апарата, който я издаде. Не издавайте повече фактури от стария — той пази един номер от поредицата.",
        confirmOk: "Освободи",
        released: "Ще бъде освободено при „Запази“.",
        undo: "Отмени",
      },
    },
    // Фирмата е във „Фискално устройство“ — софтуерна фактура няма (текстът е
    // този на отказа на BE): „Фактуриране“, „Нов депозит“, „Справки“
    mode: {
      softwareOff:
        "Фирмата издава фактури само от фискалното устройство („Фирми“ → „Къде се издават фактурите“).",
      // „Закрита сметка“ във „Фискално устройство“: пътят, който съществува.
      closedBillInFiscal:
        "Фирмата издава фактури само от фискалното устройство. Фактура за вече закрита сметка: „Възстанови“ я и я закрийте наново от „Фактуриране → Текуща сметка“ с купувача.",
      selectSubtitle:
        "Фактурите се издават от фискалното устройство при закриване на сметката.",
    },
    // Издаване на софтуерна фактура при включена обща поредица
    software: {
      numberAuto: "ще се даде автоматично",
    },
    // „Фактуриране“ → „Текуща сметка“ — наличността на апарата (invoicing/useInvoicingFlow.tsx)
    picker: {
      unavailable: "Фискална фактура при закриване не е възможна.",
      loading: "Проверява се дали фискалното устройство може да издаде фактура…",
      loadError:
        "Не можа да се провери дали фискалното устройство може да издаде фактура. Затворете и отворете „Фактуриране“ отново.",
    },
    // Купувачът (invoicing/FiscalInvoiceBuyerModal.tsx)
    buyer: {
      title: "Фискална фактура · маса {{table}}",
      subtitle: "Сума {{amount}} EUR — въведете купувача, после изберете плащане",
      numberNext:
        "Номерът се дава от фискалното устройство при закриването — следващият е № {{number}}.",
      numberFromDevice: "Номерът се дава от фискалното устройство при закриването.",
      toPayment: "Към плащане",
      // Касата кара картов терминал (`card_terminal` на fiscal-availability) —
      // „С карта“ и „Смесено“ ги няма в „Закрий“; тук и в лентата на „Закрий“.
      cardTerminal: "С карта през терминала фискална фактура още не се издава — плащането е само в брой.",
      // Същото, когато фирмата издава и софтуерни фактури („И двете“) — пътят за карта.
      cardTerminalSoftware:
        "С карта през терминала фискална фактура още не се издава — плащането е само в брой. Гостът плаща с карта? Закрийте без фактура и издайте софтуерна фактура към бона („Фактуриране“ → „Закрита сметка“).",
    },
    // „Закрий“ с фискална фактура (payment/FiscalInvoiceBuyerStrip.tsx,
    // payment/backgroundBillClose.ts)
    close: {
      buyer: "Фактура за {{name}}",
      eik: "ЕИК {{eik}}",
      vat: "ДДС № {{vat}}",
      numberFromDevice: "Фактура № ще се даде от апарата",
      success: "Маса {{table}} — фактура № {{invoice}} · бон № {{receipt}}",
      successNoReceipt: "Маса {{table}} — фактура № {{invoice}}",
      recordFailed:
        "Фактурата е издадена от фискалното устройство, но не е записана в облака — вижте „Фискални проблеми“.",
    },
    // Справка „Фактури“ (reports/components/invoices/)
    report: {
      typeCreditNote: "Кредитно известие",
    },
    // Прегледът (invoicing/FiscalInvoicePreviewNotice.tsx)
    preview: {
      titleCreditNote: "КРЕДИТНО ИЗВЕСТИЕ",
      fiscalInvoice:
        "Фискална фактура — оригиналът е бонът от фискалното устройство. Тук не се печата и получателят не се редактира. Не се анулира — кредитира се с кредитно известие за цялата сметка („Кредитно известие“ в „Справки → Фактури“).",
      creditNote:
        "Кредитно известие към фактура № {{number}}, издадено от фискалното устройство — оригиналът е бонът. Тук не се печата и не се анулира.",
      deviceSerial: "ФУ {{serial}}",
      receipt: "ФБ № {{receipt}}",
    },
    // Сторно на сметка с фискална фактура (Справки → „История на операциите“,
    // „Възстановяване“)
    storno: {
      action: "Кредитно известие",
      confirmTitle: "Кредитно известие към фактура № {{number}}",
      restoreContent:
        "Сметката е с фискална фактура № {{number}}: възстановяването издава кредитно известие към нея за цялата сметка и отваря сметката наново.",
      changePaymentNote:
        "„Смяна на начин на плащане“ я закрива наново с обикновен бон — нова фискална фактура се издава от „Фактуриране“.",
      issued: "Кредитно известие № {{number}} · бон № {{receipt}}",
      issuedNoReceipt: "Кредитно известие № {{number}}",
      recordFailed:
        "Кредитното известие е издадено от фискалното устройство, но не е записано в облака — вижте „Фискални проблеми“.",
    },
    // „Кредитно известие“ в прегледа на фискална фактура (Справки → „Фактури“,
    // invoicing/FiscalInvoiceCreditAction.tsx) — изборът между двата пътя.
    credit: {
      subtitle:
        "Фискалната фактура не се анулира — кредитира се. Известието излиза от фискалното устройство за цялата сметка, парите се връщат в брой.",
      reissueKicker: "Сгрешен купувач или данни",
      reissue: "Нова фактура",
      reissueHint:
        "Сметката се отваря наново („Възстанови“) — закривате я с фактура към правилния купувач.",
      refundKicker: "Продажбата се отменя",
      refund: "Връщане на парите",
      refundHint: "Цялата сметка се сторнира („Сторнирай всичко“) и излиза от оборота.",
      loading: "Зарежда се сметката…",
      billMissing: "Сметката на фактурата не е намерена.",
      otherInvoice: "Сметката вече е с друга фактура № {{number}}.",
      notClosed: "Сметката не е закрита — вече е отворена наново.",
      alreadyReversed: "Сметката вече е сторнирана.",
      noStornoPermission: "Нямате право „История на маси“.",
    },
    // „Фискални проблеми“ (monitoring/fiscalIssues/FiscalInvoiceIssuesCard.tsx)
    issues: {
      title: "Документи от ФУ без запис във „Фактури“",
      subtitle:
        "Фискалната фактура или кредитното известие е на хартия, но не е записано в облака. Не се издава наново — проверете бона и се свържете с поддръжка.",
      colDocument: "Документ",
      colNumber: "Фактура №",
      colBill: "Сметка",
      colWhen: "Кога",
      colReason: "Причина",
      kindInvoice: "Фискална фактура",
      kindCreditNote: "Кредитно известие",
      // Ред с бон, чието повторение печата фискална фактура
      retryHeld: "Фискална фактура № {{number}}",
      retryNew: "Фискална фактура — с нов номер",
    },
  },

  // Секцията „Депозити" в дневните отчети (reports/ReportDepositsSection.tsx)
  reportDeposits: {
    section: "Депозити",
    colMethod: "Вид",
    colCount: "Брой",
    colAmount: "Сума",
    taken: "Депозит — {{method}}",
    total: "Общо депозити",
    cashInAmountToReport: "Депозити в брой (в „Сума за отчитане“)",
    paidWithDeposit: "Платено с депозит (усвоено)",
  },

  // Бакшишът в дневните отчети (хартията, списъците, Excel) — числата са
  // полетата от BE, FE не смята „За отчитане" (docs/reports.md §Бакшиш).
  reportTips: {
    section: "Бакшиш",
    colKind: "Вид",
    colAmount: "Сума",
    // Картата: сумата, после „дял за разходи" и „дял за персонала" (думите
    // от настройките); етикетите на BE хартията — същите. Бакшиш в брой няма.
    card: "Бакшиш с карта",
    cardExpense: "Бакшиш с карта — дял за разходи",
    cardDeducted: "Бакшиш с карта — дял за персонала (приспада се)",
    cardSeparate: "Бакшиш с карта — дял за персонала (отделно)",
    other: "Бакшиш — {{method}}",
    otherShort: "Бакшиш — друго",
    // Остатъкът без разпознаваем метод — етикетът на BE хартията дума по дума.
    otherUnlisted: "Бакшиш — друг метод",
    total: "Общо бакшиш",
    amountToReport: "За отчитане",
    staffTopUp: "Доплащане към персонала",
    totalPaid: "Общо платено с бакшиш",
    cardPaid: "С карта общо (за сверка с терминала)",
    methodPaid: "{{method}} общо (за сверка)",
    formulaHint: "в брой − дял за персонала от бакшиша с карта",
    shareExpense: "дял за разходи {{amount}}",
    shareStaffDeducted: "дял за персонала (приспада се) {{amount}}",
    shareStaffSeparate: "дял за персонала (отделно) {{amount}}",
    subCard: "с карта {{amount}}",
    subOther: "друго {{amount}}",
  },

  // Бакшишът на сметка в „Справка сметки" и „История на операциите".
  billTips: {
    column: "Бакшиш",
    method: "Метод на бакшиша",
    line: "Бакшиш {{amount}} · {{method}}",
    includesTip: "вкл. бакшиш {{amount}}",
  },

  // Редът за бакшиш във фактурата (издаване, A4 преглед, справка „Фактури").
  invoiceTips: {
    vatNote: "ДДС не се начислява — доброволен бакшиш.",
    totalTip: "Бакшиш (без ДДС)",
    locked:
      "Бакшишът е записан при закриването на сметката и не може да се променя или изтрива.",
    summarizeKeepsTip: "Бакшишът остава на отделен ред — не се слива с продуктите.",
    pickerIncludesTip: "вкл. бакшиш {{amount}}",
    reportColumn: "Бакшиш (без ДДС)",
  },

  reports: {
    billsHistory: "Справка сметки",
    splitBills: "Разделени маси",
    cancellations: "Сторно",
    personalReports: "Персонални отчети",
    establishmentReports: "Отчети на заведението",
  },

  billsHistory: {
    title: "История на маси",
    table: "Маса",
    statusCol: "Статус",
    open: "Отворена",
    closed: "Затворена",
    openedAt: "Отворена",
    closedAt: "Затворена",
    duration: "Продължителност",
    hours: "ч",
    minutes: "мин",
    orders: "Поръчки",
    cancelledItems: "Сторнирани",
    cancelledLabel: "Сторно: {{count}}",
    payment: "Плащане",
    cashLabel: "Брой: {{amount}}",
    cardLabel: "Карта: {{amount}}",
    tables: "Маси",
    totalAmount: "Обща сума",
    statusFilter: "Статус",
    openFilter: "Отворени",
    closedFilter: "Затворени",
    waiterFilter: "Сервитьор",
    paymentMethodFilter: "Метод на плащане",
    fromDate: "От дата",
    toDate: "До дата",
    noData: "Няма данни за маси",
  },

  billsSplits: {
    title: "Разделени маси",
    dateCol: "Дата",
    fromTable: "От маса",
    toTable: "Към маса",
    products: "Продукти",
    totalSplits: "Общо разделяния",
    transferredProducts: "Прехвърлени продукти",
    fromTableFilter: "От маса (ID)",
    toTableFilter: "Към маса (ID)",
    noData: "Няма данни за разделени маси",
  },

  cancellationsReport: {
    title: "Справка за сторнирани продукти",
    bill: "Сметка",
    product: "Продукт",
    qtyCol: "Кол-во",
    unitPrice: "Цена (единична)",
    reason: "Причина",
    statusCol: "Статус",
    defective: "✓ Брак",
    cancelled: "Сторно",
    totalCancelled: "Общо сторнирани",
    defectiveItems: "Бракувани артикули",
    billIdFilter: "ID на сметка",
    selectUsers: "Избери потребители",
    defectiveOnly: "Само бракувани продукти",
    noData: "Няма сторнирани продукти",
  },

  personalReportsPage: {
    title: "Персонални отчети",
    allUsers: "Всички потребители",
    userCol: "Потребител",
    billsCol: "Сметки",
    cashCol: "В брой",
    cardCol: "Карта",
    totalCol: "Обща сума",
    noData: "Няма намерени отчети",
  },

  establishmentReportsPage: {
    title: "Отчети на заведението",
    personalReportsCol: "Персонални отчети",
    billsCol: "Сметки",
    cashCol: "В брой",
    cardCol: "Карта",
    totalCol: "Обща сума",
    noData: "Няма намерени отчети",
  },

  billDetails: {
    tableTitle: "Маса {{name}}",
    openedAt: "Отворена:",
    closedAt: "Затворена:",
    noOrders: "Няма поръчки",
    fromTable: "от маса {{name}}",
    split: "Разделена",
    commentLabel: "Коментар:",
    totalOrders: "Общо поръчки: {{orders}} | Продукти: {{items}}",
    cancelledCount: "Сторно: {{count}}",
  },

  configuration: {
    title: "Конфигурация",
    monitors: "Монитори",
    devices: "Устройства",
  },

  // Общото странично меню на модулите със страници по право (Конфигурация, Резервации)
  moduleSidebar: {
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    collapse: "Свий",
    backToModules: "Към модулите",
  },

  configSidebar: {
    monitors: "Монитори",
    devices: "Устройства",
    ordering: "Маркиране",
    paymentMethods: "Видове плащания",
    companies: "Фирми",
    workingHours: "Работно време",
    configurationLabel: "Модул Конфигурация",
    sectionMain: "Настройки",
  },

  workingHours: {
    sectionKicker: "Седмица",
    sectionTitle: "Работно време по дни",
    days: {
      monday: "Понеделник",
      tuesday: "Вторник",
      wednesday: "Сряда",
      thursday: "Четвъртък",
      friday: "Петък",
      saturday: "Събота",
      sunday: "Неделя",
    },
    open: "Работи",
    closed: "Почивен",
    closedDay: "Почивен ден",
    opensAt: "Отваря",
    closesAt: "Затваря",
    shiftLabel: "Смяна {{number}}",
    addShift: "Добави смяна",
    removeShift: "Премахни смяна {{number}}",
    hintClosed: "Почивен ден — не се приемат резервации",
    hintAfterMidnight: "Затваря в {{time}} на следващия ден",
    errors: {
      sameTime: "Отварянето и затварянето не може да са в един и същи час",
      sameTimeShift: "Смяна {{shift}}: отварянето и затварянето не може да са в един и същи час",
      shiftsOverlap: "Смените трябва да вървят подред, без да се застъпват, и да се съберат в 24 часа",
      overlapsNextDay: "Затварянето след полунощ трябва да е преди отварянето на следващия ден",
    },
    save: "Запази",
    discard: "Откажи промените",
    saveSuccess: "Работното време е запазено",
    saveError: "Грешка при запис на работното време",
    guide: {
      link: "Как работи?",
      text: "Работното време задава часовете по подразбиране в справките и часовете, в които се приемат резервации.",
      modalTitle: "Как работи работното време",
      modalSubtitle: "Примери с три дни от една седмица",
      tab: {
        reports: "Справки",
        reservations: "Резервации",
      },
      lead: {
        reports: "Справката за един ден е от отварянето до затварянето на деня.",
        reservations: "Резервация може да започва от отварянето до 15 минути преди затварянето.",
      },
      columnDay: "Ден",
      columnHours: "Работно време",
      columnResult: {
        reports: "Период в справката",
        reservations: "Час за резервация",
      },
      afterMidnight: "затваря след полунощ",
      result: {
        reports: {
          tuesday: "вт 10:00 → вт 22:00",
          friday: "пт 12:00 → сб 02:00",
          monday: "пн 00:00 → пн 23:59",
        },
        reservations: {
          tuesday: "от 10:00 до 21:45",
          friday: "от 12:00 до 01:45",
          monday: "Не се приемат",
        },
      },
      goodToKnow: "Добре е да знаеш",
      notes: {
        reports: {
          afterMidnight: {
            title: "Сметка след полунощ",
            text: "Петък работи до 02:00. Сметка, платена в събота в 01:30, влиза в справката за петък, а не за събота.",
          },
          shifts: {
            title: "Ден с няколко смени",
            text: "Четвъртък има две смени: 11:00–15:00 и 18:00–23:00. Справката за четвъртък е от 11:00 до 23:00 — заедно с почивката между смените.",
          },
          closedAfterMidnight: {
            title: "Почивен ден след ден, който работи до късно",
            text: "Неделя работи до 03:00, а понеделник е почивен ден. Справката за понеделник е от 03:00 до 23:59 — сметките до 03:00 остават в неделя.",
          },
          notSet: {
            title: "Без запазено работно време",
            text: "Докато работното време не е запазено, денят в справките е от 06:00 до 05:59 на следващия ден.",
          },
        },
        reservations: {
          lastSlot: {
            title: "Последен час",
            text: "Сряда работи 10:00–22:00. Часовете за резервация са през 15 минути, а последният е 21:45.",
          },
          shifts: {
            title: "Почивка между смените",
            text: "Четвъртък има две смени: 11:00–15:00 и 18:00–23:00. Резервации се приемат от 11:00 до 14:45 и от 18:00 до 22:45, а в почивката — не.",
          },
          afterMidnight: {
            title: "Ден, който работи след полунощ",
            text: "Петък работи до 02:00. Когато избереш петък, виждаш всички часове от 12 до 01 наведнъж. Ако избереш час след полунощ (например 01:15), датата горе сама минава на събота — резервацията е за събота в 01:15.",
          },
          closed: {
            title: "Почивен ден",
            text: "Понеделник е почивен ден. Формата показва „Почивен ден — не се приемат резервации“ и не записва.",
          },
          schedule: {
            title: "„Таблица на резервациите“",
            text: "Таблицата за деня показва часовете от отварянето до затварянето. Сряда 10:00–22:00 → от 10:00 до 22:00. Петък 12:00–02:00 → от 12:00 до 02:00 на един екран, без да сменяш деня.",
          },
          notSet: {
            title: "Без запазено работно време",
            text: "Докато работното време не е запазено, резервации се приемат от 11:00 до 22:45 всеки ден.",
          },
        },
      },
      close: "Затвори",
    },
  },

  reservationsSidebar: {
    reservations: "Резервации",
    table: "Таблица на резервациите",
    restaurantSchema: "Схема на заведението",
    tablesConfig: "Конфигурация на маси",
    moduleLabel: "Модул Резервации",
  },

  nonFiscalDisplay: {
    // Оптимизация с база
    cleanupTitle: "Оптимизация с база",
    cleanupRun: "Стартирай",
    cleanupConfirmTitle: "Сигурни ли сте?",
    cleanupConfirmOk: "Да",
    cleanupConfirmCancel: "Не",
    cleanupNoBills: "Няма сметки за изтриване",
    cleanupSuccess: "Изтрити сметки: {{count}}",
    cleanupError: "Грешка при почистване на базата",
    // Кодовете идват от BE (`detail`), текстовете живеят само тук.
    cleanupErrors: {
      cleanup_failed:
        "Почистването не бе извършено. Нищо не е изтрито — виж лога на сървъра.",
      cleanup_requires_fiscal_restaurant:
        "Почистването е достъпно само за ресторант с фискален принтер.",
      cleanup_no_restaurant_in_token:
        "Не е намерен идентификатор на ресторант — влезте отново.",
      cleanup_requires_access:
        "Оптимизацията е възможна само в тестов режим.",
      cleanup_no_session: "Не е намерен токен на сесията — влезте отново.",
      cleanup_no_tills:
        "Не всички каси се обаждат в момента. Оптимизацията изисква връзка с всяка каса — нищо не е изтрито.",
      cleanup_till_unreachable:
        "Каса отказа или не отговори. Възможно е да работи в локален режим или да държи незавършено плащане — проверете я и опитайте отново.",
      cleanup_renumber_failed:
        "Сметките са изтрити и касите са зачистени, но номерата не бяха пренаредени. Пуснете оптимизацията отново.",
      // „Сваляне на база" (POST /cleanup/database-download)
      database_download_wrong_code:
        "Грешен код. Нищо не е изтрито и нищо не е свалено.",
      database_download_not_consecutive:
        "Оптимизацията е извършена, но номерата на сметките не са подред или междувременно е пуснат отчет на заведението. Базата не е свалена — опитайте отново.",
      database_download_pg_dump_missing:
        "Сървърът не може да свали базата (инструментът липсва или не стига до нея). Нищо не е изтрито — свържете се с поддръжката.",
      database_download_failed:
        "Оптимизацията е извършена, но базата не можа да бъде свалена. Опитайте отново.",
    },
    // Локален режим: операцията минава през облака и през всяка каса.
    cleanupOfflineHint:
      "Терминалът работи в локален режим. Оптимизацията е възможна само при връзка с облака.",
    cleanupResultTitle: "Резултат от оптимизацията",
    cleanupResultClose: "Затвори",
    cleanupDeletedBills: "Изтрити сметки",
    cleanupDeletedReports: "Изтрити отчети",
    cleanupRecalculated: "Преизчислени отчети",
    cleanupRemaining: "Оставащи сметки",
    cleanupNewMaxBillId: "Последен номер на сметка",
    cleanupMessage: "Съобщение",
    // Сваляне на база — в архивиран ресторант първо същата оптимизация, после
    // файлът (без описание); иначе само файлът (…Plain)
    downloadTitle: "Сваляне на база",
    downloadDescPlain: "Сваля копие на базата данни като файл",
    downloadRun: "Свали",
    downloadHintPlain:
      "Сваля се веднага.",
    downloadOfflineHint:
      "Терминалът работи в локален режим. Свалянето на базата е възможно само при връзка с облака.",
    downloadOptimizing: "Оптимизация…",
    downloadDownloading: "Сваляне…",
    downloadSuccess: "Базата е свалена: {{filename}}",
    downloadError: "Грешка при сваляне на базата",
  },

  orderingSettings: {
    sectionTablesKicker: "Маси",
    sectionTablesTitle: "Номерация, ред и видимост на масите",
    sectionOrdersKicker: "Поръчки",
    sectionOrdersTitle: "Поведение след „Поръчай“",
    sectionNotificationsKicker: "Известия",
    sectionNotificationsTitle: "Съобщения в Маркиране",
    sectionCatalogKicker: "Каталог",
    sectionCatalogTitle: "Изглед и подредба на продуктите",
    sectionCodeLoginKicker: "Вход и изход",
    sectionCodeLoginTitle: "Изход на служител до вход с код",
    sectionMaintenanceKicker: "Поддръжка",
    sectionMaintenanceTitle: "База данни",
    sharedNumberingName: "Обща номерация на масите",
    sharedNumberingDesc: "Дали номерата на масите са уникални за целия ресторант",
    optionSharedNumberingOff: "Изключена",
    hintSharedNumberingOff:
      "Всеки сервитьор има собствена номерация — двама могат едновременно да имат маса „1“",
    optionSharedNumberingOn: "Включена",
    hintSharedNumberingOn:
      "Номерата са уникални за целия ресторант — заета маса „1“ дава грешка и на другите сервитьори",
    tableOrderName: "Ред на масите в списъка",
    tableOrderDesc: "Как са подредени отворените маси",
    optionTableOrderChronological: "Хронологично",
    hintTableOrderChronological:
      "По време на отваряне — най-старата маса е първа, новата отива най-отдолу",
    optionTableOrderAlphanumeric: "По номер и име",
    hintTableOrderAlphanumeric:
      "Първо масите с номер по големина (1, 2, 10, 33), после именуваните по азбучен ред",
    nonFiscalName: "Нефинализирани маси",
    nonFiscalDesc: "Кога се виждат сметки, които още не са фискализирани",
    optionNonFiscalNever: "Не",
    hintNonFiscalNever: "Сметките изчезват",
    optionNonFiscalAlways: "Винаги",
    hintNonFiscalAlways: "Сметките стоят докато не се фискализира",
    optionNonFiscalOnDemand: "При необходимост",
    hintNonFiscalOnDemand: "Динамично показване и скриване с команда ALT + F1",
    quickCloseName: "Закриване веднага след поръчка",
    quickCloseDesc: "Какво се случва с масата след „Поръчай“",
    optionQuickCloseOff: "Изключено",
    hintQuickCloseOff:
      "Нова маса иска номер, а поръчката се записва без да се закрива",
    optionQuickCloseOn: "Включено",
    hintQuickCloseOn:
      "Нова маса взима автоматично най-малкия свободен номер, а след „Поръчай“ се отваря „Закрий“",
    successNotificationsName: "Съобщения за успешно действие",
    successNotificationsDesc: "Зелените „Успешно…“ съобщения след всяко действие",
    optionSuccessNotificationsOff: "Изключени",
    hintSuccessNotificationsOff:
      "Зелените съобщения „Успешно…“ в „Маркиране“ не се показват — грешките и предупрежденията остават",
    optionSuccessNotificationsOn: "Включени",
    hintSuccessNotificationsOn:
      "След всяко успешно действие (добавени продукти, запазен клиент, закрита маса…) излиза кратко съобщение",
    catalogFilterName: "Лентата над каталога",
    catalogFilterDesc:
      "Кой филтър е в лентата над продуктите; другият отива в панела вдясно, над поръчката",
    optionFilterGroups: "Групите",
    hintFilterGroups:
      "Горе: групите (Бургери, Салати, Грил…). Вдясно над поръчката: станциите (Скара, Бар…)",
    optionFilterStations: "Станциите",
    hintFilterStations:
      "Горе: станциите (Скара, Бар…). Вдясно над поръчката: групите (Бургери, Салати, Грил…)",
    illustrationGroups: "Групи",
    illustrationStations: "Станции",
    illustrationCatalog: "Каталог",
    illustrationOrder: "Поръчка",
    colorByNameAssortments: "Оцветяване на асортиментите",
    colorByNameRecipes: "Оцветяване на рецептите",
    colorByDesc: "Откъде идва цветът на редовете и картите",
    optionColorGroup: "По група",
    hintColorGroupAssortments: "Всеки асортимент носи цвета на групата си",
    hintColorGroupRecipes: "Всяка рецепта носи цвета на групата си",
    optionColorStation: "По станция",
    hintColorStationAssortments: "Всеки асортимент носи цвета на станцията си",
    hintColorStationRecipes: "Всяка рецепта носи цвета на станцията си",
    optionColorNone: "Без оцветяване",
    hintColorNone: "Редовете и картите са без цветен фон",
    searchFieldName: "Търсачка над каталога",
    searchFieldDesc: "Показва или скрива търсачката на компютър; на телефон и таблет я има винаги",
    optionSearchFieldOff: "Скрита",
    hintSearchFieldOff:
      "Търси се направо с клавиатурата — написаното изскача върху каталога и изчезва след секунда",
    optionSearchFieldOn: "Показана",
    hintSearchFieldOn:
      "Полето стои над каталога и в него се пише; − и + в него пак променят бройката на избрания продукт",
    searchScopeName: "Търсене при избрана група",
    searchScopeDesc:
      "Къде търси търсачката, когато в каталога е отворена група (напр. „Напитки“) — важи и за редактора на обедно меню. Без избрана група се търси винаги в цялото меню",
    optionSearchScopeMenu: "В цялото меню",
    hintSearchScopeMenu:
      "Напр. в „Напитки“ пишете „лимон“ → излизат „Лимонада“ и „Пиле с лимон“ (Скара)",
    optionSearchScopeGroup: "Само в групата",
    hintSearchScopeGroup:
      "Напр. в „Напитки“ пишете „лимон“ → излиза само „Лимонада“ и оставате в „Напитки“",
    guestCountName: "Въвеждане на брой гости",
    guestCountDesc: "Дали и кога „Маркиране“ пита колко са гостите на масата",
    optionGuestCountOff: "Не",
    hintGuestCountOff: "Броят гости не се въвежда",
    optionGuestCountNewTable: "При нова маса",
    hintGuestCountNewTable:
      "Модал „Брой гости“ преди модала „Нова маса“. Без въведен брой масата не се отваря",
    optionGuestCountClose: "При закриване",
    hintGuestCountClose:
      "Модал „Брой гости“ преди модала „Закрий“. Без въведен брой масата не се закрива",
    illustrationTableFlow: "Поток на масата",
    suggestTableNameName: "Предлагане на номер за нова маса",
    suggestTableNameDesc:
      "Дали модалът „Нова маса“ се отваря с попълнен първия свободен номер. Не важи при „Закриване веднага след поръчка“ — тогава модал няма и номерът се взима сам",
    optionSuggestTableNameOff: "Изключено",
    hintSuggestTableNameOff:
      "Модалът „Нова маса“ се отваря празен и номерът се въвежда",
    optionSuggestTableNameOn: "Включено",
    hintSuggestTableNameOn:
      "Модалът „Нова маса“ се отваря с първия свободен номер — ОК го приема, а първата въведена цифра го заменя",
    autoCodeLogoutName: "Автоматичен изход до код",
    autoCodeLogoutDesc:
      "Ако никой не ползва терминала, той сам се връща на екрана за код. Важи само за влезлите с код",
    optionAutoCodeLogoutOff: "Изключено",
    hintAutoCodeLogoutOff:
      "Служителят остава влязъл, докато не излезе сам",
    optionAutoCodeLogoutOn: "Включено",
    hintAutoCodeLogoutOn:
      "Терминалът се връща на екрана за код след зададените секунди без действие",
    autoCodeLogoutSecondsName: "След колко секунди",
    autoCodeLogoutSecondsDesc:
      "Секунди без докосване, клик или клавиш",
    autoCodeLogoutSecondsError: "Въведете число от 10 до 3600",
    autoCodeLogoutSecondsHint: "От 10 до 3600. Запазва се с Enter или като излезете от полето",
    autoCodeLogoutSecondsUnit: "сек",
    sectionCloseKicker: "Закриване",
    sectionCloseTitle: "Модалът „Закрий“",
    cashChangeName: "Ресто при плащане в брой",
    cashChangeDesc:
      "Показва „Получено“ и „Ресто“ при закриване с „В брой“. Рестото е само за плащане в брой — при карта и другите методи не се показва",
    optionCashChangeOff: "Изключено",
    hintCashChangeOff:
      "„В брой“ изглежда като „С карта“ — само сумата за плащане, без банкноти, „Получено“ и „Ресто“",
    optionCashChangeOn: "Включено",
    hintCashChangeOn:
      "При „В брой“ се избира банкнота или се въвежда получената сума и се показва рестото за връщане",
    saveSuccess: "Настройката е запазена успешно",
    saveError: "Грешка при запазване на настройката",
  },

  monitorsConfig: {
    title: "Монитори",
    shpicker: "Шпикер",
    shpickerHint: "Този потребител е шпикер — екранът обединява сготвеното от всички станции и го издава към сервитьорите.",
    waiterMonitor: "Сервитьорски",
    waiterMonitorHint: "Този потребител е сервитьорски монитор — екранът показва ястията на станциите му и ги сервира („Изпълни“), както сервирането в Маркиране.",
    // „Вижда след" (VisibleFromStatusPicker.tsx): картите са самите статуси —
    // „Шпикера вижда след [Сготвено]"; описанията са примери.
    stepShpickerVisibleFrom: "Шпикера вижда след",
    stepWaiterVisibleFrom: "Сервитьора вижда след",
    visibleFromShort: "Вижда след",
    // „Сервира след" (WaiterStatusSteps.tsx) — от кой статус сервитьорът може
    // да сервира: от сервитьорския монитор и от Маркиране.
    stepWaiterServeFrom: "Сервитьора сервира след",
    serveFromShort: "Сервира след",
    statusNotStarted: "Незапочнато",
    statusInProgress: "В процес",
    statusCooked: "Сготвено",
    statusIssued: "Издадено",
    shpickerVisibleFromNotStartedDesc: "Вижда всяко ястие още от поръчката (със статуса му)",
    shpickerVisibleFromInProgressDesc: "Вижда ястието, щом готвачът го започне",
    shpickerVisibleFromCookedDesc: "Вижда ястието, щом кухнята го изпълни (както досега)",
    waiterVisibleFromNotStartedDesc: "Вижда всяко ястие още от поръчката",
    waiterVisibleFromInProgressDesc: "Вижда ястието, щом готвачът го започне",
    waiterVisibleFromCookedDesc: "Вижда ястието, щом кухнята го изпълни",
    waiterVisibleFromIssuedDesc: "Вижда ястието, щом шпикерът го издаде",
    waiterServeFromNotStartedDesc: "Сервира веднага, без да чака кухнята",
    waiterServeFromInProgressDesc: "Сервира, щом готвачът започне",
    waiterServeFromCookedDesc: "Сервира, щом кухнята го изпълни",
    waiterServeFromIssuedDesc: "Сервира, щом шпикерът го издаде",
    waiterServeFromNoShpickerReason: "Няма шпикер — ястията не стигат до „Издадено“",
    waiterServeFromHint:
      "С шпикер обикновено е „Издадено“ (щом шпикерът издаде), без шпикер — „Сготвено“. Важи за станциите на монитора — на екрана му и в Маркиране. Не се чака статус, до който ястието не стига: станция с кухненски монитор, но без шпикер — сервира се след „Сготвено“; станция само на сервитьорския монитор (без кухненски и без шпикер) — сервира без проверки. Ястие от станция без сервитьорски монитор — сервира без проверки.",
    waiterVisibleFromHint:
      "Обикновено е един статус след шпикера: шпикерът при „Изпълни“ поставя „Издадено“ → сервитьорът вижда след „Издадено“. Ако заведението няма шпикер — изберете „Сготвено“: сервитьорът вижда ястието, щом кухнята го изпълни.",
    stepColorBy: "Оцветяване",
    colorByShort: "Оцветяване",
    colorByTable: "По маси",
    colorByTableDesc: "Редовете на една маса са в общ цвят",
    colorByWaiter: "По сервитьор",
    colorByWaiterDesc: "Редовете на един сервитьор са в общ цвят",
    colorByStation: "По станции",
    colorByStationDesc: "Използва цветовете на станциите от конфигурацията",
    colorByNone: "Без",
    colorByNoneDesc: "Без цветово групиране",
    // „По статус" — само шпикер (ColorByStep.tsx, ReadyColorDetails.tsx): готовите от кухнята
    // в избран цвят.
    colorByStatus: "По статус",
    colorByStatusDesc: "Готовите от кухнята („Сготвено“) са в избран цвят",
    colorByStatusHint:
      "Готовите от кухнята („Сготвено“) са в избрания цвят — шпикерът веднага вижда какво да издаде. Другите са без цвят. Най-полезно, когато вижда и по-ранните статуси („Шпикера вижда след“).",
    readyColorLabel: "Цвят на готовите",
    readyColorExample: "Пример",
    readyColorExampleReady: "Пица Маргарита",
    readyColorExampleWaiting: "Салата Цезар",
    name: "Име",
    stations: "Станции",
    actions: "Действия",
    editMonitor: "Редактирай монитор",
    deleteMonitor: "Изтрий монитор",
    deleteConfirm: "Сигурни ли сте?",
    assignUsers: "Потребители",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",
    configuredMonitors: "Конфигурирани монитори",
    deleteSuccess: "Конфигурацията на монитора е изтрита успешно",
    deleteError: "Грешка при изтриване на конфигурацията",
    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете конфигурацията на монитор "{{name}}"?',
    editSuccess: "Конфигурацията на монитора е обновена успешно",
    editError: "Грешка при редакция на конфигурацията",
    editTitle: "Редакция на монитор",
    editConfirmTitle: "Потвърждение за редакция",
    editConfirmContent: "Сигурни ли сте, че искате да запазите промените?",
    saveChanges: "Запази промените",
    selectMonitorPlaceholder: "Изберете монитор",
    noStations: "Няма налични станции",
    monitorConfig: "Конфигурация на монитор",
    selectUserAndStation: "Моля изберете потребител и поне една станция",
    saveSuccess: "Конфигурацията на монитора е запазена успешно",
    saveError: "Грешка при запазване на конфигурацията",
    saveConfig: "Запази конфигурация",
    selected: "Избрани: {{count}}",
    aggregatedQuantities: "Групирани количества",
    // Redesign keys
    configTitle: "Свържи потребител със станции",
    // Трите секции по вид (monitorTypeSections.ts): заглавие на панела = на
    // първата колона, kicker, бутон, празен списък, kicker на модала.
    kitchenSection: "Кухненски",
    listKickerKitchen: "Списък кухненски монитори",
    addKitchenMonitor: "Добави кухненски монитор",
    noKitchenMonitors: "Няма конфигурирани кухненски монитори",
    configKickerKitchen: "Нов кухненски монитор",
    shpickerSection: "Шпикер",
    listKickerShpickers: "Списък шпикер монитори",
    addShpicker: "Добави шпикер монитор",
    noShpickers: "Няма конфигурирани шпикер монитори",
    configKickerShpicker: "Нов шпикер монитор",
    waiterSection: "Сервитьорски",
    listKickerWaiters: "Списък сервитьорски монитори",
    addWaiterMonitor: "Добави сервитьорски монитор",
    noWaiterMonitors: "Няма конфигурирани сервитьорски монитори",
    configKickerWaiter: "Нов сервитьорски монитор",
    // Празният списък „Потребител" — без него antd показва „No data".
    noFreeUsers: "Няма свободни потребители от този вид",
    // Номерата се слагат динамично в MonitorFormModal (шпикер добавя стъпка).
    stepUser: "Потребител",
    stepScreen: "Екран",
    stepStations: "Станции",
    stepView: "Изглед",
    stepOptions: "Опции",
    screenSingle: "Един екран",
    screenSingleDesc: "Всички станции на общ екран",
    screenSplit: "Разделен на 2",
    screenSplitDesc: "Лява и дясна половина със свои станции",
    leftHalf: "Лява част",
    rightHalf: "Дясна част",
    leftHalfShort: "Л",
    rightHalfShort: "Д",
    selectBothHalves:
      "При разделен екран изберете станции и за двете половини",
    aggregatedShort: "Групиране",
    completeFullQuantity: "Изпълняване на цялото количество",
    completeFullQuantityShort: "Цяло количество",
    viewShort: "Изглед",
    viewGrid: "Решетка",
    viewList: "Списък",
    viewGridDesc: "Продуктите се подреждат в колони",
    viewListDesc: "Продуктите се подреждат в един списък",
    viewBoard: "Таблица",
    viewBoardDesc: "Мрежа от клетки по поръчка; размерът се избира на самия екран",
    // „Подредба на кутийките" — „Решетка" и „Таблица" (BoxOrderStep.tsx, MonitorBoxOrder).
    stepBoxOrder: "Подредба на кутийките",
    boxOrderDown: "Отгоре надолу",
    boxOrderDownDesc: "Под предишната",
    boxOrderAcross: "Отляво надясно",
    boxOrderAcrossDesc: "До предишната",
    boxOrderHint:
      "Важи за „Решетка“ и „Таблица“. Отгоре надолу (както досега) — колона по колона; отляво надясно — ред по ред, като при четене.",
    boxOrderListLead: "Важи само за „Решетка“ и „Таблица“",
    boxOrderListReason: "В „Списък“ редовете са един под друг.",
    // Звук по монитор — ключовете са в src/pages/monitors/monitorSounds.ts.
    stepSound: "Звук",
    soundShort: "Звук",
    soundPreview: "Чуй",
    soundClassic: "Класически",
    soundBell: "Звънче",
    soundDoubleBell: "Двойно звънче",
    soundTriangle: "Триъгълник",
    soundChime: "Камбанки",
    soundKnock: "Почукване",
    soundBuzzer: "Зумер",
    soundBeeper: "Пейджър",
    soundAlarm: "Аларма",
    soundRing: "Телефон",
    // Къде отива селекцията след „Изпълни"/„Върни" (MonitorSelectionAfterAction).
    stepSelectionAfterAction: "Селекция след действие",
    selectionAfterActionShort: "Селекция",
    selectionStay: "Остава на мястото",
    selectionStayDesc: "Минава на реда, който заема мястото на изпълнения",
    selectionFirst: "Първият ред",
    selectionFirstDesc: "Отива на първия ред горе вляво",
    selectionOrder: "Първият от поръчката",
    selectionOrderDesc: "Отива на първия ред от същата поръчка",
    selectionNone: "Без селекция",
    selectionNoneDesc: "Изчезва; клик или ↓ избират отново",
  },

  devices: {
    name: "Име",
    uniqueNumber: "Уникален номер",
    type: "Тип",
    actions: "Действия",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",
    users: "Достъпи & Работни точки",
    connectedClients: "FiscalAPI",
    connectedClientsCount: "{{count}} връзки",
    connectedClientsConflict:
      "Две инсталации печатат на този принтер — един бон ще излезе два пъти.",
    connectedClientsUnknown:
      "Няма данни. Старите версии на FiscalAPI не се обявяват — обнови ги, за да се вижда кой компютър печата тук.",
    connectedClientsStale: "не е на връзка",
    fiscalapiDownload: "Свали последната версия на FiscalAPI",
    fiscalapiUpdateButton: "Обнови до v{{version}}",
    fiscalapiUpdateStarted:
      "Ъпдейтът тръгна — инсталацията ще се рестартира до минути и новата версия ще се покаже тук.",
    fiscalapiUpdateFailed: "Ъпдейтът не тръгна",
    clock: {
      open: "Час на апарата",
      title: "Час на апарата",
      close: "Затвори",
      reading: "Чета часа на апарата…",
      deviceTime: "Апаратът",
      referenceTime: "Точен час",
      exact: "Точен до секунда",
      small: "Разлика {{duration}} — в рамките на нормалното",
      ahead: "Напред с {{duration}}",
      behind: "Назад с {{duration}}",
      hours: "{{count}} ч",
      minutes: "{{count}} мин",
      seconds: "{{count}} сек",
      referenceUnverified:
        "Точният час не е потвърден — компютърът на касата и сървърите за точно време не са в съгласие или касата няма интернет. Сверяването ще откаже.",
      readFailed: "Часът на апарата не можа да се прочете.",
      readAgain: "Прочети отново",
      sync: "Свери с точния час",
      syncing: "Сверявам…",
      syncFailed: "Сверяването не мина.",
      syncedExact: "Сверено — апаратът е с точния час.",
      syncedFromAhead: "Сверено — апаратът беше напред с {{duration}}.",
      syncedFromBehind: "Сверено — апаратът беше назад с {{duration}}.",
      syncUnverified:
        "Часът е изпратен, но новият прочит се разминава — прочетете часа отново след минута.",
      backwardBlocked:
        "Апаратът не приема час преди последния си бон. Сверяването ще е възможно след {{time}} по неговия часовник — най-сигурно е сутрин, преди първия бон. Часът не е пипнат.",
      referenceUnverifiedRefusal:
        "Точният час не може да се потвърди — компютърът на касата и сървърите за точно време не са в съгласие или касата няма интернет. Часът не е пипнат. Проверете часовника на компютъра или сверете от портала на касата.",
      hint: "Сверява се по точния час на касата (компютърът, сървърът за обновления и интернет часовник в съгласие). Назад апаратът приема час едва след последния си бон.",
    },
    deleteSuccess: "Устройството е изтрито успешно",
    deleteError: "Грешка при изтриване на устройство",
    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете устройство "{{name}}"?',
    editSuccess: "Устройството е обновено успешно",
    editError: "Грешка при редакция на устройство",
    editConfirmTitle: "Потвърждение за редакция",
    editConfirmContent: "Сигурни ли сте, че искате да запазите промените?",
    saveChanges: "Запази промените",
    pickerSearch: "Търси по име",
    pickerWorkpointsCount_one: "{{count}} работна точка",
    pickerWorkpointsCount_other: "{{count}} работни точки",
    pickerUsersCount_one: "{{count}} потребител",
    pickerUsersCount_other: "{{count}} потребители",
    createSuccess: "Устройството е създадено успешно",
    createError: "Грешка при създаване на устройство",
    addDevice: "Добави устройство",
    // Опит за запис без име / без акаунт (DeviceModalShell — бутонът не се гаси).
    nameRequired: "Въведи име на устройството",
    accountsRequired: "Избери поне една работна точка или потребител",
    posAssignmentRequired: "Избери поне една работна точка, потребител или станция",
    copySuccess: "Connection string копиран",
    typeFiscal: "Фискален принтер",
    typePos: "POS принтер",
    typePaymentTerminal: "Терминал за плащане",
    // Redesign
    // Трите секции на страницата — по една на тип устройство.
    posSectionKicker: "Печат на поръчки",
    fiscalSectionKicker: "Фискализация",
    terminalSectionKicker: "Плащане с карта",
    posDevices: "ПОС устройства",
    fiscalDevices: "Фискални принтери",
    terminalDevices: "Терминали за плащане",
    addPosDevice: "Добави ПОС устройство",
    addFiscalDevice: "Добави фискален принтер",
    addTerminalDevice: "Добави терминал",
    noPosDevices: "Няма конфигурирани ПОС устройства",
    noFiscalDevices: "Няма конфигурирани фискални принтери",
    noTerminalDevices: "Няма конфигурирани терминали за плащане",
    deactivateWarning_one: "При запазване ще бъде премахнат достъпът на:",
    deactivateWarning_other: "При запазване ще бъдат премахнати {{summary}}:",
    deactivateUndo: "Отмени",
    deactivateWarningAnd: " и ",
    orgUrlCopied: "Адресът е копиран",
    noStations: "Няма налични станции",
    printLanguage: "Език на печат",
    printLanguagePlaceholder: "Български (по подразбиране)",
    noLanguages: "Няма налични езици",
    summarizeReceipt: "Обобщени касови бележки",
    summarizeReceiptHint:
      "Еднаквите продукти от сметката излизат на фискалния бон като един ред с общо количество.",
    summarizeReceiptOff: "Изключено",
    summarizeReceiptOn: "Включено",
    summarizeReceiptExampleWater: "Минерална вода",
    summarizeReceiptExampleCola: "Кола",
    summarizeReceiptExampleCoffee: "Кафе",
    summarizeReceiptExampleCoffeeMilk: "Кафе + мляко",
    summarizeReceiptActive: "Активно",
    summarizeReceiptLines_one: "{{count}} ред",
    summarizeReceiptLines_other: "{{count}} реда",
    nonFiscalCopy: "Нефискално копие на ПОС",
    nonFiscalCopyHint:
      "След всяка успешна касова бележка ПОС принтерът на същата каса печата нефискално копие — удобно при доставка, за да се види дали всичко е вътре. Без ПОС принтер копие не излиза.",
    paymentMethods: "Методи на плащане",
    stations: "Станции",
    stationsCount_one: "{{count}} станция",
    stationsCount_other: "{{count}} станции",
    usersCount_one: "{{count}} потребител",
    usersCount_other: "{{count}} потребителя",
    searchPlaceholder: "Търси по име, GUID или потребител",
    noPaymentMethodsForDevice: "—",
    // Модалът на терминал за плащане (създаване и редакция) — TerminalModal.
    terminalModal: {
      kickerEdit: "Редакция на устройство · Терминал за плащане",
      kickerCreate: "Ново устройство · Терминал за плащане",
      accountsTitle: "Картови плащания",
      accountsDesc:
        "Работните точки и потребители, закачени към този терминал. Един акаунт може да е закачен само към един терминал.",
      accountsDescShort: "Акаунтите, закачени към този терминал.",
      takenNote_one:
        "{{count}} акаунт вече е закачен към {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другия терминал.",
      takenNote_other:
        "{{count}} акаунта вече са закачени към {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другия терминал.",
      takenWhereMany: "други терминали",
      summaryAccounts: "Картови плащания:",
      summaryCount_one: "{{count}} акаунт",
      summaryCount_other: "{{count}} акаунта",
    },
    // Модалът на фискален принтер (създаване и редакция) — FiscalPrinterModal.
    fiscalModal: {
      kickerEdit: "Редакция на устройство · Фискален принтер",
      kickerCreate: "Ново устройство · Фискален принтер",
      accountsTitle: "Касови бележки",
      accountsDesc:
        "Касовите бележки на избраните работни точки и потребители се издават от това устройство. Един акаунт фискализира само на едно устройство.",
      accountsDescShort: "Касовите бележки на избраните акаунти се издават тук.",
      inactiveBannerTitle: "Устройството е изключено.",
      inactiveBannerText:
        "При запазване всички закачени работни точки и потребители се премахват и стават свободни за други фискални устройства.",
      takenNote_one:
        "{{count}} акаунт вече фискализира на {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другото устройство.",
      takenNote_other:
        "{{count}} акаунта вече фискализират на {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другото устройство.",
      takenWhereMany: "други фискални устройства",
      methodsTitle: "Методи на плащане",
      methodsDesc:
        "Избери слот на устройството или „БЕЗ ФИСКАЛИЗИРАНЕ“ за всеки метод. „Не се ползва“ = методът не се ползва на това устройство.",
      methodsDescShort: "Слот на устройството или „БЕЗ ФИСКАЛИЗИРАНЕ“ за всеки метод.",
      methodLabel: "Метод",
      slotLabel: "Слот на устройството",
      fiscalizedPill: "Фискализирани: {{count}}",
      notUsed: "Не се ползва",
      hintSlot: "Фискален · {{slot}}",
      hintNoFiscal: "Без касов бон",
      hintNotUsed: "Не се ползва тук",
      hintOnAccount: "Без касов бон · винаги",
      onAccountInfo:
        "„По сметка“ се показва при закриване само ако към сметката е избран клиент с право „Плащане по сметка“ (Организация → „Конфигурационни“ → „Клиенти“). Никога не издава касов бон, затова тук е винаги „БЕЗ ФИСКАЛИЗИРАНЕ“.",
      receiptTitle: "Касова бележка",
      receiptDescShort: "Обобщаване на редовете и нефискално копие на ПОС.",
      tabAccounts: "Акаунти",
      tabMethods: "Плащане",
      tabReceipt: "Бележка",
      tabOff: "изкл.",
      summaryReceipts: "Касови бележки:",
      summaryMethods: "Методи:",
      summaryOff: "изключени",
      summaryAccounts_one: "{{count}} акаунт",
      summaryAccounts_other: "{{count}} акаунта",
      summaryFiscalized: "{{count}} фискализирани",
    },
    // Модалът на POS принтер (създаване и редакция) — PosPrinterModal.
    posModal: {
      kickerEdit: "Редакция на устройство · POS принтер",
      kickerCreate: "Ново устройство · POS принтер",
      namePlaceholder: "Име, напр. Бар",
      editName: "Промени името",
      nameAria: "Име на принтера",
      close: "Затвори",
      cancel: "Отказ",
      docsTitle: "Документи от касата",
      docsDesc:
        "Документите на избраните работни точки и потребители излизат на този принтер. Един акаунт печата само на един POS принтер.",
      docsDescShort: "Бележките на избраните акаунти излизат тук.",
      kitchenDescShort: "Поръчките от избраните станции излизат тук като кухненски билети.",
      tabDocuments: "Документи",
      tabKitchen: "Кухня",
      tabOff: "изкл.",
      active: "Активно",
      inactive: "Неактивно",
      inactiveBannerTitle: "Документите са изключени.",
      inactiveBannerText:
        "При запазване всички закачени работни точки и потребители се премахват и стават свободни за други POS принтери. Кухненските билети продължават да се печатат.",
      accountsLabel: "Работни точки и потребители",
      selectedPill_one: "{{count}} избран",
      selectedPill_other: "{{count}} избрани",
      allPill: "Всички · {{count}}",
      allAccounts: "Всички акаунти",
      allAccountsNote: "Печатат всички <b>{{count}}</b> свободни работни точки и потребители.",
      searchPlaceholder: "Търси работна точка или потребител",
      filterAll: "Всички",
      filterWorkpoints: "Работни точки",
      filterUsers: "Потребители",
      filterSelected: "Избрани",
      workpoint: "Работна точка",
      user: "Потребител",
      noAccounts: "Няма намерени акаунти",
      shownOf: "Показани {{shown}} от {{total}}",
      selectShown: "Избери показаните",
      clear: "Изчисти",
      takenNote_one:
        "{{count}} акаунт вече печата документи на {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другия принтер.",
      takenNote_other:
        "{{count}} акаунта вече печатат документи на {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другия принтер.",
      takenWhereMany: "други POS принтери",
      printCashNoReceipt: "Печат от ПОС принтер",
      printCashNoReceiptHint:
        "Включено — бележката излиза на ПОС принтера. Изключено — не излиза.",
      kitchenTitle: "Кухненски билети",
      kitchenDesc:
        "Поръчаните продукти от избраните станции излизат на този принтер като кухненски билети — независимо кой акаунт е направил поръчката.",
      kitchenExampleTitle: "Пример за билет",
      examplePrinterNamed: "Принтер „{{name}}“",
      exampleThisPrinter: "Този принтер",
      exampleListens: "{{printer}} слуша <b>{{stations}}</b>.",
      exampleNoStations: "{{printer}} не слуша станции — не печата кухненски билети.",
      exampleSplit: "Поръчка с продукти и за двата принтера се разделя на два билета — по един на всеки.",
      exampleSingle: "Поръчка с продукти от тези станции излиза тук като кухненски билет — независимо кой акаунт поръчва.",
      exampleListAnd: " и ",
      exampleListMore: "{{list}} и още {{count}}",
      ticketTitle: "КУХНЕНСКИ БИЛЕТ",
      ticketMeta: "Маса 12 · Мария · 12:41",
      ticketItem1: "Мохито",
      ticketMod1: "+ без захар",
      ticketItem2: "Свинска пържола",
      ticketMod2: "+ добре изпечена",
      ticketEmpty: "Няма избрани станции — не се печатат билети.",
      stationsLabel: "Станции",
      stationsSelected: "Избрани: {{count}}",
      selectAll: "Избери всички",
      removeAll: "Махни всички",
      stationsNote:
        "Една станция може да печата на няколко принтера. Станциите не зависят от акаунтите и от техния статус.",
      languageLabel: "Език на кухненския билет",
      languageNote:
        "Имената на продукти, модификатори и станции на билета. Не влияе на документите от касата.",
      summaryDocs: "Документи:",
      summaryKitchen: "Кухненски билети:",
      summaryDocsOff: "изключени",
      summaryDocsAll: "всички свободни акаунти ({{count}})",
      summaryDocsCount_one: "{{count}} акаунт",
      summaryDocsCount_other: "{{count}} акаунта",
      summaryNoStations: "няма станции",
    },
  },

  devicePaymentMethods: {
    noFiscalOption: "БЕЗ ФИСКАЛИЗИРАНЕ",
    duplicateValuesError:
      "Два различни метода не могат да имат еднаква стойност за устройство.",
    invalidValueError: "Стойностите не могат да са празни.",
    duplicateMethodsError: "Един метод не може да присъства повече от веднъж.",
    noPaymentMethods: "Няма налични методи на плащане",
    viewButton: "Виж",
    viewTitle: "Методи на плащане за устройство",
    viewEmpty: "Няма зададени методи на плащане за това устройство.",
    colMethod: "Метод",
    colSlot: "Стойност",
  },

  paymentMethodsConfig: {
    title: "Видове плащания",
    listKicker: "Списък видове плащания",
    addMethod: "Добави вид плащане",
    searchPlaceholder: "Търси по име",
    colName: "Име",
    colSystem: "Тип",
    colSortIndex: "Подредба",
    colActions: "Действия",
    badgeSystem: "Системен",
    badgeCustom: "Потребителски",
    systemTooltip:
      "Системните видове плащане не могат да бъдат изтривани, но могат да се пренареждат",
    noMethods: "Няма добавени видове плащане",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",

    createTitle: "Нов вид плащане",
    createSubtitle: "Добавете потребителски вид плащане",
    editTitle: "Редакция на вид плащане",

    fieldNameBg: "Име на български",
    fieldNameBgPlaceholder: "Вид плащане",
    fieldNameEn: "Име на английски",
    fieldNameEnPlaceholder: "Вид плащане",
    fieldSortIndex: "Подредба",

    save: "Запази",
    create: "Създай",

    createSuccess: "Видът плащане е създаден успешно",
    editSuccess: "Видът плащане е обновен успешно",
    deleteSuccess: "Видът плащане е изтрит успешно",
    createError: "Грешка при създаване",
    editError: "Грешка при редакция",
    deleteError: "Грешка при изтриване",

    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent: 'Сигурни ли сте, че искате да изтриете "{{name}}"?',

    enterNameBgWarning: "Моля въведете име на български",
    enterNameEnWarning: "Моля въведете име на английски",
  },

  restaurantSchema: {
    title: "Схема на заведението",
    subtitle: "Визуална подредба на масите и зоните по райони",
    loadError: "Схемата не се зареди",
    loadErrorHint: "Провери връзката и презареди страницата.",
    offlineHint:
      "Схемата се пази в облака — редакцията е възможна, щом интернетът се върне.",
    empty: {
      title: "Начертай заведението си",
      description:
        "Започни с район — зала, тераса или бар. В него подреждаш масите и обектите, а после ги избираш направо от схемата при маркиране.",
      cta: "Създай първия район",
    },
    counts: {
      tables_one: "{{count}} маса",
      tables_other: "{{count}} маси",
      seats_one: "{{count}} място",
      seats_other: "{{count}} места",
      objects_one: "{{count}} обект",
      objects_other: "{{count}} обекта",
    },
    kinds: {
      table: "Маса",
      bar: "Бар",
      wall: "Стена",
      plant: "Растение",
      entrance: "Вход",
      stage: "Сцена",
      dj: "DJ",
    },
    toolbar: {
      undo: "Отмени (⌘Z)",
      redo: "Повтори (⇧⌘Z)",
      saving: "Запазва се…",
      saved: "Запазено",
      rotateDrag: "Хвани и завърти (Shift — през 15°)",
      stretchWall: "Хвани и разпъни стената",
      duplicate: "Дублирай (⌘D)",
      delete: "Изтрий (Del)",
      duplicateShort: "Дублирай",
      deleteShort: "Изтрий",
    },
    canvas: {
      emptyTitle: "Районът е празен",
      emptyHint: "Добави маса или плъзни обект от лентата отдолу.",
      zoomOut: "Намали",
      zoomIn: "Увеличи",
      fit: "Побери схемата",
      tableTitle: "Маса {{name}} · {{seats}}",
      wallLength: "{{length}} см",
    },
    addBar: {
      dragHint: "Плъзни върху схемата",
      hint: "Плъзни обект върху схемата",
    },
    inspector: {
      rotation: "Завъртане",
      size: "Размер",
      tableSubtitle: "{{shape}} · {{seats}}",
      objectSubtitle: "Размер: {{size}}",
      wallSubtitle: "Дължина: {{length}} см",
      wallLength: "Дължина (см)",
      wallLengthHint: "Или хвани кръгчетата в краищата на стената и я разпъни.",
      seatsHint: "Плотът расте с броя места; размерът го уголемява или смалява.",
    },
    table: {
      title: "Маса {{name}}",
      number: "Номер на масата",
      numberPlaceholder: "напр. 12",
      nameTrailingStar: "Името на масата не може да завършва на „*“ (запазено е за офлайн режима)",
      nameTaken: "Вече има маса с този номер",
      seats: "Брой места",
      shape: "Форма",
      size: "Размер на масата",
    },
    tableSizes: {
      small: "Малка",
      medium: "Средна",
      large: "Голяма",
      xl: "XL",
    },
    tableShapes: {
      round: "Кръгла",
      square: "Квадратна",
      rectangle: "Правоъгълна",
    },
    tableCreate: {
      title: "Нова маса",
      subtitle: "Номер, брой места, форма и размер.",
      submit: "Създай",
      addAnother: "Остави прозореца отворен за следващата маса",
      addAnotherHint: "След „Създай“ номерът се сменя със следващия свободен и можеш веднага да добавиш още една.",
      createdSoFar_one: "Създадена в тази серия: {{names}}",
      createdSoFar_other: "Създадени в тази серия ({{count}}): {{names}}",
      preview: "Преглед",
      numberHint: "Следващият свободен номер. Използва се и в Маркиране.",
      numberHintTyped: "Номерът се използва и в Маркиране.",
      placementHint: "Позицията и завъртането се задават директно върху схемата.",
    },
    summary: {
      tables: "Маси",
      seats: "Места",
      hint: "Избери маса от схемата или от списъка, за да промениш свойствата ѝ.",
    },
    list: {
      tables: "Маси",
      objects: "Обекти",
      empty: "Още няма маси в този район.",
    },
    regionTabs: {
      newRegion: "Нов район",
    },
    region: {
      name: "Име на района",
      namePlaceholder: "напр. Зала, Тераса",
    },
    regionCreate: {
      title: "Нов район",
      subtitle: "Зона от заведението с отделна схема.",
      submit: "Създай",
    },
    regionSettings: {
      title: "Редакция на района",
      button: "Редакция на район",
      subtitle: "Име на района и изтриване.",
      deleteTitle: "Изтриване на района",
      deleteBlocked:
        "Районът съдържа {{tables}} и {{objects}} — за да го изтриеш, първо ги премахни.",
      deleteEmpty: "Районът е празен. Ще поискаме потвърждение.",
      delete: "Изтрий…",
    },
    regionDelete: {
      title: "Изтриване на „{{name}}“",
      description: "Районът ще бъде изтрит.",
      confirm: "Изтрий",
    },
    sizes: {
      small: "Малък",
      medium: "Среден",
      large: "Голям",
      xl: "XL",
    },
    messages: {
      regionCreated: "Районът е създаден",
      tableCreated: "Маса {{name}} е създадена",
      regionSaved: "Районът е запазен",
      regionDeleted: "Районът е изтрит",
      saveError: "Промяната не можа да се запише",
      deleteError: "Изтриването не успя",
      noRoom: "Няма място — маса {{name}} е твърде близо. Първо раздалечи масите.",
    },
  },
  tablesConfig: {
    title: "Конфигурация на маси",
    subtitle: "Номер и брой места на масите по райони — без схема",
    offlineHint:
      "Масите се пазят в облака — промените са възможни, щом интернетът се върне.",
    empty: {
      title: "Първо създай район",
      description:
        "Масите стоят в райони — зала, тераса или бар. Създай първия и добави масите само с номер и брой места.",
      cta: "Създай район",
    },
    listEmpty: "Още няма маси в този район. Добави първата от „Нови маси“.",
    searchPlaceholder: "Търси по номер…",
    clearSearch: "Изчисти търсенето",
    seatsLess: "Едно място по-малко",
    seatsMore: "Едно място повече",
    grid: {
      kicker: "Маси · {{region}}",
      selectAll: "Избери всички",
      filterAll: "Всички",
      selectTable: "Избери маса {{name}}",
      newTable: "Нова маса",
      noMatches: "Няма маси, които отговарят на търсенето.",
    },
    newTables: {
      kicker: "Нови маси",
      title: "Добави в „{{region}}“",
      single: "Една маса",
      series: "Серия номера",
      number: "Номер",
      numbers: "Номера от – до",
      from: "От",
      to: "До",
      seats: "Места на маса",
      add: "Добави маса",
      addMany_one: "Добави {{count}} маса",
      addMany_other: "Добави {{count}} маси",
      seriesInvalid: "Въведи числа от – до, като „до“ не е по-малко от „от“",
      seriesTooMany: "Най-много {{max}} маси наведнъж",
      seriesNothingFree: "Всички номера в този диапазон са заети",
      seriesSkippedHint_one: "{{count}} зает номер ще бъде пропуснат",
      seriesSkippedHint_other: "{{count}} заети номера ще бъдат пропуснати",
      placementHint:
        "Масата се нарежда сама в района. Мястото ѝ може да се промени в „<link>Схема на заведението</link>“.",
    },
    edit: {
      title: "Маса {{name}}",
      seats: "Места",
      region: "Район",
      save: "Запази",
      delete: "Изтрий масата",
      close: "Затвори",
    },
    bulk: {
      title_one: "Избрана {{count}} маса",
      title_other: "Избрани {{count}} маси",
      seats: "Места на всички",
      apply: "Приложи",
      moveTo: "Премести в район",
      chooseRegion: "Избери район…",
      move: "Премести",
      delete: "Изтрий избраните",
      cancel: "Откажи избора",
      edit: "Редактирай",
    },
    delete: {
      title: "Изтриване на маса {{name}}",
      description:
        "Масата изчезва и от схемата, и от резервациите. Маса с резервация или отворена сметка не може да се изтрие.",
      titleMany: "Изтриване на {{count}} маси",
      descriptionMany:
        "Маси {{names}} изчезват и от схемата, и от резервациите. Масите с резервация или отворена сметка се пропускат.",
      confirm: "Изтрий",
    },
    messages: {
      created: "Маса {{name}} е добавена",
      seriesCreated_one: "Добавена е {{count}} маса",
      seriesCreated_other: "Добавени са {{count}} маси",
      seriesSkipped: "Пропуснати заети номера: {{names}}",
      seatsApplied_one: "Местата са сменени на {{count}} маса",
      seatsApplied_other: "Местата са сменени на {{count}} маси",
      moved: "Маса {{name}} е преместена в „{{region}}“",
      movedMany_one: "{{count}} маса е преместена в „{{region}}“",
      movedMany_other: "{{count}} маси са преместени в „{{region}}“",
      deleted: "Маса {{name}} е изтрита",
      deletedMany_one: "Изтрита е {{count}} маса",
      deletedMany_other: "Изтрити са {{count}} маси",
      deleteSkippedInUse: "Не са изтрити (резервация или отворена сметка): {{names}}",
      notFitted: "Масата не се събра в района — може да се подреди в „Схема на заведението“",
      saveError: "Промяната не можа да се запише",
      deleteError: "Изтриването не успя",
    },
  },
  companiesConfig: {
    title: "Фирми",
    listKicker: "Списък фирми",
    addCompany: "Добави фирма",
    searchPlaceholder: "Търси по име, обект или ЕИК",
    colName: "Име",
    colEik: "ЕИК",
    colVat: "ДДС №",
    colActions: "Действия",
    badgeDefault: "Текуща",
    noCompanies: "Няма добавени фирми",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",

    createTitle: "Нова фирма",
    createSubtitle: "Въведете данните за фактуриране",
    editTitle: "Редакция на фирма",
    editSubtitle: "Редактирайте данните за фактуриране",

    secBasic: "Основни данни",
    secIdentity: "Идентификация и контакти",
    secNumbering: "Номерация на документи",
    secInvoicePrinting: "Печат на фактури",
    fieldInvoicePrinter: "POS принтер за фактури",
    fieldInvoicePrinterHint:
      "Фактурите на фирмата излизат на този принтер, от която и каса да са издадени. „POS принтерът на оператора“ — както досега: принтерът на касата, от която се печата.",
    invoicePrinterOperator: "POS принтерът на оператора",
    secBanks: "Банкови сметки",

    fieldName: "Име на фирмата",
    fieldNamePlaceholder: 'Напр. "Тест ООД"',
    fieldObjectName: "Име на обекта",
    fieldObjectNamePlaceholder: 'Напр. "Тест обект"',
    fieldAddress: "Адрес",
    fieldAddressPlaceholder: "Седалище и адрес на управление",
    fieldMol: "МОЛ",
    fieldMolPlaceholder: "Материално отговорно лице",
    fieldEik: "ЕИК / БУЛСТАТ",
    fieldEikHint: "9 или 13 цифри",
    fieldEikValid: "Валиден ЕИК — контролната сума излиза",
    fieldVatFromEik: "Попълни BG{{eik}}",
    fieldVat: "ДДС №",
    fieldVatHint: "Формат BG + 9 или 10 цифри (по желание)",
    fieldPhone: "Телефон",
    fieldEmail: "E-mail",

    fieldDefault: "Това е текущата фирма",
    fieldDefaultDesc:
      "Документите ще се издават с тези данни. Само една фирма може да е текуща.",

    fieldLastInvoice: "Последен номер на фактура",
    fieldLastInvoicePlaceholder: "Напр. 0000000034",
    fieldLastInvoiceHint:
      "Последният ВЕЧЕ издаден номер. 0 = още няма издадена фактура.",
    fieldLastProforma: "Последна проформа",
    fieldLastProformaHint: "Формат: П-2026-0001",
    numberingNextKicker: "Следващ документ",
    numberingNextInvoice: "Фактура №",
    numberingNextUnknown:
      "Попълнете последния издаден номер, за да се види с кой номер тръгва следващата фактура.",

    addBank: "Добави банка",
    noBanks: "Все още няма добавени банкови сметки",
    bankIndex: "Банка #{{index}}",
    bankName: "Име на банка",
    bankAddDraft: "Нова банкова сметка",
    bankEditDraft: "Редакция на банкова сметка",
    bankConfirm: "Запази банка",
    bankMakeDefault: "Направи по подразбиране",
    draftDirtyBlock:
      "Първо запазете или откажете текущата банкова сметка преди да продължите.",

    save: "Запази",
    create: "Създай",

    createSuccess: "Фирмата е създадена успешно",
    editSuccess: "Фирмата е обновена успешно",
    deleteSuccess: "Фирмата е изтрита успешно",
    createError: "Грешка при създаване",
    editError: "Грешка при редакция",
    deleteError: "Грешка при изтриване",

    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете фирма "{{name}}"?',

    errRequired: "Полето е задължително",
    errInvalidEik: "Невалиден ЕИК/БУЛСТАТ",
    errInvalidVat: "Очакван формат: BG + 9 или 10 цифри",
    errInvalidEmail: "Невалиден e-mail",
    errInvalidBic: "Невалиден BIC код",
    errInvalidIban: "Невалиден IBAN",
    errInvalidInvoiceNumber: "Невалиден номер",
    errInvalidProforma: "Очакван формат: П-2026-0001",
  },

  monitors: {
    title: "Монитори",
    kitchenBadge: "Кухненски",
    shpickerBadge: "Шпикер",
    waiterBadge: "Сервитьорски",
    selectStation: "Изберете станция",
    connected: "Свързан",
    disconnected: "Изключен",
    connecting: "Свързване...",
    noOrders: "Няма поръчки",
    unfulfilled: "Неизпълнени",
    fulfilled: "Изпълнени",
    noAssignedStations: "Няма назначени станции",
    contactAdmin:
      "Свържете се с администратор за да ви бъдат назначени станции",
    inProgress: "В процес",
    complete: "Изпълни",
    return: "Върни",
    // Името на статуса при посочване на иконата на реда (statusIcon.tsx).
    statusNotStarted: "Незапочнато",
    statusInProgress: "В процес",
    statusCooked: "Сготвено",
    statusIssued: "Издадено",
    statusServed: "Сервирано",
    noActiveOrders: "Няма активни поръчки",
    newOrdersWillAppear: "Новите поръчки ще се появят автоматично",
    // Мъртъв канал изглежда точно като спокойна кухня — затова празният екран
    // казва КОЯ от двете е (docs/edge.md §5.3).
    noConnection: "Няма връзка",
    noConnectionHint:
      "Екранът не е свързан — нови поръчки НЕ пристигат. Извикай отговорник.",
    refresh: "Опресни",
    soundOn: "Включи звука",
    soundOff: "Изключи звука",
    selected: "Избрани: {{count}}",
    minuteShort: "м",
    // Подсказката на „+6м" — закъснението на реда спрямо времето за приготвяне
    overdueBy: "Закъснява с {{time}}",
    // Клик по ред/отметка, който стои на екрана, но не се пипа (lockedRowHint.ts)
    serveAfterStatus: "Сервира се след статус „{{status}}“",
    issuedLockedHint: "Издадено от шпикера — връща се само от шпикера",
    navUp: "Един продукт нагоре",
    navDown: "Един продукт надолу",
    navUp2: "Два продукта нагоре",
    navDown2: "Два продукта надолу",
    colStatus: "Статус",
    colTable: "Маса",
    colProduct: "Артикул",
    colElapsed: "Време",
    colQty: "Кол.",
    colTotal: "Общо",
    colOperator: "Оператор",
    colOrderTime: "Поръчано",
    additionToProduct: "(към {{product}})",
    additionToProductFromStation: "(към {{product}} от {{station}})",
    stationPartDone: "готово",
    stationPartInProgress: "в процес",
    stationPartWaiting: "чака",
    // Подтекстът на цял ред (шпикер/сервитьорски): иконката до станцията
    // (клош / часовник) — aria-label и title.
    stationPartReady: "готово",
    stationPartNotReady: "не е готово",
    // Подтекстът „(към Бургер)" на добавка, чието ястие не стои над нея в
    // таба: иконката (клош / часовник) — aria-label и title.
    mainProductReady: "Ястието е готово",
    mainProductNotReady: "Ястието още не е готово",
    // Сервитьорският монитор: сервирането (или връщането) не мина — BE
    // текстът (напр. „сервира се след …“), иначе този.
    serveFailed: "Редът не се сервира — опитайте отново",
    // Отметката пред реда в „Решетка": Изпълни / Върни само за този ред.
    checkboxComplete: "Изпълни реда",
    checkboxReturn: "Върни реда",
    // Отметката в заглавието на поръчката („Решетка" и „Таблица"): за всичките ѝ редове.
    checkboxCompleteOrder: "Изпълни поръчката",
    checkboxReturnOrder: "Върни поръчката",
    // Филтърът по станции горе на монитора (кутийките до заглавието)
    stationFilterTitle: "Станции",
    stationFilterAll: "Всички",
    // Изглед „Таблица"
    // Невидимите дръжки за размера в трите изгледа (подсказка при посочване)
    resize: {
      gridColumnWidth: "Плъзнете за по-широки или по-тесни колони. Двоен клик — по подразбиране.",
      gridCardHeight: "Плъзнете за по-големи или по-малки редове. Двоен клик — по подразбиране.",
      gridCard: "Плъзнете за размера на кутийките. Двоен клик — по подразбиране.",
      gridRowHeight: "Плъзнете за по-високи или по-ниски редове. Двоен клик — по подразбиране.",
      boardColumns: "Плъзнете за колоните на екрана. Двоен клик — по подразбиране.",
      boardRows: "Плъзнете за редовете на екрана. Двоен клик — по подразбиране.",
      boardCells: "Плъзнете за размера на клетките. Двоен клик — по подразбиране.",
      boardSlots: "Плъзнете за редовете в клетка. Двоен клик — по подразбиране.",
      listRowHeight: "Плъзнете за височината на редовете. Двоен клик — средна.",
    },
    boardNothingSelected: "Няма избрана поръчка",
    boardSelectedOrder: "Избрана: #{{table}} · {{waiter}}",
    // Клавишите в долната лента на „Таблица" — само позволените действия
    // (BoardSelectionLabel), свързани с „ · ".
    boardKeysSelect: "↑ ↓ ← → избор",
    boardKeysComplete: "+ изпълни",
    boardKeysReturn: "− върни",
    // Шпикер: „Изпълни" на ястие, чиито видими добавки остават в
    // „Неизпълнени" — въпрос точно преди изпращането.
    issueWithoutAdditionsTitle: "Изпълни без добавките?",
    issueWithoutAdditionsLine:
      "Ще изпълните „{{dish}}“ от маса #{{table}} без добавките: {{additions}}.",
    issueWithoutAdditionsCancel: "Откажи",
  },

  inventoryPage: {
    moduleLabel: "Модул Складова база",
    backToModules: "Към модулите",
    collapse: "Свий",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    delivery: "Доставка",
    refresh: "Опресни",
    // Таблица доставки
    newDelivery: "Нова доставка",
    colDate: "Дата",
    colInvoice: "Фактура №",
    colSupplier: "Доставчик",
    colWarehouse: "Склад",
    colProducts: "Продукти",
    colValue: "Стойност",
    colType: "Тип",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    colBatch: "Партида",
    colExpiry: "Срок",
    stxRestockLabel: "Заприходяване",
    colProductName: "Продукт",
    colPackaging: "Разфасовка",
    colNet: "Сума без ДДС",
    lotSource: "Източник",
    lotSource_delivery: "Доставка",
    lotSource_stocktake: "Инвентаризация",
    lotSource_transfer: "Прехвърляне",
    lotSource_substitution: "Замяна",
    lotSource_writeoff: "Изписване",
    lotSource_scrap: "Бракуване",
    lotSource_report: "Разнасяне на отчет",
    colGross: "Сума с ДДС",
    colUnit: "Мерна единица",
    filterApply: "Приложи",
    filterReset: "Нулирай",
    filterSearch: "Търсене във филтрите",
    filterSelectAll: "Избери всички",
    sectionConfig: "Настройки",
    settings: "Конфигурации",
    settingsVatSection: "Регистрация по ДДС",
    settingsWhSection: "Склад по подразбиране",
    woNeedsWarehouseHint: "Изберете склад по подразбиране (Настройки → Конфигурации) — без склад няма откъде да се изписва.",
    settingsWhHint:
      "Складът, който модулът ползва по подразбиране (за справки и нови операции).",
    settingsWhQuestion: "Склад по подразбиране:",
    settingsVatQuestion: "Фирмата регистрирана ли е по ДДС?",
    settingsVatHint:
      "Определя как се изчисляват сумите с и без ДДС в складовия модул и как се показват: при „Да“ всички суми в склада са без ДДС, при „Не“ — с ДДС, а цената в доставката се въвежда с ДДС — тази, която плащате на доставчика.",
    settingsVatYes: "Да, регистрирана",
    settingsVatNo: "Не",
    settingsSaved: "Настройките са запазени",
    fieldScrapReasonPh: "Изберете причина",
    kpiDeliveries: "Доставки",
    kpiValue: "Обща стойност",
    kpiProducts: "Продукти",
    products: "Продукти",
    noWarehouse: "Изберете склад, за да видите доставките.",
    noDeliveries: "Все още няма заприходени доставки за този склад.",
    noLines: "Няма продукти в тази доставка.",
    // Модал нова доставка
    fieldDate: "Дата на доставка",
    fieldInvoice: "Фактура №",
    fieldInvoicePh: "Въведете номер",
    fieldSupplier: "Доставчик",
    fieldSupplierPh: "Изберете доставчик",
    productAdd: "Нов продукт",
    productAddTitle: "Нов складов продукт",
    productAddHint:
      "Продуктът се записва в общия справочник на организацията.",
    productName: "Име",
    productNamePh: "Име на продукта",
    productNameRequired: "Името е задължително",
    productExportCode: "Код за експорт",
    productGroup: "Група",
    productGroupPh: "Изберете група",
    productUnit: "Мерна единица",
    productUnitPh: "Изберете единица",
    productUnitRequired: "Мерната единица е задължителна",
    productVat: "ДДС",
    productVatPh: "Изберете ДДС",
    productVatRequired: "ДДС е задължително",
    productMinQuantity: "Минимално количество",
    productWastePct: "Фира",
    productPackagings: "Разфасовки",
    productPackagingsPh: "Изберете разфасовки",
    productPackagingsHint:
      "Разфасовките, в които се доставя продуктът (напр. каса, стек).",
    productTrackBatch: "Следене на партида",
    productTrackExpiry: "Следене на срок на годност",
    productSaved: "Продуктът е записан",
    supplierAdd: "Нов доставчик",
    supplierAddTitle: "Нов доставчик",
    supplierAddHint:
      "Доставчикът се записва в общия справочник на организацията.",
    supplierName: "Име",
    supplierNamePh: "Име на доставчика",
    supplierNameRequired: "Името е задължително",
    supplierEik: "ЕИК",
    supplierEikPh: "напр. 123456786",
    supplierEikInvalid: "Невалиден ЕИК (9 или 13 цифри с контролна цифра)",
    supplierVatNumber: "ДДС номер",
    supplierVatNumberPh: "напр. BG123456786",
    supplierVatNumberInvalid: "Невалиден ДДС номер (BG + 9 или 10 цифри)",
    supplierVatNumberHint:
      "Без ДДС номер доставката не начислява ДДС — сумата с ДДС остава равна на сумата без ДДС.",
    supplierSaved: "Доставчикът е записан",
    fieldTemplate: "От минала доставка",
    fieldTemplatePh: "Изберете доставка като шаблон",
    templateOptionProducts: "{{count}} прод.",
    // Работен лист „Нова доставка" (страница)
    backToDeliveries: "Към доставките",
    wsSaveChanges: "Запази промените",
    wsSearchPh: "Добавете продукт — просто започнете да пишете, напр. „домати“",
    wsClearRowHint: "Премахни реда от доставката",
    reportLoadFailed: "Справката не се зареди",
    reportLoadFailedText: "Връзката със сървъра прекъсна или той върна грешка. Числата не са показани, за да не изглеждат като нули.",
    reportRetry: "Опитай пак",
    reportStale: "Обновяването не успя — показани са данните от {{time}}.",
    noMinSet: "Без зададен минимум",
    noPrice: "Няма цена",
    shortagePositions_one: "{{count}} позиция",
    shortagePositions_other: "{{count}} позиции",
    shortageWarehouses_one: "{{count}} склад",
    shortageWarehouses_other: "{{count}} склада",
    shortageUnpriced_one: "без цена: {{count}}",
    shortageUnpriced_other: "без цена: {{count}}",
    soldKpiCostCurrent: "Себестойност по текущи цени",
    soldRevenueAfterDiscounts: "След отстъпки",
    scLotsHintAsOf: "Партидите към края на {{date}} — по реда, в който се изписват; срокът е оценен към тази дата.",
    payUnpaidToday: "неплатено от днес",
    payUnpaidFor_one: "неплатено от {{count}} ден",
    payUnpaidFor_other: "неплатено от {{count}} дни",
    unknownProductName: "Продукт #{{id}}",
    wsColUnitPriceNet: "Ед. цена без ДДС",
    wsUnitPriceNetPer: "Ед. цена без ДДС / {{unit}}",
    // фирма без регистрация по ДДС: въвежда платеното (ENTERED_PRICE_LABELS в vatBasis.ts)
    wsColUnitPriceGross: "Ед. цена с ДДС",
    wsUnitPriceGrossPer: "Ед. цена с ДДС / {{unit}}",
    wsUnitPriceGrossHint: "Фирмата не е регистрирана по ДДС — въведете цената, която плащате (с ДДС)",
    // ръбът на заглавието в складовите решетки (`ColumnHeaderCells`)
    colResizeHint: "Влачете за ширина на колоната · двоен клик — ширината по подразбиране",
    // подсказките при задържане върху заглавията в доставката
    wsUnitPriceGrossDerivedHint: "Изчислява се от ед. цената без ДДС и ДДС ставката на продукта — не се въвежда",
    wsSumNetHint: "Количество × ед. цена без ДДС — или напишете сумата от документа",
    wsSumGrossHint: "Количество × ед. цена с ДДС — или напишете сумата от документа",
    wsStockShort: "Нал.",
    wsPriceShort: "Цена",
    wsWarehouseForNewRows: "Склад за новите редове",
    wsWhAskTitle: "Склад „{{to}}“ — и за въведените редове?",
    wsWhAskText_one: "{{count}} ред вече е в склад „{{from}}“.",
    wsWhAskText_other: "{{count}} реда вече са в склад „{{from}}“.",
    wsWhOnlyNew: "Само за новите редове",
    wsWhOnlyNewHint: "Въведените остават в „{{from}}“, новите редове отиват в „{{to}}“.",
    wsWhAlsoExisting_one: "И за съществуващия ред",
    wsWhAlsoExisting_other: "И за съществуващите {{count}} реда",
    wsWhAlsoExistingHint: "Редовете от „{{from}}“ минават в „{{to}}“. Редове в друг склад не се пипат.",
    wsAddRow: "Още ред за продукта",
    wsAddRowHint: "Още ред за продукта — друг склад, партида, срок или цена",
    // панелът „Колони" на складовите таблици
    wsColumnWaiting: "Колоната се вижда сама — в листа има ред, който я ползва или чака попълване в нея",
    colInternalNumber: "№ (вътрешен номер)",
    // 0.0.319: нова доставка без склад; вече добавен продукт; започната инвентаризация
    wsPickWarehouseFirst: "Първо изберете склад",
    wsRepeatTitle: "„{{name}}“ вече е в доставката",
    wsRepeatTitleMany_one: "{{count}} продукт вече е в доставката",
    wsRepeatTitleMany_other: "{{count}} продукта вече са в доставката",
    wsRepeatText_one: "Може да го добавите на нов ред — например с друго количество или цена.",
    wsRepeatText_other: "Може да ги добавите на нови редове — например с друго количество или цена.",
    wsRepeatCaption: "Вече в доставката",
    wsRepeatNewRow: "Нов ред за „{{name}}“",
    wsRepeatNewRows: "Нов ред за всеки",
    wsRepeatNewRowHint: "Свое количество, цена, склад и партида — може и същите като в другия ред.",
    wsRepeatExisting_one: "Към съществуващия ред",
    wsRepeatExisting_other: "Към съществуващите редове",
    wsRepeatExistingHint: "Курсорът отива в реда, който вече е в доставката.",
    wsRepeatExistingCatalogHint_one: "Въведеното количество заменя това в реда.",
    wsRepeatExistingCatalogHint_other: "Въведените количества заменят тези в редовете.",
    wsProductRowOf: "ред {{index}} от {{count}}",
    wsProductRowsHint_one: "„{{name}}“ е на {{count}} ред в доставката — всеки е отделна партида",
    wsProductRowsHint_other: "„{{name}}“ е на {{count}} реда в доставката — всеки е отделна партида",
    wsStocktakeToday_one: "Днес има започната инвентаризация",
    wsStocktakeToday_other: "Днес има {{count}} започнати инвентаризации",
    wsStocktakeStarted: "започната {{when}}",
    docPickDayFirst: "Първо изберете дата",
    docPastDay_one: "Датата е по-стара от текущата — вчера",
    docPastDay_other: "Датата е по-стара от текущата — преди {{count}} дни",
    wsClearAll: "Изчисти",
    wsClearAllTitle: "Да изчистя ли доставката?",
    wsClearAllText_one: "{{count}} ред излиза от листа.",
    wsClearAllText_other: "Всички {{count}} реда излизат от листа.",
    wsClearAllUndo: "Веднага след това можете да ги върнете с „Отмени“.",
    wsClearAllOk: "Изчисти доставката",
    wsClearAllDone_one: "Листът е изчистен ({{count}} ред)",
    wsClearAllDone_other: "Листът е изчистен ({{count}} реда)",
    undo: "Отмени",
    tplReplaced: "Листът е заменен с доставката от {{date}}",
    tplAskTitle: "Доставката от {{date}} — в листа",
    tplAskText: "В листа вече има въведени редове.",
    tplAdd: "Добави липсващите продукти",
    tplAddHint: "Добавя продуктите от тази доставка, които още ги няма в листа. Въведеното остава.",
    tplReplace: "Замени листа",
    tplReplaceHint: "Листът става тази доставка. Предишните редове се връщат с „Отмени“.",
    fieldTime: "Час",
    saveMomentLabel: "Дата и час",
    conflictSomeone: "друг потребител",
    conflictTitle: "Документът е променен от {{who}}",
    conflictText: "Докато го редактирахте, {{who}} записа промени. Вашите промени са още тук — нищо не е загубено.",
    conflictTextWhen: "{{who}} го записа в {{when}}, докато го редактирахте. Вашите промени са още тук — нищо не е загубено.",
    conflictView: "Виж текущия документ",
    conflictViewHint: "Записаният документ и „История на промените“. Листът с вашите промени остава.",
    conflictOverwrite: "Запиши моята версия",
    conflictOverwriteHint: "Записва вашия вариант. Промените на {{who}} остават в „История на промените“.",
    conflictDiscard: "Откажи моите промени",
    conflictDiscardHint: "Листът се зарежда наново от записания документ. Вашите промени се губят.",
    wsNoMatch: "Няма съвпадение",
    wsLastPrice: "посл. цена",
    wsSoldWithoutStock: "−{{qty}} продадени без наличност",
    wsSoldWithoutStockHint: "Продадено е повече, отколкото е имало в склада. Доставка с по-късна дата от продажбите влиза цяла (минусът се отписва); доставка с датата на продажбите го покрива.",
    wsPricesFromSupplier: "Цени и посл. доставка от: {{name}}",
    wsResultsCount_one: "{{count}} резултат",
    wsResultsCount_other: "{{count}} резултата",
    wsAddedTag: "Добавен",
    wsNoLastDelivery: "без предишна доставка",
    wsNoSupplierDelivery: "няма доставка от този доставчик",
    wsEmptyTitle: "Няма добавени продукти",
    wsEmptyHint:
      "Намерете продукт с търсачката горе и натиснете Enter — редът се добавя тук, а фокусът отива направо в „Количество“.",
    wsEmptyKbdType: "пишете отвсякъде",
    wsEmptyKbdEnter: "добавя продукта",
    wsEmptyKbdEsc: "връща в търсачката",
    wsUnitTotals: "Общо количества",
    // Работен лист „Изписване" (страници създаване/редакция)
    backToWriteoffs: "Към изписванията",
    woSearchPh:
      "Добавете продукт или рецепта — просто започнете да пишете, напр. „домати“",
    woEmptyTitle: "Няма добавени редове",
    unitPortions: "порции",
    woEmptyHint:
      "Намерете продукт или рецепта с търсачката горе и натиснете Enter — редът се добавя тук, а фокусът отива направо в „Количество“.",
    draftRestoreTitle: "Незавършена доставка",
    draftRestoreTitleBy: "Незавършена доставка от {{name}}",
    draftRestoreSavedAt: "Запазена на",
    draftRestoreTotal: "Общо",
    draftRestoreQuestion: "Искате ли да продължите откъдето спряхте?",
    draftRestoreContinue: "Продължи",
    draftRestoreStartOver: "Започни наново",
    fieldWarehouse: "Склад",
    fieldWarehousePh: "Изберете склад",
    fieldProduct: "Продукт",
    fieldProductPh: "Изберете продукт",
    productOptStock: "Наличност",
    productOptLastDelivery: "Посл. доставка",
    fieldUnitPrice: "Ед. цена",
    fieldNote: "Бележка",
    fieldNotePh: "Незадължителна бележка към доставката",
    addRow: "Добави ред",
    total: "Общо",
    // Основа + ДДС в „Общо" (само при фирма, регистрирана по ДДС)
    totalBase: "Основа",
    totalVat: "ДДС",
    colComment: "Коментар",
    colUser: "Потребител",
    cancel: "Отказ",
    submit: "Заприходи",
    created: "Доставката е заприходена",
    errWarehouse: "Изберете склад",
    errNoWarehouses:
      "Няма създаден склад. Създайте склад в организацията, преди да записвате движения.",
    errDate: "Изберете дата",
    errNoLines: "Добавете поне един валиден ред",
    errCreate: "Грешка при заприходяване",
    // Изписвания
    writeoff: "Изписване",
    newWriteoff: "Ново изписване",
    noWriteoffs: "Все още няма изписвания за този склад.",
    kpiWriteoffs: "Изписвания",
    colReason: "Причина",
    colNote: "Бележка",
    colAvailable: "Наличност",
    fieldReason: "Причина",
    fieldReasonPh: "Свободен текст",
    fieldComment: "Коментар",
    fieldCommentPh: "Незадължителен коментар",
    recipe: "Рецепта",
    selectRecipe: "Изберете рецепта",
    splitToProducts: "Раздели на продукти",
    revertToRecipe: "Върни в рецепта",
    confirmContinue: "Продължи",
    editDeliveryTitle: "Редакция на доставка",
    editWriteoffTitle: "Редакция на изписване",
    editSubmitWriteoff: "Редактирай изписване",
    edit: "Редакция",
    delete: "Анулирай",
    confirmDeleteTitle: "Анулиране на записа?",
    confirmDeleteBody:
      "Записът ще бъде анулиран и наличността преизчислена. Действието е необратимо.",
    deleted: "Записът е анулиран",
    errDelete: "Грешка при анулиране",
    errLoad: "Грешка при зареждане",
    confirmLeaveTitle: "Незапазени промени",
    confirmLeaveBody:
      "Имате незапазени промени. Да напуснете ли без запазване?",
    confirmLeave: "Напусни",
    confirmDeleteRowTitle: "Премахване на реда?",
    confirmDeleteRowBody: "Този ред ще бъде премахнат.",
    confirmSplitTitle: "Разделяне на рецептата?",
    confirmSplitBody: "Редът ще се замени с продуктите на рецептата.",
    confirmRevertTitle: "Връщане в рецепта?",
    confirmRevertBody:
      "Разделените продукти ще се съберат обратно в един ред-рецепта.",
    notePh: "Бележка",
    portionsPh: "Порции",
    recipeGroupLabel: "Рецепта",
    recipeEmpty: "Рецептата няма съставки",
    fifo: "FIFO (първа влязла)",
    fieldWriteoffDate: "Дата на изписване",
    batchShort: "Партида",
    noBatch: "Без партида",
    remainShort: "Остатък",
    expiryShort: "Срок",
    noExpiry: "без срок на годност",
    writeoffSubmit: "Изпиши",
    writeoffCreated: "Изписването е записано",
    errWriteoff: "Грешка при изписване",
    errStock: "Не може да се изпише повече от наличното: {{products}}",
    // Бракуване (scrap) — 1:1 с изписването, различен тип + причина за брак
    scrap: "Бракуване",
    scrapReasonExpired: "Изтекъл срок",
    scrapReasonSpoiled: "Развалена стока",
    scrapReasonBroken: "Счупен/разсипан",
    scrapReasonMismatch: "Несъответствие",
    scrapReasonVoidMarking: "Брак от Маркиране",
    docScrapTitle: "Документ за бракуване",
    docScrapSubtitle: "Бракуване №{{id}}",
    docScrapHeading: "Бракуване на стока",
    // Прехвърляне между складове (transfer)
    // Прехвърляне — списък и работен лист (0.0.155)
    backToTransfers: "Към прехвърлянията",
    trxNotePh: "Незадължителна бележка",
    trxDirection: "Направление",
    trxRemains: "Остава {{warehouse}}",
    trxBecomes: "Става {{warehouse}}",
    trxLastPrice: "посл. цена {{price}}",
    trxNoPrice: "няма доставна цена",
    transfer: "Прехвърляне",
    newTransfer: "Ново прехвърляне",
    editTransferTitle: "Редакция на прехвърляне",
    transferSubmit: "Прехвърли",
    editSubmitTransfer: "Редактирай прехвърляне",
    transferCreated: "Прехвърлянето е записано",
    errTransfer: "Грешка при прехвърляне",
    noTransfers: "Все още няма прехвърляния за този склад.",
    kpiTransfers: "Прехвърляния",
    colFromWarehouse: "От склад",
    colToWarehouse: "Към склад",
    fieldFromWarehouse: "От склад",
    fieldFromWarehousePh: "Склад-източник",
    fieldToWarehouse: "Към склад",
    fieldToWarehousePh: "Склад-цел",
    errFromWarehouse: "Изберете склад-източник",
    errToWarehouse: "Изберете склад-цел",
    errSameWarehouse: "Източник и цел трябва да са различни складове",
    docTransferTitle: "Документ за прехвърляне",
    docTransferSubtitle: "Прехвърляне №{{id}}",
    docTransferHeading: "Прехвърляне между складове",
    errRecipe: "Грешка при зареждане на рецептата",
    // Разпределяне по складове + документ
    // Подсказки какво липсва, за да е активен бутонът „Заприходи"
    issueQty: "Въведете количество за: {{products}}",
    issuePrice: "Въведете ед. цена за: {{products}}",
    issueWarehouse: "Изберете склад на реда за: {{products}}",
    issueBatch: "Попълнете партида за „{{product}}“ (задължителна)",
    issueExpiry: "Попълнете срок на годност за „{{product}}“ (задължителен)",
    issueBatchFor: "Попълнете партида (задължителна) за: {{products}}",
    issueExpiryFor: "Попълнете срок на годност (задължителен) за: {{products}}",
    issueEmpty: "Добавете поне един продукт с количество, цена и склад",
    // Инвентаризация
    stocktake: "Инвентаризация",
    sectionReports: "Справки",
    stocktakeSubmit: "Потвърди инвентаризацията",
    newStocktake: "Нова инвентаризация",
    editStocktakeTitle: "Редакция на инвентаризация",
    editSubmitStocktake: "Запази промените",
    stocktakeCreated: "Инвентаризацията е записана",
    errStocktake: "Грешка при инвентаризация",
    // 409 `substitution_exceeds_stocktake` — остаряла замяна (stocktakeSubstitutionConflict.ts)
    substitutionConflictDonor:
      "Замените са остарели: „{{product}}“ трябва да даде {{requested}}, а преброеният излишък е {{available}}. Коефициентът или наличността са се променили — замените са презаредени. Прегледайте ги и запишете отново; преброеното е запазено.",
    substitutionConflictRecipient:
      "Замените са остарели: за „{{product}}“ се покриват {{requested}}, а липсата е {{available}}. Коефициентът или наличността са се променили — замените са презаредени. Прегледайте ги и запишете отново; преброеното е запазено.",
    errNoCounts: "Въведете поне един преброен продукт",
    colSystem: "Търсено",
    colCounted: "Намерено",
    colDiff: "Разлика",
    colStatus: "Статус",
    statusEqual: "равен",
    statusSurplus: "излишък",
    statusShortage: "липса",
    statusSubstitute: "заместване",
    kpiSurplus: "Излишък",
    kpiShortage: "Липси",
    hideZeroStock: "Скрий без наличност",
    stockAsOfField: "Към дата",
    stockAsOfNow: "Към днес",
    stockAsOfNote: "Количества към края на {{date}} · стойности по текущи цени",
    stockGrossCurrentPrices: "Стойност с ДДС по текущи цени",
    stockNetCurrentPrices: "Стойност без ДДС по текущи цени",
    showZeroStock: "Покажи всички",
    stocktakeReasonPh: "Бележка / причина (по избор)",
    noProducts: "Няма продукти в този склад",
    noStocktakes: "Няма инвентаризации за периода",
    colSurplus: "Излишък",
    colShortage: "Липси",
    colNetValue: "Стойност без ДДС",
    colGrossValue: "Стойност с ДДС",
    // Справка „Наличности"
    stockReport: "Наличности",
    searchStockPh: "Търси по продукт, категория, фира…",
    colCategory: "Категория",
    colGroup: "Група",
    stockLotsSubtitle: "Хронология на движенията",
    stockLotsEmpty: "Няма движения за този продукт.",
    colMinQty: "Мин. наличност",
    colWaste: "Фира",
    colAvgPrice: "Ср. цена с ДДС",
    colAvgPriceNet: "Ср. цена без ДДС",
    colLastPrice: "Последна доставна цена",
    // Съкратеният вариант — за таблици с много колони (Излишък от продажби)
    colLastPriceShort: "Посл. доставна цена",
    underMin: "Под минимума",
    nearMin: "До 20% над минимума",
    overMin: "Над 20% над минимума",
    kpiStocktakes: "Инвентаризации",
    // Инвентаризация — списък и работен лист (0.0.152)
    backToStocktakes: "Към инвентаризациите",
    groupByWarehouse: "Групирай по склад",
    groupStocktakesCount_one: "{{count}} инвентаризация",
    groupStocktakesCount_other: "{{count}} инвентаризации",
    fieldStocktakeDate: "Дата",
    colUnitShort: "Ед.",
    fieldStocktakeReason: "Бележка / причина (по избор)",
    stxSearchPh: "Търси продукт за преброяване…",
    stxCountedTag: "преброен",
    stxDraftTitleBy: "Незавършена инвентаризация от {{name}}",
    // Взаимозамени (секцията вдясно от таблицата)
    subPanelTitle: "Взаимозамени",
    subPanelPairs_one: "{{count}} двойка",
    subPanelPairs_other: "{{count}} двойки",
    subCoefficient: "Коеф.",
    subApply: "Замени",
    subRevert: "Отмени",
    subChipHint: "Участва във взаимозамяна",
    subNoSurplusLeft:
      "Излишъкът на този продукт вече е използван от друга замяна",
    // Взаимозаменяеми продукти
    interchange: "Взаимозаменяеми продукти",
    newInterchange: "Ново правило",
    newInterchangeTitle: "Създаване на взаимозаменяеми продукти",
    editInterchangeTitle: "Редакция на правило",
    backToInterchangeables: "Към взаимозаменяемите",
    interchangeSubmit: "Запази правилото",
    interchangeGroupProducts: "Продукти в групата",
    interchangeProductsSubtitle:
      "Всички изброени продукти могат да заместват един друг",
    interchangeAddProductPh: "Добавете продукт към групата…",
    interchangePairExample:
      "Числата са спрямо първия продукт; всяка друга двойка се получава от тях — напр.",
    interchangeHowApplies: "Как ще се прилага",
    interchangeCoef: "Коефициент",
    interchangeCoefHelp:
      "Коефициент = колко базови единици на групата е 1 единица от продукта (1:1 за равностойни, напр. 1 пюре = 0.7 сок). Приоритет = кой се ползва пръв при покриване; празно → продуктът с най-стара доставка.",
    interchangeSortIndex: "Приоритет",
    interchangeSortPh: "напр. 1",
    interchangeNeedTwo: "Групата трябва да съдържа поне 2 продукта",
    interchangeHintCol: "Коментар",
    interchangeHintPh: "Незадължителен коментар за групата",
    interchangeHint:
      "При липса на някой от продуктите в групата системата предлага изписване от останалите по показаните съотношения — при разнасяне на отчет и при инвентаризация.",
    interchangeSearchPh: "Продукт или коментар…",
    noInterchange: "Все още няма групи взаимозаменяеми продукти.",
    interchangeBadCoef: "Коефициентът трябва да е положително число",
    interchangeSaved: "Групата е записана",
    back: "Назад",
    substitutionsReport: "Взаимозаменени продукти",
    noSubstitutions: "Няма замени за периода.",
    subSearchPh: "Търси по продукт или тип…",
    // Справка „Анулирани дейности" (soft delete следа)
    deletedReport: "Анулирани дейности",
    deletedColWhen: "Анулирано на",
    deletedColDocDate: "Дата на документа",
    deletedColBy: "Анулирано от",
    deletedKpiCount: "Анулирани записи",
    deletedSearchPh: "Търси по вид, продукт или потребител…",
    noDeleted: "Няма анулирани дейности за периода.",
    deletedSubtitle: "Анулирано от {{who}} на {{when}}",
    deletedType_delivery: "Доставка",
    deletedType_writeoff: "Изписване",
    deletedType_scrap: "Бракуване",
    deletedType_stocktake: "Инвентаризация",
    deletedType_transfer: "Прехвърляне",
    deletedType_substitution: "Замяна",
    deletedType_report: "Разнасяне на отчет",
    deletedNetValue: "Стойност без ДДС",
    deletedRestore: "Възстанови",
    deletedRestoreTitle: "Възстановяване на записа?",
    deletedRestoreBody:
      "Записът ще се върне в нормалните списъци, а количествата му ще се приложат отново върху наличността.",
    deletedRestored: "Записът е възстановен",
    errRestore: "Грешка при възстановяване",
    colSubCount: "Брой замени",
    subSourceStocktake: "При инвентаризация",
    subColFrom: "От (донор)",
    subColTo: "На (получател)",
    subWrittenOff: "Изписано",
    subCovered: "Покрито",
    // Страница „Излишък от продажби" (бивш „Недостиг" — недостиг от разнесени отчети)
    negativeReport: "Излишък от продажби",
    negSearchPh: "Продукт, склад или категория…",
    noNegative: "Няма продукти с отрицателна наличност.",
    kpiNegCount: "Продукти в недостиг",
    kpiNegNet: "Стойност без ДДС",
    kpiNegGross: "Стойност с ДДС",
    shortageTotal: "Общо непокрит излишък",
    shortageProductsCount_one: "{{count}} продукт",
    shortageProductsCount_other: "{{count}} продукта",
    shortageRowDelivery: "Доставка",
    colDeficitQty: "Количество",
    shortageBreakdownSubtitle: "Натрупан от отчети",
    shortageBreakdownHint:
      "Доставка покрива само отчети СЛЕД датата ѝ. За да занулиш по-стар недостиг, върни доставка със задна дата — на/преди отчета, който го е причинил.",
    compensateBackdated: "Компенсирай със задна дата",
    errSave: "Грешка при запис",
    docStocktakeTitle: "Документ за инвентаризация",
    docStocktakeSubtitle: "Инвентаризация №{{id}}",
    docStocktakeHeading: "Инвентаризация",
    docTitle: "Документ за доставка",
    docSubtitle: "Доставка №{{id}}",
    docHeading: "Заприходяване",
    docWriteoffTitle: "Документ за изписване",
    docWriteoffSubtitle: "Изписване №{{id}}",
    docWriteoffHeading: "Изписване на стока",
    // ─── Разнасяне на отчети ───────────────────────────────────────────────
    posting: "Разнасяне на отчети",
    soldProducts: "Продадени продукти",
    soldRecipes: "Продадени рецепти",
    newPosting: "Ново разнасяне",
    editPostingTitle: "Редакция на разнасяне",
    backToPostings: "Към разнасянията",
    kpiPostings: "Разнасяния",
    kpiPostedProducts: "Изписани продукти",
    kpiCompensations: "Компенсации",
    colReportNo: "Отчет №",
    colDateTime: "Дата и час",
    periodTotal: "Общо за периода",
    postingColSold: "Продадени",
    postingSoldRecipes: "рецепти",
    postingSoldProducts: "продукта",
    postingColCompensations: "Компенсации",
    postingSubsBadge: "{{count}} зам.",
    postingPickReport: "Изберете отчет",
    postingNoPending: "Няма неразнесени отчети",
    postingReportOption: "Отчет №{{number}} · {{date}}",
    postingPickSubtitle_one: "{{count}} неразнесен отчет на заведението",
    postingPickSubtitle_other: "{{count}} неразнесени отчета на заведението",
    postingPickBills_one: "{{count}} сметка",
    postingPickBills_other: "{{count}} сметки",
    postingPickTurnover: "Оборот",
    postingProductTag: "Продукт",
    postingRecipeTag: "Рецепта",
    postingColWarehouse: "Склад",
    postingWhSourceRecipe: "Склад от рецептата (избран за съставката в портала на организацията)",
    postingWhSourceStation: "Склад на станцията на рецептата",
    postingColAvail: "Наличност",
    postingColToWriteoff: "За изписване",
    colQtyShort: "К-во",
    postingColItem: "Артикул",
    postingTotalWriteoff: "Общо изписване",
    postingPerWarehouse: "по складове",
    postingCovered: "покрито",
    postingRemoveSub: "Премахни замяната (връща наличността на минус)",
    postingShortageSummary_one: "{{count}} продукт не достига",
    postingShortageSummary_other: "{{count}} продукта не достигат",
    postingNoShortage: "Всички продукти са налични",
    postingSplitMismatch: "Разпределеното не съвпада с нужното количество",
    postingCompTitle: "Компенсиране на липси",
    postingCompMarked: "{{applied}} от {{total}} отбелязани",
    postingCompSelectAll: "избери всички",
    postingCompApplied_one: "{{count}} компенсиран",
    postingCompApplied_other: "{{count}} компенсирани",
    postingSoldTitle: "Продадено",
    postingSoldPositions_one: "{{count}} позиция",
    postingSoldPositions_other: "{{count}} позиции",
    postingSoldTotalQty: "{{qty}} бр",
    postingSoldShow: "Покажи продаденото",
    postingSoldHide: "Скрий продаденото",
    postingSoldStationWarehouse: "→ склад {{name}}",
    postingSoldStationNoWarehouse: "без склад",
    postingScopeStation: "Станция",
    postingScopeWaiter: "Сервитьор",
    postingScopeAll: "Всички",
    postingScopeWhole: "Показан е целият отчет",
    postingScopeFiltered: "Филтърът е само за „Продадено“ · разнася се целият отчет",
    postingScopeFilteredBoth: "Показано е продаденото тук и продуктите му · разнася се целият отчет",
    postingSoldDirectProduct: "Изписва се директно като продукт",
    postingSoldRecipeError: "Рецептата не се зареди",
    postingSoldRecipeEmpty: "Рецептата няма съставки",
    postingSoldRecipeHint: "Покажи рецептата и само нейните продукти в изписването",
    postingFocusNote: "Само продуктите на {{name}}",
    postingTotalShown: "Общо за показаните",
    postingFilterNoProducts: "Нищо не се изписва за показаното",
    postingTotalsWhole: "за целия отчет",
    // Разбивката при отчета (под избраната карта / „Сервитьори и станции ▸")
    postingBreakdownStationsCount_one: "{{count}} станция",
    postingBreakdownStationsCount_other: "{{count}} станции",
    postingWriteoffTitle: "Изписване от склад",
    postingWriteoffProducts_one: "{{count}} продукт",
    postingWriteoffProducts_other: "{{count}} продукта",
    postingShortBadge_one: "{{count}} липса",
    postingShortBadge_other: "{{count}} липси",
    postingSaveEdit: "Запази промените",
    postingEditNone: "Няма разнесени отчети за избрания период",
    postingPosted: "Отчетът е разнесен",
    postingUpdated: "Промените са запазени",
    postingErr: "Грешка при разнасяне на отчета",
    postingNoRecipes: "Отчетът няма продадени артикули",
    postingMissingWarehouse: "Изберете склад за: {{names}}",
    postingPickWarehouse: "Изберете",
    postingNoWarehouseHint:
      "Изберете склад — или задайте склада на съставката в рецептата (портала на организацията) или складове на станциите (Организация → Меню → Станции)",
    postingConfirmTitle: "Затваряне на деня",
    postingConfirmEditTitle: "Запазване на промените",
    postingConfirmBody:
      "Има продукти с недостиг — те ще се изпишат с отрицателна наличност. Да продължим?",
    postingConfirmBodyOk:
      "Да разнесем ли отчета и да изпишем количествата от склада?",
    postingConfirmOk: "Разнеси отчета",
    postingDocTitle: "Документ разнасяне",
    postingDocSubtitle: "Разнасяне №{{id}}",
    postingDocHeading: "Разнасяне на отчет",
    // Справки: продадени продукти / рецепти
    soldColName: "Наименование",
    soldColSold: "Продадено (бр)",
    soldColTotalQty: "Общо количество",
    soldColAvgPrice: "Ср. цена с ДДС",
    soldColAvgPriceNet: "Ср. цена без ДДС",
    soldColIngredients: "Съставки",
    // Търсачката намира и по връзката рецепта ↔ продукт (sold/soldSearchModel):
    // до името — защо е намерен редът; под търсачката — какво е намерено
    soldSearchPhProduct: "Търси продукт или рецепта…",
    soldSearchPhRecipe: "Търси рецепта или продукт…",
    soldViaRecipe: "в {{list}}",
    soldViaIngredient: "съдържа {{list}}",
    soldMatchedMore: "и още {{count}}",
    soldQuotedName: "„{{name}}“",
    soldMatchedRecipes_one:
      "По рецепта {{names}} — показани са продуктите в нея. До името: колко е отишло в рецептата; колоните са общо за периода.",
    soldMatchedRecipes_other:
      "По рецепти {{names}} — показани са продуктите в тях. До името: колко е отишло във всяка; колоните са общо за периода.",
    soldMatchedProducts_one: "По продукт {{names}} — показани са рецептите, в които участва.",
    soldMatchedProducts_other: "По продукти {{names}} — показани са рецептите, в които участват.",
    // „Последна продажба" (само рецепти): колона, ред в картата, хедър на панела, Excel
    soldColLastSold: "Последна продажба",
    soldLastSoldLine: "последна продажба {{date}}",
    // Под търсачката — какво отваря клик на ред
    soldOpenHintRecipe: "Натиснете рецепта — продажбите по дни и по отчети",
    soldOpenHintProduct: "Натиснете продукт — складовата карта за периода",
    // Постоянното съобщение над таблицата (sold/SoldPostedOnlyNotice)
    soldPostedOnlyNotice:
      "Тук се броят само продажбите от разнесени отчети. Днешните се появяват, след като се направи отчетът на заведението и се разнесе.",
    soldPendingReports_one: "Чака разнасяне: {{count}} отчет",
    soldPendingReports_other: "Чакат разнасяне: {{count}} отчета",
    soldPostAction: "Разнеси",
    noSold:
      "Няма разнесени продажби за избрания период (справката показва само разнесени отчети)",
    soldKpiCount: "Брой",
    soldKpiQty: "Общо количество",
    soldKpiRevenue: "Оборот",
    close: "Затвори",
    print: "Принтирай",
    docEdit: "Редактирай",
    docDelete: "Анулирай",
    navDeliveryPayments: "Плащане на доставки",
    navPostedReports: "Разнесени отчети",
    navDeliveriesReport: "Доставки",
    navWriteoffsReport: "Изписвания",
    navStocktakesReport: "Инвентаризации",
    navTransfersReport: "Прехвърляния",
    // Менюто и табовете на документите (Документи → Доставки · Неплатени · Справка…)
    sectionDocuments: "Документи",
    navDeliveries: "Доставки",
    navWriteoffs: "Изписвания",
    navStocktakes: "Инвентаризации",
    navTransfers: "Прехвърляния",
    docTabsLabel: "Изгледи на документа",
    docTabCurrent: "Текущи",
    docTabUnpaid: "Неплатени",
    docTabArchive: "Справка",
    docTabByWarehouse: "По склад",
    docTabToPost: "За разнасяне",
    docPageYourDraft: "Вашата чернова",
    docPageDraftAutosaved: "запазена автоматично {{when}}",
    docPageContinue: "Продължи",
    docPageDelete: "Изтрий",
    docPagePendingTitle: "Чакат действие",
    docPagePendingNotesHint: "Стокови без фактура — когато доставчикът издаде обобщаваща фактура, въведете я оттук.",
    docPageSavedTodayTitle: "Записани днес",
    docPageOlderInArchive: "по-старите са в Справка",
    docPageEmptyDelivery: "Нямате чернова и днес още няма записани доставки.",
    docPageEmptyWriteoff: "Нямате чернова и днес още няма изписвания в този склад.",
    docPageEmptyTransfer: "Нямате чернова и днес още няма прехвърляния.",
    woNewOptions: "Бракуване с готова причина",
    // Долната лента на работния лист: състоянието на черновата и „Липсва: …"
    draftStateIdle: "Записва се автоматично",
    draftStateSaving: "Запазва се…",
    draftStateServer: "Запазено автоматично {{time}} · виждат го колегите",
    draftStateServerNoTime: "Запазено автоматично · виждат го колегите",
    draftStateLocal: "Запазено само в този браузър {{time}} — няма връзка със сървъра",
    draftStateFailed: "Черновата не се записва",
    missingTitle: "Липсва:",
    missingOnlyProblems: "Само проблемните",
    missingOnlyProblemsClear: "Покажи всички редове",
    missDate: "Дата",
    missDateFuture: "Не може да е в бъдещето",
    missInvoiceNumberHint: "Задължително при фактура",
    missScrapReasonHint: "Задължително при бракуване",
    missLines: "Продукти",
    missCounts: "Преброено",
    missRecipes: "Рецепти",
    missRowsQty_one: "{{count}} ред без количество",
    missRowsQty_other: "{{count}} реда без количество",
    missRowsPrice_one: "{{count}} ред без цена",
    missRowsPrice_other: "{{count}} реда без цена",
    missRowsBatch_one: "{{count}} ред без партида",
    missRowsBatch_other: "{{count}} реда без партида",
    missRowsExpiry_one: "{{count}} ред без срок",
    missRowsExpiry_other: "{{count}} реда без срок",
    missRowsWarehouse_one: "{{count}} ред без склад",
    missRowsWarehouse_other: "{{count}} реда без склад",
    missRowsShort_one: "{{count}} ред не стига",
    missRowsShort_other: "{{count}} реда не стигат",
    // Търсачката на работния лист: група „Вече в документа"
    searchGroupInDocument: "Вече в документа",
    searchGroupAdd: "Добави",
    searchInDocumentRow: "ред {{row}} · {{quantity}}",
    searchCounted: "преброено {{quantity}}",
    searchAddRow: "ред",
    searchAddRowHint: "Нов ред за същия продукт (друга партида) — Shift+Enter",
    stockLoading: "Наличността се зарежда",
    navHintDrafts_one: "{{count}} чернова",
    navHintDrafts_other: "{{count}} чернови",
    navHintUnpaid_one: "{{count}} неплатена",
    navHintUnpaid_other: "{{count}} неплатени",
    navHintToPost_one: "{{count}} за разнасяне",
    navHintToPost_other: "{{count}} за разнасяне",
    navCriticalReports_one: "{{count}} отчет закъснява",
    navCriticalReports_other: "{{count}} отчета закъсняват",
    navCriticalStocktakes_one: "{{count}} незавършена инвентаризация от вчера или по-рано",
    navCriticalStocktakes_other: "{{count}} незавършени инвентаризации от вчера или по-рано",
    navCriticalTotal_one: "{{count}} блокираща задача",
    navCriticalTotal_other: "{{count}} блокиращи задачи",
    postingArchiveRef: "Разнасяне на отчети → Справка",
    closeMenu: "Затвори менюто",
    openMenu: "Отвори менюто",
    kickerReport: "Справка",
    exportExcel: "Експорт в Excel",
    viewDocument: "Преглед на документа",
    rowMenu: "Още действия",
    showMore: "Покажи още ({{count}})",
    pdfHint: "В прозореца за печат изберете „Запази като PDF“",
    statusPosted: "Разнесен",
    statusAnnulled: "Анулиран",
    statusAnnulledStamp: "АНУЛИРАН",
    annulledBanner: "Анулиран на {{date}}",
    annulReason: "Причина",
    annulReasonPh: "напр. грешна рецептура",
    annulledToast: "Документ №{{number}} е анулиран",
    segAll: "Всички",
    segPosted: "Разнесени",
    segAnnulled: "Анулирани",
    colDocument: "Документ",
    colReport: "Отчет",
    colWrittenOff: "Изписани",
    colSubstitutions: "Замествания",
    kpiValueGross: "Обща стойност · с ДДС",
    kpiValueNet: "Обща стойност · без ДДС",
    periodTotalActive: "Общо за периода · без анулирани",
    postedNoDocs: "Няма документи за избрания период.",
    postedSearchPh: "Търсене по документ, отчет, потребител…",
    filterPostedBy: "Разнесъл",
    filterNoMatch: "Няма съвпадения",
    filterClear: "Изчисти",
    filterDone: "Готово",
    filterClearAll: "Изчисти всички",
    periodCustom: "Период",
    periodApply: "Приложи",
    periodPickStart: "Изберете начална дата",
    period_today: "Днес",
    period_yesterday: "Вчера",
    period_last7: "Последните 7 дни",
    period_last30: "Последните 30 дни",
    period_thisMonth: "Този месец",
    period_lastMonth: "Миналия месец",
    period_thisYear: "Тази година",
    prevMonth: "Предишен месец",
    nextMonth: "Следващ месец",
    month0: "Януари",
    month1: "Февруари",
    month2: "Март",
    month3: "Април",
    month4: "Май",
    month5: "Юни",
    month6: "Юли",
    month7: "Август",
    month8: "Септември",
    month9: "Октомври",
    month10: "Ноември",
    month11: "Декември",
    weekday_mon: "Пн",
    weekday_tue: "Вт",
    weekday_wed: "Ср",
    weekday_thu: "Чт",
    weekday_fri: "Пт",
    weekday_sat: "Сб",
    weekday_sun: "Нд",
    postingPendingSubtitle_one: "{{count}} неразнесен отчет · най-старият първи",
    postingPendingSubtitle_other: "{{count}} неразнесени отчета · най-старият първи",
    postingAllPostedTitle: "Всички отчети са разнесени",
    postingAllPostedText: "Новите отчети ще се появят тук след затваряне на деня.",
    postingViewPosted: "Виж разнесените отчети",
    postingPendingList: "Неразнесени отчети",
    postingAgeToday: "Днес",
    postingAgeYesterday: "Вчера",
    postingAgeDays_one: "{{count}} ден",
    postingAgeDays_other: "{{count}} дни",
    postingAgeLate_one: "Закъснял · {{count}} ден",
    postingAgeLate_other: "Закъснял · {{count}} дни",
    postingReportTitle: "Отчет №{{number}}",
    postingCardNumber: "№{{number}}",
    postingMetaClosed: "затворен {{time}}",
    postingMetaTurnover: "оборот {{amount}}",
    postingMetaWaiters_one: "{{count}} сервитьор",
    postingMetaWaiters_other: "{{count}} сервитьора",
    postingStatusShort_one: "{{count}} продукт с недостиг",
    postingStatusShort_other: "{{count}} продукта с недостиг",
    postingStatusWithSub: "{{count}} със заместител",
    postingStatusAllAvailable: "Всичко е налично",
    postingStatusNoWarehouse_one: "{{count}} продукт без склад",
    postingStatusNoWarehouse_other: "{{count}} продукта без склад",
    // кратките — в тясната карта на чакащ отчет (пълните са в подсказката)
    postingStatusNoWarehouseShort: "{{count}} без склад",
    postingStatusShortShort: "{{count}} с недостиг",
    postingStatusAllAvailableShort: "Налично",
    postingStatusReturned: "Върнат след анулиране на №{{number}}",
    postingStatusReturnedShort: "Върнат",
    postingCorrectsAnnulled: "Коригира анулиран №{{number}}",
    postingChipShort_one: "{{count}} продукт не достига",
    postingChipShort_other: "{{count}} продукта не достигат",
    postingChipSubstituted: "{{count}} заместени",
    postingRemaining_one: "{{count}} продукт ще остане на минус",
    postingRemaining_other: "{{count}} продукта ще останат на минус",
    postingCostError: "Цените не се заредиха",
    postingCostStale: "Цените не се опресниха — показани са последните заредени",
    postingCostRetry: "Опитай пак",
    postingCostMissing_one: "без цена: {{count}} продукт",
    postingCostMissing_other: "без цена: {{count}} продукта",
    postingCostMissingHint: "Няма отворени партиди в избрания склад за: {{names}}. Сумата без ДДС е без тях.",
    postingCostMissingHintGross: "Няма отворени партиди в избрания склад за: {{names}}. Сумата с ДДС е без тях.",
    postingPreviewErr: "Отчетът не се зареди",
    postingAlreadyPosted: "Отчетът вече е разнесен — списъкът се опреснява.",
    postingSubmitReport: "Разнеси Отчет №{{number}}",
    postingShortConfirmTitle: "Разнасяне с недостиг",
    postingShortConfirmBody: "Тези продукти ще се изпишат с отрицателна наличност. Да продължим?",
    postingShortConfirmOk: "Разнеси отчета",
    postingPostedToast: "Отчет №{{number}} е разнесен",
    // Съобщението след запис (`savedDocument/`): „Отвори" — модалът на място
    savedOpen: "Отвори",
    savedAnotherOne: "+ Още една",
    savedAnotherOneNeuter: "+ Още едно",
    postingLeaveBody: "Избраните замени за този отчет ще се загубят.",
    postingSubsTitle: "Замяна с взаимозаменяеми продукти",
    postingSubsHint: "Разпределете липсващото количество между един или няколко заместителя.",
    // Политиката на BE (service_report_unposting.py): сторно/възстановяване на сметка НЕ връща замените
    postingSubsNotReturned:
      "Замените не се връщат сами при сторно или възстановяване на сметка от отчета. Ако трябва — поправете ги ръчно: „Коригирай и разнеси повторно“ или „Анулирай“ в „Разнасяне на отчети“ → Справка.",
    postingAvailableShort: "налични",
    postingMissing: "Липсват {{qty}}",
    postingCoveredLabel: "Покрито",
    postingSubQty: "Количество от {{name}}",
    postingInsteadOf: "⇄ вместо {{name}}",
    postingCoveredNote: "⇄ {{qty}} {{unit}} покрити със заместител",
    postingManualCorrectionNote: "ръчно коригирано",
    postingManualCorrectionHint:
      "Ръчна корекция (служебен акаунт): въведеното се изписва вместо количеството по продажбите. Празно поле — обратно към продажбите.",
    postingManualCorrectionLockedNote: "ръчно коригирано от служебния акаунт",
    postingManualCorrectionLockedHint:
      "Количеството е поправено от служебния акаунт и се изписва вместо продажбите. Само той може да го промени или да го върне по продажбите; разпределението по складове можете да сменяте.",
    postingBySales: "по продажби: {{qty}}",
    postingResetToSales: "Върни по продажби",
    postingColAfter: "След",
    postingPositions_one: "{{count}} позиция",
    postingPositions_other: "{{count}} позиции",
    postingPositionsShown_one: "{{shown}} от {{count}} позиция",
    postingPositionsShown_other: "{{shown}} от {{count}} позиции",
    postingDocTitleNo: "Документ разнасяне №{{number}}",
    postingDocSoldTitle: "Продадено по отчета",
    postingDocSoldLoading: "Продаденото се зарежда…",
    postingDocSoldError: "Продаденото не се зареди",
    postingDocSoldHint: "Покажи продуктите, които изписва",
    postingDocSoldCurrentRecipe: "по текущата рецепта — разнасяне отпреди снимката на рецептите",
    postingDocSoldNotPosted: "Не е изписван по това разнасяне",
    postingRepost: "Коригирай и разнеси повторно",
    postingRepostHint: "Анулира и отваря отчета наново",
    postingRepostTitle: "Корекция на документ №{{number}}",
    postingRepostText: "Изписаните количества се връщат в склада, а Отчет №{{report}} се отваря за ново разнасяне с досегашните замени.",
    postingRepostConfirm: "Анулирай и коригирай",
    postingAnnulTitle: "Анулиране на документ №{{number}}",
    postingAnnulText: "Изписаните количества се връщат в склада, а Отчет №{{report}} се връща в „Разнасяне на отчети“.",
    printShort: "Печат",
    chipSearch: "Търсене: „{{q}}“",
    colDocType: "Тип",
    colLinks: "Връзки",
    colNoteNo: "Стокова №",
    colPayment: "Плащане",
    deliveriesNone: "Няма доставки за този филтър.",
    deliveriesResult_one: "{{count}} доставка",
    deliveriesResult_other: "{{count}} доставки",
    deliveriesSearchPh: "Търсене по номер, доставчик, продукт, потребител…",
    deliveriesSumHint: "(стоковите по фактура не се сумират)",
    deliveryAnnulTitle: "Анулиране на доставка",
    deliveryAnnulText: "Количествата се изваждат от склада. Документът остава в справката като анулиран.",
    deliveryAnnulOwnLines_one: "Собственият {{count}} ред се изважда от склада",
    deliveryAnnulOwnLines_other: "Собствените {{count}} реда се изваждат от склада",
    deliveryAnnulNoOwnLines: "Собствени редове няма — от склада не се изважда нищо",
    deliveryAnnulNotesStay_one: "{{count}} стокова остава заприходена и се връща в „Стокови без фактура“",
    deliveryAnnulNotesStay_other: "{{count}} стокови остават заприходени и се връщат в „Стокови без фактура“",
    deliveryAnnulStays: "Документът остава в справката като анулиран.",
    deliverySavedToast: "Доставка №{{number}} е записана",
    docHeadingNote: "Стокова разписка",
    docTypeInvoice: "Фактура",
    docTypeNote: "Стокова",
    draftStatusDraft: "Чернова",
    draftStatusHeld: "Задържана",
    draftStatusBusy: "Редактира се",
    enteredBy: "въведена от {{name}}",
    filterEnteredBy: "Въвел",
    homeColleagues: "Колеги в процес",
    homeContinueDraft: "Продължи незавършената",
    homeDiscardAndNew: "Изтрий и започни нова",
    homeDraftLines_one: "{{count}} продукт",
    homeDraftLines_other: "{{count}} продукта",
    homeDraftModalTitle: "Имате незавършена доставка",
    homeDraftModalText: "Продължете нея или я изтрийте, за да започнете нова.",
    homeDraftUpdated: "последна промяна {{when}}",
    homeEnterInvoice: "Въведи фактура",
    homeNoSupplier: "Без доставчик",
    homeNotesInfo_one: "{{count}} стокова · {{from}}",
    homeNotesInfo_other: "{{count}} стокови · {{from}} – {{to}}",
    homeNotesShowAll: "Покажи всички {{count}}",
    homeNotesShowLess: "Скрий",
    homeTodayCount_one: "{{count}} доставка",
    homeTodayCount_other: "{{count}} доставки",
    homeTodayNone: "Днес още няма въведени доставки.",
    homeUnpaidCount_one: "{{count}} неплатен документ",
    homeUnpaidCount_other: "{{count}} неплатени документа",
    internalNo: "вътр. №{{id}}",
    invoiceLinksNotes_one: "Фактурата обобщава {{count}} стокова:",
    invoiceLinksNotes_other: "Фактурата обобщава {{count}} стокови:",
    kpiUninvoicedNotes: "Стокови без фактура",
    kpiUnpaid: "Неплатени",
    payableWithVatHint: "С ДДС — толкова се дължи на доставчика",
    linkInvoice: "Фактура · вътр. №{{id}}",
    linkWaitingInvoice: "чака фактура",
    linkClosedNoInvoice: "приключена без фактура",
    filterInvoiceState: "Фактура",
    invoiceState_waiting: "Чака фактура",
    invoiceState_closed: "Приключена без фактура",
    invoiceState_inInvoice: "Във фактура",
    linkNote: "СР · вътр. №{{id}}",
    newDeliveryPlus: "+ Нова доставка",
    noDocNumber: "б/н",
    noteInInvoiceBanner: "Стоковата е включена във фактура — там се плаща и коригира.",
    openInvoice: "Отвори фактурата",
    optional: "незадължително",
    payAllPaid: "Всички доставки са платени.",
    payPaid: "Платена",
    payUnpaid: "Неплатена",
    payByInvoice: "По фактура",
    payAnnulled: "Анулирана",
    payPaidMany: "Платени",
    payUnpaidMany: "Неплатени",
    payAnnulledMany: "Анулирани",
    payUntracked: "Без данни за плащане",
    payMethod_cash: "В брой",
    payMethod_bank: "Банков превод",
    payMethod_card: "Карта",
    payModalTitle: "Плащане",
    payDate: "Дата на плащане",
    payDatePick: "Изберете дата на плащане",
    payMethod: "Начин",
    payReference: "Основание / референция",
    payConfirm: "Потвърди плащането",
    payDocsCount_one: "{{count}} документ",
    payDocsCount_other: "{{count}} документа",
    paySelected_one: "Избран {{count}} документ",
    paySelected_other: "Избрани {{count}} документа",
    payMarkPaid: "Отбележи като платени",
    payPickFirst: "Отметнете поне един документ",
    payDoneToast_one: "{{count}} документ е отбелязан като платен",
    payDoneToast_other: "{{count}} документа са отбелязани като платени",
    payError: "Плащането не беше записано",
    payNeedsServerTitle: "Плащането още не е включено на сървъра",
    payNeedsServerText: "Екранът работи след обновяване на бекенда до версията с плащане на доставки.",
    docLabelInvoice: "Фактура {{number}}",
    docLabelNote: "Стокова {{number}}",
    payPanelPaid: "Платена на {{date}}",
    payPanelReference: "осн. {{reference}}",
    payPanelMarkedBy: "отбеляза {{name}}",
    payPanelUnpaidToday: "Неплатена · от днес",
    payPanelUnpaid_one: "Неплатена · от {{count}} ден",
    payPanelUnpaid_other: "Неплатена · от {{count}} дни",
    payPanelByInvoice: "Плаща се през фактурата",
    payPanelPaidSeparately: "платена отделно на {{date}}",
    payPanelAnnulled: "Документът е анулиран",
    payChange: "Промени",
    payMarkPaidOne: "Отбележи като платена",
    payMarkUnpaid: "Отбележи като неплатена",
    payUnpayTitle: "{{doc}} да стане неплатена?",
    payUnpayText: "{{doc}} става неплатена и се връща в „Доставки → Неплатени“.",
    payUnpayTextNotes_one: "{{doc}} става неплатена и се връща в „Доставки → Неплатени“ заедно с {{count}} стокова към нея — тя се плаща през фактурата. Стокова, платена отделно преди фактурата, остава платена.",
    payUnpayTextNotes_other: "{{doc}} става неплатена и се връща в „Доставки → Неплатени“ заедно с {{count}} стокови към нея — те се плащат през фактурата. Стоковите, платени отделно преди фактурата, остават платени.",
    payUnpaidToast: "{{doc}} е отбелязана като неплатена",
    payUnpayError: "Отмяната на плащането не беше записана",
    payUndo: "Отмени",
    payUndoneToast_one: "Плащането на {{count}} документ е отменено",
    payUndoneToast_other: "Плащането на {{count}} документа е отменено",
    payNotesPaidSeparately_one: "{{count}} стокова е платена отделно — не е в сумата",
    payNotesPaidSeparately_other: "{{count}} стокови са платени отделно — не са в сумата",
    noteDetach: "Извади от фактурата",
    noteDetachTitle: "Да се извади ли стоковата от фактурата?",
    noteDetachText: "{{doc}} излиза от фактурата и се връща в „Стокови без фактура“. Стоката ѝ остава заприходена. Ако фактурата е платена, стоковата остава платена със същото плащане.",
    noteDetachConfirm: "Извади",
    noteDetachedToast: "{{doc}} е извадена от фактурата",
    noteDetachError: "Изваждането не беше записано",
    noteClose: "Приключи без фактура",
    noteCloseTitle: "Приключване без фактура",
    noteCloseText: "Стоковата излиза от „Стокови без фактура“ — фактура за нея няма да се чака. Ако все пак дойде, „Върни за фактуриране“ я връща.",
    noteCloseReason: "Причина",
    noteCloseReasonPh: "напр. Доставчикът не издава фактура",
    noteCloseMarkPaid_one: "и я отбележи като платена",
    noteCloseMarkPaid_other: "и ги отбележи като платени",
    noteCloseStaysUnpaid: "Без отметката неплатената стокова остава в „Доставки → Неплатени“, докато не я платите.",
    noteCloseConfirm: "Приключи",
    noteClosePick: "Отметнете поне една стокова",
    noteClosedToast_one: "{{count}} стокова е приключена без фактура",
    noteClosedToast_other: "{{count}} стокови са приключени без фактура",
    noteCloseError: "Приключването не беше записано",
    noteClosedBanner: "Приключена без фактура на {{date}}",
    noteReopen: "Върни за фактуриране",
    noteReopenedToast: "{{doc}} отново чака фактура",
    noteReopenError: "Връщането не беше записано",
    revClosedWithoutInvoice: "Приключена без фактура",
    catalogOpen: "Целият списък",
    catalogTitle: "Целият списък с продукти",
    catalogHint: "Кликнете ред и въведете количество и цена — Enter минава на следващия, Ctrl+Enter добавя всички в доставката",
    catalogFilterPh: "Филтър по име",
    catalogAllGroups: "Всички",
    catalogInDocument: "в документа",
    catalogPicked_one: "Избран {{count}} продукт",
    catalogPicked_other: "Избрани {{count}} продукта",
    catalogHintToggle: "отмята",
    catalogHintAdd: "добавя",
    catalogAdd: "Добави избраните",
    colVat: "ДДС",
    deleteDraft: "Изтрий черновата",
    deleteDraftTitle: "Изтриване на черновата",
    deleteDraftBody: "Незавършената доставка ще се изтрие. Нищо не е заприходено.",
    fieldDocType: "Тип документ",
    fieldNoteNo: "Стокова №",
    heldToast: "Доставката е задържана — нищо не е заприходено",
    heldDraftFailed: "Доставката е записана, но проблемните продукти не се запазиха като задържана чернова — няма връзка със сървъра или колега е поел редакцията.",
    lockLost: "{{name}} пое редакцията — промените ви вече не се пазят",
    notesOffer_one: "Доставчикът има {{count}} стокова без фактура. Ако фактурата я обобщава, изберете я.",
    notesOffer_other: "Доставчикът има {{count}} стокови без фактура. Ако фактурата ги обобщава, изберете ги.",
    notesPick: "Избери стокови",
    notesLinked_one: "Фактурата обобщава {{count}} стокова · {{total}}",
    notesLinked_other: "Фактурата обобщава {{count}} стокови · {{total}}",
    notesLinkedHint: "Стоката им вече е заприходена — фактурата само ги свързва и се плаща вместо тях. Нови редове добавяте отдолу.",
    notesChange: "Промени избора",
    notesModalTitle: "Кои стокови обобщава фактурата?",
    notesModalSub: "Стоковите на доставчика без фактура",
    notesModalHint: "Стоковите не се заприходяват втори път. Свързана стокова не се редактира и не се анулира самостоятелно.",
    notesMoreLines: "… и още {{count}} реда",
    notesPicked_one: "{{count}} стокова · {{total}}",
    notesPicked_other: "{{count}} стокови · {{total}}",
    notesApply: "Свържи с фактурата",
    payMethodLong: "Начин на плащане",
    presenceOnlyYou: "Само вие редактирате",
    probSaveTitle: "Има продукти с проблем",
    probSaveSub: "Изберете как да продължите",
    probSaveHold: "Задръж доставката",
    probSaveHoldHint: "Нищо не се заприходява, докато проблемът не се реши.",
    probSaveWithout: "Запиши без проблемните",
    probSaveWithoutHint: "Останалите продукти се заприходяват сега.",
    problemTitle: "Проблем с продукт",
    problemHint: "Маркираният продукт не блокира работата. При запис ще изберете дали да задържите цялата доставка или да я запишете без него.",
    problemNotePh: "напр. 3 бутилки счупени, чакаме кредитно известие",
    problemDescription: "Описание на проблема",
    problemMark: "Маркирай",
    problemClear: "Премахни маркировката",
    problemFlagHint: "Маркирай проблем",
    problemReason_damaged: "Повредена",
    problemReason_short: "Липсва количество",
    problemReason_wrong: "Грешен продукт",
    problemReason_expired: "Изтекъл срок",
    problemReason_other: "Друго",
    productsTitle: "Продукти",
    saveModalTitle: "Запис на доставката",
    saveModalSave: "Запиши",
    saveNumberRequired: "Номерът на фактурата е задължителен",
    saveTypeHintInvoice: "Фактура — номерът е задължителен",
    saveTypeHintNote: "Стокова разписка — по-късно може да влезе във фактура",
    saveDelivery: "Запиши доставката",
    savedTempFailed: "Черновата не се запази — няма връзка със сървъра или колега е поел редакцията. Листът остава отворен; опитайте пак.",
    homeLockTitle: "Доставката се редактира в момента",
    homeLockText: "{{name}} работи по тази доставка ({{supplier}}, {{lines}}, последна промяна {{when}}). Ако я поемете, промените на {{first}} спират да се пазят и {{first}} ще види, че сте поели редакцията.",
    homeTakeOver: "Поеми редакцията",
    homeTakeOverToast: "Поехте доставката на {{name}}",
    homeTakeOverFailed: "Доставката не можа да бъде поета — опитайте пак",
    homeDeleteDraftLocked: "{{name}} редактира черновата в момента — не може да бъде изтрита",
    homeDeleteDraftFailed: "Черновата не е изтрита — няма връзка със сървъра. Опитай пак.",
    shortageSubtitle: "Непокритият излишък по склад · покрива се с доставка със задна дата",
    shortageSortName: "По продукт",
    shortageSortValue: "По стойност",
    shortagePickFirst: "Отметнете поне един продукт",
    shortageSelectedGross_one: "Избран {{count}} продукт · с ДДС",
    shortageSelectedGross_other: "Избрани {{count}} продукта · с ДДС",
    shortageSelectedNet_one: "Избран {{count}} продукт · без ДДС",
    shortageSelectedNet_other: "Избрани {{count}} продукта · без ДДС",
    shortageBackdatedTo: "доставка със задна дата {{date}}",
    shortageCompensate: "Компенсирай с доставка",
    shortageReportsInfo_one: "{{count}} отчет · от {{date}}",
    shortageReportsInfo_other: "{{count}} отчета · от {{date}}",
    shortageBreakdownOpen: "Разбивка по отчети",
    shortageCompensateOneHint: "Доставка само за този продукт",
    interchangeRulesCount_one: "{{count}} правило",
    interchangeRulesCount_other: "{{count}} правила",
    interchangeMembersCount_one: "{{count}} продукт в групата",
    interchangeMembersCount_other: "{{count}} продукта в групата",
    interchangeCatalogHint: "Отметнете продуктите, които се заместват взаимно, и ги добавете наведнъж",
    reportResult_one: "{{count}} резултат",
    reportResult_other: "{{count}} резултата",
    stockSubtitle_one: "{{count}} продукт · {{inStock}} с наличност",
    stockSubtitle_other: "{{count}} продукта · {{inStock}} с наличност",
    stockPickWarehouse: "Изберете склад, за да видите наличностите.",
    stockMinLine: "мин. {{qty}}",
    stockLastPriceLine: "посл. {{price}}",
    soldSubtitleProduct_one: "{{count}} продукт за периода",
    soldSubtitleProduct_other: "{{count}} продукта за периода",
    soldSubtitleRecipe_one: "{{count}} рецепта за периода",
    soldSubtitleRecipe_other: "{{count}} рецепти за периода",
    soldAvgLine: "ср. цена {{price}}",
    soldIngredientsLine_one: "{{count}} съставка",
    soldIngredientsLine_other: "{{count}} съставки",
    subSubtitle_one: "{{count}} замяна за периода · от всички складове",
    subSubtitle_other: "{{count}} замени за периода · от всички складове",
    deletedSubtitle_one: "{{count}} анулиран запис · периодът е по датата на анулиране",
    deletedSubtitle_other: "{{count}} анулирани записа · периодът е по датата на анулиране",
    newTransferPlus: "+ Ново прехвърляне",
    trxHomeTodayCount_one: "{{count}} прехвърляне",
    trxHomeTodayCount_other: "{{count}} прехвърляния",
    trxHomeTodayNone: "Днес още няма прехвърляния.",
    trxSavedToast: "Прехвърляне №{{number}} е записано",
    trxEnteredBy: "въведено от {{name}}",
    trxAnnulTitle: "Анулиране на прехвърляне №{{number}}",
    trxAnnulText: "Количествата се връщат в склада-източник. Документът остава в справката като анулиран.",
    trxCatalogTitle: "Наличните в {{warehouse}}",
    trxCatalogHint: "Само продуктите с наличност в склада-източник към датата — кликнете ред и въведете количеството",
    trxSegActive: "Активни",
    transfersSearchPh: "Търсене по №, склад, продукт, потребител, коментар…",
    transfersResult_one: "{{count}} прехвърляне",
    transfersResult_other: "{{count}} прехвърляния",
    transfersNone: "Няма прехвърляния за този филтър.",
    newStocktakePlus: "+ Нова инвентаризация",
    stocktakeHomeDraftHint: "Черновата се пази автоматично в този браузър, докато не запишете или изтриете инвентаризацията.",
    stocktakeHomeCounted_one: "{{count}} преброен продукт",
    stocktakeHomeCounted_other: "{{count}} преброени продукта",
    stocktakeCountedShort_one: "{{count}} преброен",
    stocktakeCountedShort_other: "{{count}} преброени",
    stocktakeDraftModalTitle: "Имате незавършена инвентаризация",
    stocktakeStart: "Започни",
    stkUnfinishedYours: "вашата",
    stkCountingNow: "в момента брои {{name}}",
    stkWhenToday: "днес {{time}}",
    stkWhenYesterday: "вчера {{time}}",
    stkRowContinue: "Продължи",
    stkRowTakeOver: "Поеми",
    stkColleagueAskTitle: "{{name}} вече брои {{warehouse}}",
    stkColleagueAskText: "Продължете започнатото броене или започнете отделно — двете се записват като отделни инвентаризации.",
    stkColleagueAskCaption: "Започнатото броене",
    stkColleagueContinue: "Продължи броенето на {{first}}",
    stkColleagueContinueHint: "Отваря листа с преброеното досега — нищо не се брои два пъти",
    stkColleagueSeparate: "Започни отделна",
    stkColleagueSeparateHint: "Нова инвентаризация на {{warehouse}} до тази на {{first}}",
    stkDraftPill: "Чернова · {{who}}",
    stkDraftPillYours: "ваша",
    stkNotStarted: "Няма започната",
    stkNeverDone: "Не е правена инвентаризация",
    stkLatestNumber: "№{{id}}",
    stkMoreCounts_one: "+{{count}} броене",
    stkMoreCounts_other: "+{{count}} броения",
    stkLateHint: "Последно пипана преди днес — продажбите след броенето ще излязат като липса. Довършете я днес.",
    stkLateOther: "на {{name}} закъснява",
    stkLateOtherHint: "Броенето на {{name}} е пипано последно преди днес — продажбите след него ще излязат като липса. Довършете го днес.",
    stkStartSeparate: "Започни отделна инвентаризация",
    stkOpenCountOf: "Отвори броенето на {{name}}",
    stkColWarehouse: "Склад",
    stkColStatus: "Статус",
    stkColLast: "Последна завършена",
    stkSaveAskTitle: "Да запиша ли инвентаризацията на {{warehouse}}?",
    stkSaveAskTitlePlain: "Да запиша ли инвентаризацията?",
    stkSaveAskTitleEdit: "Да запиша ли промените по инвентаризация №{{id}}?",
    stkSaveAskText: "Разликите спрямо наличността в системата стават движения: излишъкът се заприходява, липсата се изписва.",
    stkSaveAskCaption: "Разлики спрямо системата",
    stkSaveEqual: "Без разлика",
    stkSaveRecipes: "Приготвени рецепти",
    stkSaveTotal: "Общо разлика",
    stkSaveProducts_one: "{{count}} продукт",
    stkSaveProducts_other: "{{count}} продукта",
    stkSavePortions_one: "{{count}} рецепта",
    stkSavePortions_other: "{{count}} рецепти",
    stkSaveUndo: "Записаната инвентаризация се анулира от Инвентаризации → Справка.",
    stkSaveConfirm: "Запиши инвентаризацията",
    stkSaveConfirmEdit: "Запиши промените",
    stocktakeSavedToast: "Инвентаризация №{{number}} е записана",
    stocktakeAnnulTitle: "Анулиране на инвентаризация №{{number}}",
    stocktakeAnnulText: "Излишъците и липсите ѝ се отменят — наличността се преизчислява без нея. Документът остава в справката като анулиран.",
    stocktakesSearchPh: "Търсене по №, склад, потребител, причина, продукт…",
    stocktakeStatusActive: "Активна",
    stocktakeStatusAnnulled: "Анулирана",
    stocktakeNoGroup: "Без група",
    woCatalogTitle: "Целият списък с продукти и рецепти",
    woCatalogHint: "Кликнете ред и въведете количеството — Enter минава на следващия, Ctrl+Enter добавя всички наведнъж",
    woCatalogRecipes: "Рецепти",
    woLinesCount_one: "{{count}} ред",
    woLinesCount_other: "{{count}} реда",
    newWriteoffPlus: "+ Ново изписване",
    woTodayNone: "Днес още няма изписвания в този склад.",
    woDocsCount_one: "{{count}} документ",
    woDocsCount_other: "{{count}} документа",
    woNoReason: "Без причина",
    woProductsCount_one: "{{count}} продукт",
    woProductsCount_other: "{{count}} продукта",
    woSavedToast: "Изписване №{{number}} е записано",
    woScrapSavedToast: "Бракуване №{{number}} е записано",
    woAnnulTitle: "Анулиране на изписване №{{number}}",
    woAnnulText: "Изписаните количества се връщат в склада. Документът остава в справката като анулиран.",
    woReportSearchPh: "Търсене по №, причина, коментар, продукт, потребител…",
    woReportNone: "Няма изписвания за този филтър.",
    woStatusActive: "Активни",
    wsCreateNamed: "Нов продукт „{{name}}“",
    stoCatalogTitle: "Целият списък — какво броите",
    stoCatalogHint: "Отметнете продуктите, които ще броите сега — те застават най-отгоре в таблицата, в реда на избора, и ги броите един след друг със ↓.",
    // „Целият списък" (components/search/CatalogPickerModal) — колони, групи, лента с избраните
    catAllVisible: "Всички видими",
    catColPrice: "Цена",
    catEmpty: "Каталогът е празен",
    catNoMatchInGroup: "Няма съвпадения в „{{group}}“",
    catShowAllGroups_one: "Покажи от всички групи · {{count}} съвпадение",
    catShowAllGroups_other: "Покажи от всички групи · {{count}} съвпадения",
    catCreateNamed: "Нов продукт „{{name}}“",
    catGroups: "Групи",
    catOnlyInStock: "Само с наличност",
    catHideAdded: "Скрий добавените",
    catSelected_one: "Избран {{count}}",
    catSelected_other: "Избрани {{count}}",
    catNothingSelected: "Нищо не е отметнато — Enter или клик по реда",
    catUnpick: "Махни „{{name}}“ от избраните",
    catAddCount_one: "Добави {{count}} избран",
    catAddCount_other: "Добави {{count}} избрани",
    catShownOf: "{{shown}} от {{total}}",
    catKeyRow: "ред",
    catKeyGroup: "група",
    catKeyEscClear: "изчиства филтъра",
    catKeyEscClose: "затваря",
    catMore: "+ още {{count}}",
    // въвеждане в реда, „Мин.", сумата, чиповете „Под минимума" / „От този доставчик", презаписът
    catColMin: "Мин.",
    catColSum: "Сума",
    catFieldPrice: "Ед. цена без ДДС",
    catFieldPriceHint: "В отметнат ред — ед. цена без ДДС за базова единица, попълнена с последната доставна; в останалите — последната доставна цена",
    catFieldPriceGross: "Ед. цена с ДДС",
    catFieldPriceGrossHint: "В отметнат ред — ед. цена с ДДС (тази, която плащате) за базова единица, попълнена с последната доставна; в останалите — последната доставна цена",
    catSelectedSum: "сума",
    catBelowMinimum: "Под минимума",
    catBelowMinimumHint: "Продуктите с наличност под минималното количество — за поръчка",
    catFromSupplier: "От този доставчик",
    catFromSupplierHint: "Продуктите с доставна цена от „{{name}}“",
    catKeyEdit: "отмята и въвежда",
    catKeyPrice: "към цената",
    catOverwriteTitle_one: "Да се презапише ли {{count}} ред в листа?",
    catOverwriteTitle_other: "Да се презапишат ли {{count}} реда в листа?",
    catOverwriteText: "Вече попълнените в листа редове получават въведеното тук; останалите избрани се добавят както са.",
    catOverwriteCaption: "В листа → ново",
    catOverwriteConfirm: "Презапиши и добави",
    catOverwriteBack: "Назад",
    ichGroupTitle: "Кои продукти се заместват взаимно",
    ichGroupLead: "Въведете количествата, които са равностойни. Когато някой продукт липсва при разнасяне на отчет или при инвентаризация, системата предлага да се изпише друг от групата в същото съотношение.",
    ichOrderLabel: "Кой се изписва пръв",
    ichOrderOldest: "Най-старата доставка",
    ichOrderManual: "По реда тук",
    ichOrderOldestHelp: "От заместителите първо се изписва този с най-старата доставка — изчерпва се по-старата наличност.",
    ichOrderManualHelp: "Първо се изписва №1, после №2… — подредете със стрелките, Alt+↑/↓ или с плъзгане на номера.",
    ichSlotLabel: "Продукт {{index}}",
    ichSlotFirstHint: "напишете името му или изберете от целия списък",
    ichSlotSecondHint: "…и продукт, който може да го замести",
    ichSlotMoreLabel: "Още продукт",
    ichSlotMoreHint: "по желание — всички в групата се заместват взаимно",
    ichKeysAmounts: "между количествата",
    ichKeysMove: "мести продукта",
    ichDragHandle: "Плъзнете, за да смените реда",
    ichPriorityAria: "Приоритет {{index}}",
    ichPriorityNone: "Без приоритет — по най-стара доставка",
    ichAmountAria: "Количество от {{name}}",
    ichMoveUp: "Премести нагоре",
    ichMoveDown: "Премести надолу",
    ichRemove: "Махни {{name}} от групата",
    ichUnitFallback: "ед.",
    ichReady: "Готово за запис",
    ichMissingAmount: "Въведете количество за: {{names}}",
    ichExampleLabel: "Пример",
    ichExampleA: "Кафе A",
    ichExampleB: "Кафе B",
    ichExampleUnit: "кг",
    ichExampleScenario: "Ако липсват 10 {{unit}} {{a}}, системата предлага да се изпишат 7 {{unit}} {{b}} — и обратно: при липса на {{b}} се предлага {{a}}.",
    ichPreviewTitle: "Как ще работи",
    ichPreviewPick: "Ако липсва",
    ichPreviewShortage: "Липсват",
    ichPreviewOffer: "системата предлага да се изпише:",
    ichPreviewOr: "или",
    ichPreviewNeedAmount: "(въведете количество)",
    ichPreviewOldestNote: "първо от този с най-старата доставка",
    ichPreviewNextNote: "Следващият се ползва, ако предишният не стига.",
    ichPreviewNeedRecipient: "Въведете количество за {{name}}, за да видите примера.",
    ichPreviewWhere: "Прилага се при разнасяне на отчет и при инвентаризация. Замяната се предлага — потвърждавате я вие.",
    ichPriorityOldest: "Първо се изписва този с най-старата доставка",
    ichPriorityOrder: "Първо се изписва: {{names}}",
    ichPriorityRest: "останалите — по най-стара доставка",
    ichEmptyTitle: "Още няма правила за заместване",
    ichEmptyText: "Правилото казва кои продукти могат да се заместват взаимно и в какво количество. Когато някой липсва при разнасяне на отчет или при инвентаризация, системата предлага да се изпише друг от същото правило.",
    ichNoMatch: "Няма правило с „{{query}}“",
    ichClearSearch: "Изчисти търсенето",
    ichListKeys: "избор и отваряне на правило",
    // Подсказките на „Причина" в листа „Изписване" (writeoff/components/WriteoffReasonField)
    wrPreviousReasons: "Предишни причини",
    wrReasonUsed_one: "Ползвана {{count}} път",
    wrReasonUsed_other: "Ползвана {{count}} пъти",
    wrKeyPick: "избира",
    // История на промените на документ (components/revisions/)
    revTitle: "История на промените",
    revNone: "Без промени след създаването",
    revEdits_one: "{{count}} редакция",
    revEdits_other: "{{count}} редакции",
    revLast: "последна {{when}} · {{name}}",
    revChanges_one: "{{count}} промяна",
    revChanges_other: "{{count}} промени",
    revNoValueChanges: "записан без промени в стойностите",
    revCreated_delivery: "създадена",
    revCreated_writeoff: "създадено",
    revCreated_stocktake: "създадена",
    revCreated_transfer: "създадено",
    revAdded: "добавен",
    revRemoved: "премахнат",
    revLinkedNotes: "Обобщени стокови",
    revTotalNet: "Общо без ДДС",
    revTotalGross: "Общо с ДДС",
    revSubstitution: "Замяна",
    revAutoPrice: "автоматична",
    revUnknownUser: "неизвестен потребител",
    revLoadError: "Историята на промените не може да се зареди",
    revShowHistory: "Покажи историята на промените",
    revHideHistory: "Скрий историята на промените",
    // Потвърждения (components/confirm): въпрос с обекта, какво ще стане, преглед, конкретен глагол
    cfmMore: "+ още {{count}}",
    cfmFinal: "Действието не може да се отмени.",
    cfmPortions_one: "{{value}} порция",
    cfmPortions_other: "{{value}} порции",
    cfmLeaveTitle: "Излизане от {{document}} без запис?",
    cfmLeaveDraftTitle: "Излизане от {{document}}?",
    cfmLeaveText: "Незаписаните промени се губят — в склада нищо не се променя.",
    cfmLeaveDraftText: "Преброеното остава като чернова в този браузър и при следващо отваряне ще ви предложим да продължите. В склада още нищо не е записано.",
    cfmLeavePostingText: "Избраните замени за Отчет №{{number}} се губят. Отчетът остава неразнесен в списъка — нищо не се изписва.",
    cfmLeaveDraftNotSavedTitle: "Черновата не е записана (няма връзка със сървъра). Излез без запис?",
    cfmLeaveDraftNotSavedText: "Промените в листа след последния успешен запис се губят. Останете и опитайте пак, когато връзката се върне.",
    cfmLeaveCaption: "Незаписани редове",
    cfmLeaveSheetCaption: "Редове в листа",
    cfmLeaveDraftCaption: "Остават в черновата",
    cfmLeaveFinal: "Изгубените промени не могат да се върнат.",
    cfmLeaveConfirm: "Излез без запис",
    cfmLeaveDraftConfirm: "Излез, черновата остава",
    cfmLeaveStay: "Остани",
    cfmDocNewWriteoff: "новото изписване",
    cfmDocNewScrap: "новото бракуване",
    cfmDocEditWriteoff: "редакцията на изписване №{{number}}",
    cfmDocEditScrap: "редакцията на бракуване №{{number}}",
    cfmDocNewTransfer: "новото прехвърляне",
    cfmDocEditTransfer: "редакцията на прехвърляне №{{number}}",
    cfmDocNewStocktake: "новата инвентаризация",
    cfmDocEditStocktake: "редакцията на инвентаризация №{{number}}",
    cfmDocEditDelivery: "редакцията на доставка №{{number}}",
    cfmDocPosting: "разнасянето на Отчет №{{number}}",
    cfmRemoveRowTitle: "Премахване на „{{name}}“ от листа?",
    cfmRemoveRowTitlePlain: "Премахване на реда от листа?",
    cfmRemoveRowText: "Редът с {{qty}} се маха от листа. В склада нищо не се променя, докато не запишете.",
    cfmRemoveRowTextEmpty: "Редът се маха от листа. В склада нищо не се променя, докато не запишете.",
    cfmRemoveRowUndo: "Можете да го добавите пак от търсачката.",
    cfmRemoveRowConfirm: "Премахни реда",
    cfmSplitRecipeTitle: "Разделяне на рецептата „{{name}}“?",
    cfmSplitRecipeText_one: "Редът се заменя с {{count}} продуктов ред — съставката на рецептата за {{portions}}, с количество и партида, които можете да променяте.",
    cfmSplitRecipeText_other: "Редът се заменя с {{count}} продуктови реда — съставките на рецептата за {{portions}}, всяка с количество и партида, които можете да променяте поотделно.",
    cfmSplitRecipeCaption: "Ще се появят",
    cfmSplitRecipeDefaultPortions: "Порциите не са попълнени — количествата са за 1 порция.",
    cfmSplitRecipeUndo: "Можете да ги съберете обратно с „{{action}}“.",
    cfmSplitRecipeConfirm_one: "Раздели на {{count}} ред",
    cfmSplitRecipeConfirm_other: "Раздели на {{count}} реда",
    cfmRevertTitle: "Връщане в рецептата „{{name}}“?",
    cfmRevertText_one: "{{count}} продуктов ред се събира обратно в един ред „{{name}}“ за {{portions}} — промените по количеството и партидата му се губят.",
    cfmRevertText_other: "{{count}} продуктови реда се събират обратно в един ред „{{name}}“ за {{portions}} — промените по количествата и партидите им се губят.",
    cfmRevertCaption: "Ще се съберат",
    cfmRevertUndo: "Можете да я разделите пак с „{{action}}“.",
    cfmRevertConfirm: "Събери в рецептата",
    cfmDeleteDraftTitle: "Изтриване на незавършената доставка?",
    cfmDeleteDraftTitleSupplier: "Изтриване на незавършената доставка от „{{supplier}}“?",
    cfmDeleteDraftText: "Черновата и всичките ѝ редове се изтриват. Нищо не е заприходено, затова складът не се променя.",
    cfmDeleteDraftCaption: "Изтриват се",
    cfmDraftDeliveryTitle: "Да продължите ли незавършената доставка?",
    cfmDraftDeliveryTitleBy: "Да продължите ли незавършената доставка на {{name}}?",
    cfmDraftStocktakeTitle: "Да продължите ли незавършената инвентаризация?",
    cfmDraftStocktakeTitleBy: "Да продължите ли незавършената инвентаризация на {{name}}?",
    cfmDraftSavedAt: "Черновата е запазена автоматично на {{when}}. Продължете от нея или започнете на чисто.",
    cfmDraftCaption: "В черновата",
    cfmDraftContinue: "Продължи черновата",
    cfmDraftContinueHint: "Редовете ѝ се зареждат в листа и продължавате оттам.",
    cfmDraftStocktakeContinueHint: "Преброеното се зарежда в листа и продължавате да броите оттам.",
    cfmDraftDiscard: "Изтрий и започни наново",
    cfmDraftDiscardHint: "Черновата се изтрива безвъзвратно, листът започва празен.",
    cfmDraftAskDeliveryTitle: "Да продължите ли доставката от „{{supplier}}“?",
    cfmDraftAskDeliveryTitlePlain: "Да продължите ли незавършената доставка?",
    cfmDraftAskDeliveryText: "Всеки потребител има само една незавършена доставка — за да започнете нова, тази трябва да се запише или изтрие.",
    cfmDraftAskStocktakeTitle: "Да продължите ли инвентаризацията на „{{warehouse}}“?",
    cfmDraftAskStocktakeTitlePlain: "Да продължите ли незавършената инвентаризация?",
    cfmDraftAskStocktakeText: "В този браузър вече има започната инвентаризация — за да започнете нова, тази трябва да се запише или изтрие.",
    cfmDraftAskCaption: "Незавършената",
    cfmDraftAskContinueHint: "Отваря листа с нейните редове.",
    cfmDraftAskStocktakeContinueHint: "Отваря листа с преброеното досега.",
    cfmDraftAskDiscardHint: "Черновата се изтрива безвъзвратно и се отваря празен лист.",
    cfmLockTitle: "Да поемете ли доставката на {{name}}?",
    cfmLockText: "{{name}} я редактира в момента. Ако я поемете, промените на {{first}} спират да се пазят, а {{first}} ще види, че сте поели редакцията.",
    cfmLockCaption: "Черновата",
    cfmLockConfirm: "Поеми от {{first}}",
    cfmProblemTitle_one: "{{count}} продукт с проблем — как да запишем доставката?",
    cfmProblemTitle_other: "{{count}} продукта с проблем — как да запишем доставката?",
    cfmProblemText: "Продукт с проблем не се заприходява, докато проблемът не се реши. Изберете какво да стане с останалите.",
    cfmProblemCaption: "С проблем",
    cfmProblemHoldHint: "Нищо не се заприходява — доставката остава чернова със статус „Задържана“, докато проблемът се реши.",
    cfmProblemWithoutHint_one: "{{count}} продукт се заприходява сега, проблемните остават в задържана чернова.",
    cfmProblemWithoutHint_other: "{{count}} продукта се заприходяват сега, проблемните остават в задържана чернова.",
    cfmShortageTitle_one: "Разнасяне на Отчет №{{number}} с недостиг при {{count}} продукт?",
    cfmShortageTitle_other: "Разнасяне на Отчет №{{number}} с недостиг при {{count}} продукта?",
    cfmShortageText: "Тези продукти не достигат в склада и ще се изпишат с отрицателна наличност, докато следваща доставка или инвентаризация не я изравни.",
    cfmShortageCaption: "Не достигат",
    cfmShortageUndo: "Ако се окаже грешка, разнасянето може да се анулира от „{{report}}“.",
    cfmShortageConfirm: "Разнеси с недостиг",
    cfmAnnulDeliveryTitle: "Анулиране на доставка №{{number}}?",
    cfmAnnulDeliveryTitleSupplier: "Анулиране на доставка №{{number}} от „{{supplier}}“?",
    cfmAnnulDeliveryCaption: "Излизат от склада",
    cfmAnnulDeliveryConfirm: "Анулирай доставката",
    cfmAnnulWriteoffTitle: "Анулиране на изписване №{{number}}?",
    cfmAnnulScrapTitle: "Анулиране на бракуване №{{number}}?",
    cfmAnnulWriteoffCaption: "Връщат се в склада",
    cfmAnnulWriteoffConfirm: "Анулирай изписването",
    cfmAnnulScrapConfirm: "Анулирай бракуването",
    cfmAnnulTransferTitle: "Анулиране на прехвърляне №{{number}}?",
    cfmAnnulTransferCaption: "Връщат се в „{{warehouse}}“",
    cfmAnnulTransferConfirm: "Анулирай прехвърлянето",
    cfmAnnulStocktakeTitle: "Анулиране на инвентаризация №{{number}}?",
    cfmAnnulStocktakeCaption: "Отменят се разликите",
    cfmAnnulStocktakeConfirm: "Анулирай инвентаризацията",
    cfmAnnulUndo: "Документът може да се възстанови от справката „{{report}}“.",
    cfmRestoreTitle: "Възстановяване на {{document}}?",
    cfmRestoreDoc_delivery: "доставка №{{number}}",
    cfmRestoreDoc_writeoff: "изписване №{{number}}",
    cfmRestoreDoc_scrap: "бракуване №{{number}}",
    cfmRestoreDoc_stocktake: "инвентаризация №{{number}}",
    cfmRestoreDoc_transfer: "прехвърляне №{{number}}",
    cfmRestoreDoc_substitution: "замяна №{{number}}",
    cfmRestoreDoc_report: "разнасяне №{{number}}",
    cfmRestoreDocOther: "запис №{{number}}",
    cfmRestoreCaption: "Прилагат се отново",
    cfmRestoreUndo: "Документът може да се анулира пак от прегледа му.",
    cfmRestoreVerb_delivery: "Възстанови доставката",
    cfmRestoreVerb_writeoff: "Възстанови изписването",
    cfmRestoreVerb_scrap: "Възстанови бракуването",
    cfmRestoreVerb_stocktake: "Възстанови инвентаризацията",
    cfmRestoreVerb_transfer: "Възстанови прехвърлянето",
    cfmRestoreVerb_substitution: "Възстанови замяната",
    cfmRestoreVerb_report: "Възстанови разнасянето",
    cfmRestoreVerbOther: "Възстанови записа",
    // Филтри в заглавията на колоните на справките (components/filters/ColumnHeader, ColumnFilterPanel, FilterSummaryLine)
    cfFilters: "Филтри",
    cfSelectAll: "Всички",
    cfOnly: "Само това",
    cfFrom: "от",
    cfTo: "до",
    cfFilterAria: "Филтър по „{{column}}“",
    cfRemove: "Махни филтъра „{{filter}}“",
    cfKeyToggle: "отмята",
    cfKeyOnly: "само това",
    cfKind: "Вид",
    cfKindReason: "Вид и причина",
    cfNoMatch: "Нищо не отговаря на търсенето и филтрите",
    cfClearFilters: "Изчисти филтрите",
    cfWithSurplus: "С излишък",
    cfNoSurplus: "Без излишък",
    cfWithShortage: "С липси",
    cfNoShortage: "Без липси",
    scTitle: "Складова карта",
    scCardAria: "Складова карта на {{name}}",
    scClose: "Затвори картата",
    scInStock: "Налично",
    scInStockAsOf: "Налично към {{date}}",
    scTabMovements: "Движения",
    scTabLots: "Партиди",
    scTabSubstitutions: "Замени",
    scOpening: "Начално салдо",
    scClosing: "Крайно салдо",
    scColIn: "Приход",
    scColOut: "Разход",
    scColPrice: "Цена",
    scColUser: "Въвел",
    scColNote: "Бележка",
    scTypeAll: "Всички",
    scTypeFilterAria: "Вид движение",
    scDoc_delivery: "Доставка",
    scDoc_report: "Отчет",
    scDoc_writeoff: "Изписване",
    scDoc_scrap: "Бракуване",
    scDoc_stocktake: "Инвентаризация",
    scDoc_transfer: "Прехвърляне",
    scDoc_substitution: "Замяна",
    scDocNumber: "{{label}} №{{number}}",
    scCoveredBy: "⇄ покрито от {{name}}",
    scBatchNote: "партида {{batch}}",
    scExpiryNote: "до {{date}}",
    scEmptyPeriod: "Няма движения в периода.",
    scEmptyFiltered: "Няма движения от този вид в периода.",
    scExcel: "Excel",
    scInconsistent: "Сборът на движенията не съвпада с крайното салдо — проверете историята на продукта.",
    scNegativeHint: "Под нулата — изписано е повече, отколкото е имало",
    scSoldWithoutStock: "⚠ {{qty}} продадени без наличност",
    scWrittenOffWithoutStock: "⚠ {{qty}} изписани без наличност",
    scCoveredNegative: "({{qty}} покриват продаденото без наличност)",
    scColReceived: "Приета",
    scColRemaining: "Остатък",
    scLotsHint: "Отворените партиди към момента — по реда, в който ще се изписват (най-старата първа).",
    scLotsEmpty: "Няма отворени партиди.",
    scColSubstitution: "Замяна",
    scSubsEmpty: "Няма замени в периода.",
    scSubsCovered: "покрити {{qty}}",
    scSubsTaken: "изписани {{qty}}",
    scSubsCountReplaced_one: "заместил друг продукт 1 път",
    scSubsCountReplaced_other: "заместил друг продукт {{count}} пъти",
    scSubsCountReplacedBy_one: "заместен 1 път",
    scSubsCountReplacedBy_other: "заместен {{count}} пъти",
    scBadgeReplaced: "⇄ заместил {{name}}",
    scBadgeReplacedBy: "⇄ заместен с {{name}}",
    scBadgeTipTitle: "Замени за {{period}}",
    scBadgeTipReplaced_one: "Заместил {{name}} — 1 път, {{qty}}",
    scBadgeTipReplaced_other: "Заместил {{name}} — {{count}} пъти, {{qty}}",
    scBadgeTipReplacedBy_one: "Заместен с {{name}} — 1 път, {{qty}}",
    scBadgeTipReplacedBy_other: "Заместен с {{name}} — {{count}} пъти, {{qty}}",
    scMasterListAria: "Продукти в склада",
    scKeysSwitch: "продукт",
    scKeysClose: "затваря",
    ichDocNewRule: "новото правило",
    ichDocEditRule: "правилото „{{name}}“",
    ichDeleteTitle: "Изтриване на правилото „{{name}}“?",
    ichDeleteText: "Продуктите в него вече няма да се предлагат като взаимозаменяеми при разнасяне на отчет и при инвентаризация. Наличностите и вече записаните документи не се променят.",
    ichDeleteCaption: "Продукти в правилото",
    ichDeleteFinal: "Изтриването не може да се отмени — правилото се създава наново.",
    ichDeleteConfirm: "Изтрий правилото",
    cfmPostingAnnulTitle: "Анулиране на разнасянето на Отчет №{{report}}?",
    cfmPostingRepostTitle: "Корекция на разнасянето на Отчет №{{report}}?",
    cfmPostingAnnulNote: "Анулираното разнасяне остава в тази справка зачертано, с причината; отчетът може да се разнесе отново.",
    cfmPostingAnnulConfirm: "Анулирай разнасянето",
    cfmPostingRepostConfirm: "Анулирай и разнеси повторно",
    upPriceFromSum: "Изчислена от въведената сума на реда — сумата се записва точно",
    // Общата лента на справките и изборът на период (кръг 4)
    tbPeriodPickRange: "изберете първия и последния ден",
    tbPeriodPickEnd: "изберете последния ден",
    tbToolbarAria: "Лента на справката",
    tbColAnnulReason: "Причина за анулиране",
    tbColAgeDays: "Дни от доставката",
    tbColReports: "Отчети",
    tbColOldestReport: "Най-стар отчет",
    stkStatusAll: "Всички",
    stkStatusCounted: "Преброени",
    stkStatusUncounted: "Непреброени",
    stkStatusDiff: "С разлика",
    stkAllGroups: "Всички групи",
    stkGroupsAria: "Групи продукти",
    stkBandProgress: "{{counted}} от {{total}}",
    stkBandPinned_one: "{{count}} избран за броене",
    stkBandPinned_other: "{{count}} избрани за броене",
    stkBandRestHint: "не се променят; напишете 0, ако продуктът липсва",
    stkEmptyCounted: "Още няма преброени продукти.",
    stkEmptyUncounted: "Всички продукти са преброени.",
    stkEmptyDiff: "Няма разлики — преброеното съвпада с търсеното.",
    stkTotalsSurplus: "Излишъци",
    stkTotalsShortage: "Липси",
    stkTotalsNetCaption: "Нетно",
    stkIssuePrice: "Въведете ед. цена за: {{products}}",
    stkIssueMore_one: "и още {{count}}",
    stkIssueMore_other: "и още {{count}}",
    stkPricePh: "цена *",
    stkPriceRequiredHint: "Няма доставна цена в този склад — въведете ед. цената на излишъка, иначе ще влезе на 0.",
    stkPriceAdminOnly: "Ед. цената се сменя само от служебния акаунт на UnrealSoft.",
    sdGroupRecipe: "По рецепта",
    sdGroupRecipeTip: "Текущите рецепти × продаденото от сметките, затворени в периода, по текущата средна себестойност.",
    sdGroupPosted: "Разнесено",
    sdGroupPostedTip: "Изписаното от склада при разнасянето на отчетите с дата в периода, по FIFO себестойност — заедно с изписаното вместо друг продукт (замяна).",
    sdGroupDiff: "Разлика",
    sdGroupDiffTip: "Разнесено − по рецепта. „+“ — изписано е повече, отколкото казват рецептите; „−“ — по-малко.",
    sdColQty: "К-во",
    sdDatesHint: "По рецепта — по датата на затваряне на сметките; Разнесено — по датата на отчета.",
    sdDatesHintTip: "Двете се разминават, когато рецептата е сменена след разнасянето, цената е друга (текуща средна срещу FIFO), продукт е заменен с друг, количество е коригирано ръчно при разнасянето или отчетът е с дата извън периода (например пуснат след полунощ).",
    sdDonorLine: "{{qty}} изписани вместо друг продукт",
    sdCoveredLine: "{{qty}} покрити от друг продукт",
    sdKeysSwitch: "ред",
    sdPostedByWarehouse: "Разнесено по складове: {{list}}",
    sdCardPeriodNote: "Картата е за периода на справката ({{period}}) и тръгва от разнасянията — чипът „Всички“ показва всички движения.",
    sdRecipeKicker: "Продадена рецепта",
    sdRecipePanelAria: "Продадена рецепта {{name}}",
    sdClosePanel: "Затвори панела",
    sdSoldLabel: "Продадено",
    sdTabDays: "По дни",
    sdTabReports: "Отчети",
    sdTabIngredients: "Съставки",
    sdDaysHint: "Продажбите по деня на затваряне на сметката — само дните с продажби.",
    sdDaysHoursHint: "По часове — в Справки → „Персонализирани справки“ (филтър „Артикули“).",
    sdReportsHint: "Сметките от периода по разнесения отчет, в който са влезли. Клик или Enter отваря разнасянето.",
    sdReportsEmpty: "Няма разнесени отчети с тази рецепта за периода.",
    sdIngredientsNote: "По ТЕКУЩАТА рецепта × {{sold}} продадени — теоретичен разход, не изписаното от склада. Изписаното е в „Продадени продукти“ → „Разнесено“.",
    sdIngredientsEmpty: "Рецептата няма съставки.",
    sdColPerPortion: "На порция",
    sdColTotalQty: "Общо",
    sdPerPortionLine: "{{qty}} на порция",
    sdIngredientsTotal: "Себестойност по рецепта",
    sdXlsDonor: "Разнесено · в т.ч. вместо друг продукт",
    sdXlsCovered: "Покрито от друг продукт",
    stqStatusPinned: "За броене",
    stqBandPinnedHint: "(избрани от списъка)",
    stqBandRestHint: "остават както са; напишете 0, ако липсва",
    stqEmptyPinned: "Няма продукти за броене — изберете ги от „Целият списък“.",
    stqBatchLink: "+ партида / срок",
    // „Намерено" на няколко пъти (StocktakeCountExtras)
    stqCountAdd: "Добави още",
    stqCountAddHint: "Добави още към намереното — или напишете „+5“ в полето („-2“ поправя)",
    stqCountHistory: "История на броенето",
    stqCountClear: "Изчисти",
    stqCountClearHint: "Изчисти броенето на реда и започни отначало",
    stqTotalsWithVat: "(с ДДС {{value}})",
    // „Занули склада" на листа на нова инвентаризация (useStocktakeZeroing)
    stqZeroButton: "Занули склада",
    stqZeroNeedsWarehouse: "Първо изберете склад",
    stqZeroNothing: "Няма продукти с наличност в склада „{{warehouse}}“ към {{date}}.",
    stqZeroTitle: "Да занулим ли склада „{{warehouse}}“ към {{date}}?",
    stqZeroText_one: "{{count}} продукт получава „Намерено“ 0.",
    stqZeroText_other: "{{count}} продукта получават „Намерено“ 0.",
    stqZeroTextNegative_one: "{{count}} от тях е на минус и също става 0.",
    stqZeroTextNegative_other: "{{count}} от тях са на минус и също стават 0.",
    stqZeroTextCounted_one: "Вече преброеният {{count}} продукт остава както е.",
    stqZeroTextCounted_other: "Вече преброените {{count}} продукта остават както са.",
    stqZeroTextWhole: "Важи за целия склад — филтрите над таблицата не го ограничават.",
    stqZeroCaption: "Наличност към {{date}}",
    stqZeroNegativeTag: "на минус",
    stqZeroAll: "Занули всички ({{count}})",
    stqZeroAllHint: "Всички стават 0. Липса за около {{value}} (по средната цена; точната се смята при записа).",
    stqZeroAllHintNoPrice: "Всички стават 0. Стойността на липсата се смята при записа.",
    stqZeroNegative: "Само минусите ({{count}})",
    stqZeroNegativeHint: "Само продуктите на минус стават 0, без стойност. Останалите чакат да ги преброите.",
    stqZeroNegativeNone: "Няма продукти на минус.",
    stqZeroNoteDraft: "Нищо не се записва, докато не потвърдите инвентаризацията — можете да поправите отделни редове.",
    stqZeroNoteUndo: "Записаната инвентаризация се анулира от Инвентаризации → Справка и наличностите се връщат.",
    stqZeroReason: "Зануляване на склада",
    stqZeroApplied_one: "„Намерено“ 0 за {{count}} продукт — прегледайте и потвърдете инвентаризацията.",
    stqZeroApplied_other: "„Намерено“ 0 за {{count}} продукта — прегледайте и потвърдете инвентаризацията.",
    dashNav: "Табло",
    dashTitle: "Табло",
    dashLocalOff: "Локален режим — таблото не показва състоянието на склада, докато няма връзка с облака.",
    dashQueueAria: "Задачите на склада",
    dashQuickAria: "Бързи действия",
    dashQuickDelivery: "Нова доставка",
    dashQuickWriteoff: "Ново изписване",
    dashQuickTransfer: "Прехвърляне",
    dashQuickStocktake: "Инвентаризация",
    dashKeysQuick: "бързите действия",
    dashKeysRows: "между задачите",
    dashKeysEnter: "действието на реда",
    dashGroupBlocking: "Блокиращи",
    dashGroupShortage: "Излишък от продажби",
    dashGroupDrafts: "Вашите чернови",
    dashGroupWaiting: "Чакащи",
    dashAllClear: "Няма нищо за вършене",
    dashAllClearHint: "Закъснели отчети, незавършени чернови, неплатени доставки и стокови без фактура ще се появят тук.",
    dashSourceFailed: "{{source}} — не се зареди",
    dashRetry: "Опитай пак",
    dashSourcePosting: "Отчетите за разнасяне",
    dashSourceDelivery: "Черновите на доставки",
    dashSourceWriteoff: "Черновите на изписвания",
    dashSourceStocktake: "Незавършените инвентаризации",
    dashSourceTransfer: "Черновите на прехвърляния",
    dashSourceShortage: "Излишъкът от продажби",
    dashSourcePayable: "Неплатените доставки",
    dashSourceNotes: "Стоковите без фактура",
    dashContinue: "Продължи",
    dashTakeOver: "Поеми",
    dashPost: "Разнеси",
    dashPay: "Плати",
    dashCompensate: "Компенсирай",
    dashEditingNow: "в момента редактира {{name}}",
    dashDraftTitleDelivery: "Чернова доставка · {{label}}",
    dashDraftTitleWriteoff: "Чернова изписване · {{label}}",
    dashDraftTitleStocktake: "Чернова инвентаризация · {{label}}",
    dashDraftTitleTransfer: "Чернова прехвърляне · {{label}}",
    dashTaskStaleStocktake: "Незавършена инвентаризация · {{label}}",
    dashTaskHeldDelivery: "Задържана доставка · {{label}}",
    dashTaskReport: "Отчет №{{number}} · {{date}}",
    dashTaskReportContext_one: "{{count}} сметка · оборот",
    dashTaskReportContext_other: "{{count}} сметки · оборот",
    dashTaskReportLate_one: "закъснява {{count}} ден",
    dashTaskReportLate_other: "закъснява {{count}} дни",
    dashTaskReportLateHint: "Неразнесеният отчет държи наличностите неверни — разнесете го.",
    dashTaskReportOne: "№{{number}} от {{date}}",
    dashOldestReport: "най-старият — №{{number}} от {{date}}",
    dashTaskPendingReports_one: "{{count}} отчет за разнасяне",
    dashTaskPendingReports_other: "{{count}} отчета за разнасяне",
    dashTaskShortageHint: "Продадено е повече, отколкото има в склада — компенсирайте с доставка.",
    dashShortageProducts_one: "{{count}} продукт",
    dashShortageProducts_other: "{{count}} продукта",
    dashTaskUnpaid_one: "{{count}} неплатена доставка",
    dashTaskUnpaid_other: "{{count}} неплатени доставки",
    dashOldestWaits_one: "най-старата чака {{count}} ден",
    dashOldestWaits_other: "най-старата чака {{count}} дни",
    dashTaskNotes: "Стокови без фактура · {{supplier}}",
    // Фактура над стокови: редовете на стоковите в листа и в документа
    notesRowsBand: "Стокова {{number}} · {{date}} · вътр. №{{id}}",
    notesRowsHint: "вече е заприходена — фактурата само я обобщава",
    notesRowsCount_one: "{{count}} продукт от стоковата",
    notesRowsCount_other: "{{count}} продукта от стоковите",
    docNoteSection: "От стокова разписка {{number}} · {{date}} · вътр. №{{id}}",
    docNotesLoading: "Зареждане на редовете на стоковите…",
    // Нова доставка без доставчик
    issueSupplier: "Изберете доставчик",
    saveDateFuture: "Доставка не може да е в бъдещето — изберете по-ранен ден или час",
    saveNegTitle: "Продадено без наличност",
    saveNegHead: "{{name}}: {{qty}} продадени без наличност на {{days}}.",
    saveNegWrittenOff: "С дата {{date}} те се отписват и влизат всичките {{incoming}}.",
    saveNegCovered: "С дата {{date}} доставката ще покрие {{covered}} и ще влязат {{rest}}.",
    saveNegMixed: "С дата {{date}} {{writtenOff}} се отписват, доставката ще покрие {{covered}} и ще влязат {{rest}}.",
    saveNegMoveDate: "Ако стоката е дошла на {{day}} — сложи тази дата, тогава ще покрие продаденото.",
    postingZeroHint: "Нищо не се изписва от склада. Разнесете го, за да излезе от чакащите — в справката остава с 0.00.",
    sdDaysEmpty: "Няма продажби на рецептата в периода",
    // „Коригирай общото" в доставката
    tadjNetLabel: "Общо без ДДС — напишете сумата от документа; разликата отива в реда с най-голяма сума",
    tadjGrossLabel: "Общо с ДДС — напишете сумата от документа; разликата отива в реда с най-голяма сума",
    tadjNoRows: "Няма ред с количество и сума, който да поеме разликата",
    tadjTooLarge: "Разликата {{delta}} е по-голяма от реда „{{product}}“ — проверете редовете",
    tadjApplied: "{{delta}} от общото отидоха в „{{product}}“",
    tadjConfirmTitle: "Разлика {{delta}} спрямо редовете?",
    tadjConfirmText: "Това е повече от закръгляне. Сумата на „{{product}}“ става {{value}}, а цената му се изчислява от нея.",
    tadjConfirmUndo: "Поправя се, като въведете сумата на реда ръчно",
    tadjConfirmOk: "Сложи я в „{{product}}“",
    tadjRowNote: "{{delta}} от корекцията на общото",
    // Изписване: стойността на рецептата и недостигът по съставки (wr6)
    wr6IssueShort: "Недостатъчна наличност: {{items}}",
    wr6ShortItem: "{{name}} — нужни {{needed}}, налични {{available}}",
    wr6ShortItemFrom: "{{name}} — нужни {{needed}}, налични {{available}} (за {{recipes}})",
    wr6ShortMore_one: "и още {{count}}",
    wr6ShortMore_other: "и още {{count}}",
    wr6Needed: "нужни",
    wr6Available: "налични",
    wr6OwnShare: "тук {{value}}",
    wr6NeededTotal: "нужни общо {{value}}",
    wr6FitsLabel: "Стига за",
    wr6BandTitle: "Не стига за {{portions}}:",
    wr6FitAction: "Намали на {{portions}}",
    wr6DialogTitle: "Не стига наличност за „{{name}}“",
    wr6DialogText_one: "За {{portions}} не стига {{count}} съставка — наличността е към {{date}} в склад „{{warehouse}}“.",
    wr6DialogText_other: "За {{portions}} не стигат {{count}} съставки — наличността е към {{date}} в склад „{{warehouse}}“.",
    wr6DialogCaption: "Не стигат",
    wr6DialogFitHint: "Толкова стигат наличните съставки при останалите редове. После запишете отново.",
    wr6DialogSplitHint_one: "Рецептата става {{count}} продуктов ред — поправете количеството му или го махнете.",
    wr6DialogSplitHint_other: "Рецептата става {{count}} продуктови реда — поправете количествата на липсващите или ги махнете.",
    wr6DialogNoFit: "Съставките не стигат и за 1 порция при останалите редове.",
    // Приготвени рецепти при инвентаризация (sr6)
    sr6SectionTitle: "Приготвени рецепти",
    sr6SectionHint: "съставките им се прибавят към преброеното",
    sr6PortionsUnit: "порц.",
    sr6PerPortion: "за 1 порция:",
    sr6ContentsLoading: "Зареждане на съставките…",
    sr6ContentsError: "Съставките не се заредиха",
    sr6ContentsEmpty: "Няма складови съставки — махнете рецептата",
    sr6RemoveRecipe: "Премахни „{{name}}“",
    sr6RemoveCaption: "Излизат от преброеното",
    sr6InRecipesChip: "+{{qty}} в рецепти",
    sr6InRecipesTitle: "В приготвени рецепти",
    sr6InRecipesPart: "{{recipe}} × {{portions}} — {{qty}}",
    sr6InRecipesTotal: "общо намерено {{total}}",
    sr6CountLooseHint: "преброй и извън рецептата (или 0)",
    sr6IssueCountLoose: "Преброй и извън рецептата (или 0): {{products}}",
    sr6IssuePortions: "Въведете порции за: {{recipes}}",
    sr6IssueEmptyRecipe: "Рецептата „{{name}}“ няма складови съставки — махнете я",
    sr6BandPinnedRecipes: "(съставки на приготвените рецепти)",
    sr6BandPinnedBoth: "(избрани от списъка и съставки на рецептите)",
    sr6SearchPh: "Търси продукт или рецепта за преброяване…",
    sr6SearchAdded: "добавена",
    sr6CatalogHint: "Отметнете продуктите, които ще броите сега — застават най-отгоре в таблицата, в реда на избора. Кликнете ред, за да въведете „Намерено“ направо тук — Enter минава на следващия. Групата „Рецепти“ са приготвени ястия — отиват в „Приготвени рецепти“ и съставките им се прибавят към преброеното.",
    sr6DocRecipes: "Приготвени рецепти",
    sr6DocInRecipes: "от тях {{qty}} в рецепти",
    // Черновите на изписване, прехвърляне и инвентаризация (кръг 6)
    dr6ContinueDraftNeut: "Продължи незавършеното",
    dr6DiscardAndNewNeut: "Изтрий и започни ново",
    dr6AskCaptionNeut: "Незавършеното",
    dr6AskContinueHintNeut: "Отваря листа с неговите редове.",
    dr6LockTextNeut: "{{name}} го редактира в момента. Ако го поемете, промените на {{first}} спират да се пазят, а {{first}} ще види, че сте поели редакцията.",
    dr6TakeOverFailed: "Черновата не можа да бъде поета — опитайте пак",
    dr6DeleteDraftText: "Черновата и всичките ѝ редове се изтриват. В склада още нищо не е записано, затова наличностите не се променят.",
    dr6NoWarehouse: "Без склад",
    dr6WoAskTitle: "Да продължите ли незавършеното изписване?",
    dr6WoAskText: "Всеки потребител има само едно незавършено изписване — за да започнете ново, това трябва да се запише или изтрие.",
    dr6WoLockTitle: "Да поемете ли изписването на {{name}}?",
    dr6WoTakeOverToast: "Поехте изписването на {{name}}",
    dr6WoDeleteTitle: "Изтриване на незавършеното изписване?",
    dr6WoPromptTitleBy: "Да продължите ли незавършеното изписване на {{name}}?",
    dr6TrxAskTitle: "Да продължите ли незавършеното прехвърляне?",
    dr6TrxAskText: "Всеки потребител има само едно незавършено прехвърляне — за да започнете ново, това трябва да се запише или изтрие.",
    dr6TrxLockTitle: "Да поемете ли прехвърлянето на {{name}}?",
    dr6TrxTakeOverToast: "Поехте прехвърлянето на {{name}}",
    dr6TrxDeleteTitle: "Изтриване на незавършеното прехвърляне?",
    dr6TrxPromptTitleBy: "Да продължите ли незавършеното прехвърляне на {{name}}?",
    dr6StkAskText: "Всеки потребител има само една незавършена инвентаризация — за да започнете нова, тази трябва да се запише или изтрие.",
    dr6StkLockTitle: "Да поемете ли инвентаризацията на {{name}}?",
    dr6StkTakeOverToast: "Поехте инвентаризацията на {{name}}",
    dr6StkDeleteTitle: "Изтриване на незавършената инвентаризация?",
    dr6StkDeleteTitleLabel: "Изтриване на незавършената инвентаризация на „{{label}}“?",
    // Черновата на инвентаризацията: продукти + приготвени рецепти
    dr6StkCountedLines_one: "{{count}} преброен ред",
    dr6StkCountedLines_other: "{{count}} преброени реда",
    sd6DeletedChip: "изтрит",
    sd6DeletedHint: "Продуктът е изтрит в организацията. Историята му остава, но не се предлага за нови документи.",
  },

  // Споделената таблица на справките (src/components/dataTable) — общи низове
  // за менюто на колоната, панела с колоните, пагинацията и реда „Общо".
  dataTable: {
    hourShort: "ч",
    minuteShort: "мин",
    sortAsc: "Сортирай възходящо",
    sortDesc: "Сортирай низходящо",
    hideColumn: "Скрий колоната",
    clearColumnFilter: "Изчисти филтъра",
    columnMenuFor: "Меню на колона {{column}}",
    filterTextHint: "Съдържа…",
    filterFrom: "от",
    filterTo: "до",
    filterSearch: "Търси стойност",
    filterSelectAll: "Всички",
    filterClear: "Изчисти",
    filterNoValues: "Няма стойности",
    columns: "Колони",
    density: "Плътност",
    density_compact: "Сбита",
    density_normal: "Нормална",
    density_roomy: "Широка",
    resetLayout: "Върни подредбата по подразбиране",
    pageRange: "{{from}}–{{to}} от {{total}}",
    goToPage: "Отиди на страница {{page}}",
    perPage: "{{count}} на страница",
    prev: "Назад",
    next: "Напред",
    emptyTitle: "Няма редове",
    emptyHint: "Изчисти филтрите или разшири периода.",
    totalsLabel: "Общо · {{count}}",
    mobileControls: "Подредба",
    mobileSortSection: "Подреди по",
    mobileFilterSection: "Филтри",
    clearAllFilters: "Изчисти всички филтри",
    columnMenuHint: "Подредба, филтър, скриване на колоната",
    resizeColumn: "Оразмери колона {{column}} (двоен клик връща ширината)",
    moveColumn: "Премести колона „{{column}}“ — влачи или ↑/↓",
    columnRequired: "Тази колона не се скрива",
  },

  reportsPage: {
    depositsReport: "Депозити",
    paidWithDepositShort: "депозит № {{id}} · {{amount}}",
    // Сметка, покрита изцяло с депозит — методът вече го казва, тук е номерът
    paidWithDepositNumber: "депозит № {{id}}",
    depositColumn: "Депозит",
    dpStatus_active: "Активен",
    dpStatus_used: "Използван",
    dpStatus_expired: "Изтекъл",
    dpStatus_attached: "Закачен към маса",
    dpStatus_cancelled: "Анулиран",
    dpKpiTaken: "Взети",
    dpKpiTakenSub: "Брой: {{count}} · в брой {{cash}}",
    dpKpiTakenSubCancelled: "Брой: {{count}} · в брой {{cash}} · анулирани {{cancelledCount}} ({{cancelled}})",
    dpKpiUsed: "Използвани",
    dpKpiUsedSub: "Брой: {{count}} · {{percent}} % от взетото",
    dpKpiUsedSubEmpty: "Брой: {{count}}",
    dpKpiBurned: "Изгорели",
    dpKpiBurnedSub: "Неползвани части и изтекли",
    dpKpiActive: "Активни",
    dpKpiExpired: "Изтекли",
    dpKpiCountSub: "Брой: {{count}}",
    dpKpiOutstanding: "Активни в момента",
    dpKpiOutstandingSub: "Брой: {{count}} · извън периода",
    dpKicker_created: "Взети в периода",
    dpKicker_used: "Използвани в периода",
    dpKicker_valid_until: "„За дата“ в периода",
    dpDepositOne: "{{count}} депозит",
    dpDeposits: "{{count}} депозита",
    dpSearchPlaceholder: "Търсене по №, име, описание, сметка, бон…",
    dpNoData: "Няма депозити",
    dpEmptyHint: "Няма депозити за избрания период по тази дата.",
    dpBasisLabel: "Период по дата на",
    dpBasisCreated: "Вземане",
    dpBasisUsed: "Използване",
    dpBasisValidUntil: "За дата",
    dpColumnNumber: "№",
    dpColumnCreatedAt: "Взет на",
    dpColumnName: "Име",
    dpColumnDescription: "Описание",
    dpColumnAmount: "Сума",
    dpColumnMethod: "Метод",
    dpColumnValidUntil: "За дата",
    dpColumnStatus: "Статус",
    dpColumnUsedAt: "Използван на",
    dpColumnBill: "Маса",
    dpColumnUsedAmount: "Платено с него",
    dpColumnBurned: "Изгоряло",
    dpColumnCreatedBy: "Взел",
    dpColumnUsedBy: "Сервитьор на сметката",
    dpColumnInvoice: "Фактура №",
    dpInvoiceAction: "Фактурирай",
    // „Бон №" — касовият бон на депозита или защо го няма
    dpColumnReceipt: "Бон №",
    dpReceiptNotRequired: "не се издава",
    dpReceiptUnknown: "неясен бон",
    dpReceiptCardCharged: "картата — без бон",
    dpReceiptMissing: "без бон",
    dpColumnReported: "Отчетен",
    dpReportedYes: "Да",
    dpReportedNo: "Не",
    // Анулирането — причината (или „Анулирай"), кога и кой
    dpColumnCancel: "Анулиране",
    dpColumnCancelledAt: "Анулиран на",
    dpColumnCancelledBy: "Анулирал",
    dpNoExpiry: "без срок",
    kitchenMonitors: "Монитори",
    kmListKicker: "Редове по статуси",
    kmAvgKicker: "Средно време",
    kmTable: "Маса",
    kmStation: "Станция",
    kmQty: "Кол.",
    kmEnteredAt: "Влязла",
    kmStatusInProgress: "В процес",
    kmStatusCooked: "Сготвено",
    kmStatusIssued: "Издадено",
    kmStatusServed: "Сервирано",
    kmType: "Тип",
    kmStartedBy: "Започнал",
    kmCookedBy: "Сготвил",
    kmIssuedBy: "Издал",
    kmServedBy: "Сервирал",
    kmResultOne: "{{count}} ред",
    kmResults: "{{count}} реда",
    kmNoData: "Няма статус преходи в избрания период",
    // Sidebar
    reports: "Отчети",
    exportExcel: "Експорт в Excel",
    exportPreparing: "Подготовка на файла...",
    exportFailed: "Неуспешен експорт",
    exportTooManyBills:
      "Сметките са {{bills}}, а в един Excel влизат до {{limit}}. Файлът не е направен — стеснете периода (или филтрите) и опитайте пак.",
    tableReports: "Контрол",
    generalReports: "Продажби",
    reportsManagement: "Отчети",
    fiscalReports: "Фискални",
    categoriesReport: "По групи",
    collapse: "Свий",
    billsHistory: "Справка сметки",
    billsSplits: "Разделени маси",
    cancellations: "Сторно",
    invoices: "Фактури",
    personalReports: "Персонални отчети",
    establishmentReports: "Отчети на заведението",
    assortmentReport: "По артикули",
    // В режим „със склад" продаваемото е рецепта → същата справка, друго име.
    recipesReport: "По рецепти",
    discountsReport: "Отстъпки",
    // Справката „Клиенти" (клиентски отстъпки и надбавки) — sidebar и заглавие
    clientsReport: "Клиенти",
    priceChanges: "Променени цени",
    priceChangesTitle: "Променени цени",
    cardPayments: "Картови плащания",
    cardPaymentsTitle: "Картови плащания",
    cardPaymentsConsumedKicker: "С БОН",
    cardPaymentsUnresolvedKicker: "ВИСЯЩИ",
    cardPaymentsVoidedKicker: "ВЪРНАТИ",
    cardPaymentsResults: "{{count}} тегления",
    cardPaymentsResultOne: "1 теглене",
    cardPaymentsNoData: "Няма картови тегления за периода",
    cardPaymentsListKicker: "ДВИЖЕНИЯ ПО ТЕРМИНАЛА",
    cardPaymentsColTime: "Час",
    cardPaymentsColBill: "Сметка",
    cardPaymentsColAmount: "Сума",
    cardPaymentsColStatus: "Статус",
    cardPaymentsColPan: "Карта",
    cardPaymentsColAuth: "Код",
    cardPaymentsColReceipt: "Бон №",
    cardPaymentsColMount: "Терминал",
    cardPaymentsColRefund: "Върнато (сторно)",
    cardPaymentsTerminal: "Каса",
    cardPaymentsStatus_consumed: "С бон",
    cardPaymentsStatus_voided: "Върнато",
    cardPaymentsStatus_unknown: "Неясно",
    cardPaymentsStatus_void_failed: "Без бон!",
    cardPaymentsMount_pc: "терминал на касата",
    cardPaymentsMount_fiscal: "терминал на принтера",
    fiscalCardPending: "Платена с карта — не теглете повторно",
    priceChangesColKind: "Вид",
    priceChangesKindProduct: "Продукт",
    priceChangesKindAddition: "Добавка",
    priceChangesOldPrice: "Стара цена",
    priceChangesNewPrice: "Нова цена",
    priceChangesDelta: "Разлика",
    priceChangesLineEffect: "Разлика общо",
    priceChangesActive: "Активна",
    priceChangesReverted: "Върната",
    priceChangesDirection: "Вид промяна",
    priceChangesDown: "Намалена цена",
    priceChangesUp: "Увеличена цена",
    priceChangesCountKicker: "Промени в периода",
    priceChangesCountTitle: "Сменени цени",
    priceChangesDownTitle: "Общо намалена сума",
    priceChangesUpTitle: "Общо увеличена сума",
    priceChangesListKicker: "Списък променени цени",
    priceChangesResults: "{{count}} промени",
    priceChangesResultOne: "{{count}} промяна",
    priceChangesNoData: "Няма променени цени за избрания период.",
    waitersReport: "По сервитьори",
    stationsReport: "По станции",
    dashboard: "Дашборд",
    dashboardSection: "Дашборд",
    dashboardTitle: "Дашборд",
    dashboardOpenTables: "Отворени маси",
    dashboardOpenCount: "Брой маси",
    dashboardOpenAmount: "Обща сума",
    dashboardClosedToday: "Затворени сметки днес",
    dashboardClosedCount: "Брой сметки",
    dashboardCash: "В брой",
    dashboardCard: "С карта",
    dashboardMixed: "Смесени",
    dashboardBills: "сметки",
    dashboardDailyReports: "Дневни обороти (последни 7 дни)",
    dashboardNoReport: "Няма отчет",
    dashboardToday: "Днес",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    dashboardBackToModules: "Към модулите",
    dashboardModuleLabel: "Модул Справки",
    dashboardAdminRole: "Администратор",
    dashboardRevenueByDays: "Оборот по дни",
    dashboardLast7Days: "Последните 7 дни",
    dashboardDailyRevenue: "Дневен оборот",
    dashboardAverage: "Средно",
    dashboardNoRevenue: "Няма оборот",
    dashboardOpen: "Отворени",
    dashboardClosedTodayShort: "Затворени днес",
    dashboardTotalAmountLabel: "Обща сума",
    dashboardBill: "сметка",
    dashboardBillsMany: "сметки",
    dashboardTableOne: "маса",
    dashboardTableMany: "маси",
    dashboardTablesOpenNow: "Отворени сега",
    dashboardTablesClosedToday: "Затворени днес",
    dashboardTablesOccupancy: "Дял отворени",
    dashboardTablesNone: "Няма активност днес",
    dashboardTotalShort: "Общо",
    dashboardLogout: "Изход",
    dashboardAvgCheck: "Среден бон",
    dashboardAvgTableTime: "Средно време на маса",
    dashboardVoidsToday: "Сторнирания днес",
    dashboardDiscountsToday: "Отстъпки днес",
    dashboardMinShort: "мин",
    dashboardHourShort: "ч",
    dashboardPcs: "бр.",
    dashboardTopKicker: "Топ 5 днес",
    dashboardTopSubtitle: "Най-продавани по оборот",
    dashboardTopEmpty: "Няма продажби днес",
    dashboardHeatKicker: "Натовареност",
    dashboardHeatSubtitle: "Закрити сметки по час — последните 8 дни",
    dashboardHeatEmpty: "Няма данни за периода",
    dashboardVoidsHint:
      "Обща стойност на сторнираните продукти днес (по момент на сторниране)",
    dashboardDiscountsHint:
      "Обща стойност на всички отстъпки — на цяла сметка и на отделни артикули — от закритите днес сметки",
    dashboardBillWithDiscount: "в 1 сметка",
    dashboardBillsWithDiscount: "в {{count}} сметки",
    dashboardStationsKicker: "Оборот по обекти",
    dashboardStationsSubtitle: "Разпределение за днес",

    // Common
    refresh: "Обнови",
    filters: "Филтри",
    clear: "Изчисти",
    apply: "Приложи",
    fromDate: "От дата",
    toDate: "До дата",
    totalRecords: "Общо {{count}} записа",
    totalReports: "Общо {{count}} отчета",
    totalLabel: "Общо:",
    totalAmount: "Обща сума",
    view: "Виж",
    noData: "Няма данни",
    waiter: "Сервитьор",
    date: "Дата",
    reportDate: "Дата на отчета",
    createdAt: "Дата на създаване",
    amount: "Сума",
    fiscalAmount: "Сума ФП",
    baseAmount: "Базова сума",
    productName: "Продукт",
    category: "Категория",
    station: "Станция",
    quantity: "Количество",
    averagePrice: "Средна цена",
    totalProducts: "Общо продукти",
    totalQuantity: "Общо количество",
    dateRange: "Период",
    total: "Общо",

    // BillsHistory
    billsHistoryTitle: "Справка сметки",
    tables: "Маси",
    table: "Маса",
    status: "Статус",
    statusOpen: "Отворени",
    // Единствено число — статусът на ЕДНА сметка (точката в реда, картата
    // на телефон). Множественото се ползва за филтъра, където се избират групи.
    statusOpenOne: "Отворена",
    statusClosedOne: "Затворена",
    statusClosed: "Затворени",
    opened: "Отворена",
    closed: "Затворена",
    duration: "Продължителност",
    orders: "Поръчки",
    cancelledItems: "Сторнирани",
    cancelledLabel: "Сторно: {{count}}",
    payment: "Плащане",
    paymentMethod: "Метод на плащане",
    noTableData: "Няма данни за маси",
    hours: "ч",
    minutes: "мин",
    cash: "Брой",
    card: "Карта",
    billsHistoryActivityEmpty: "Няма активност в избрания период",
    billsHistoryResults: "{{count}} резултата",
    billsHistoryResultOne: "{{count}} резултат",
    billsHistoryNoResults: "Няма сметки за избраните филтри",
    billsHistoryReceiptNumber: "Фискален бон",
    billsHistoryClearFilters: "Изчисти филтри",

    // Редизайн 0.0.218 — bento подредба + споделената таблица.
    openMenu: "Отвори менюто",
    durationShort: "Време",
    itemsShort: "Арт.",
    guestsCount: "Брой гости",
    billIdShort: "№ сметка",
    ordersShort: "Поръчки",
    cashShort: "В брой",
    cardShort: "С карта",
    cancelledCountShort: "Сторн. бр.",
    discount: "Отстъпка",
    receiptNumber: "Бон №",
    restored: "Възстановена",
    billsHistoryKpiBills: "Сметки",
    billsHistoryKpiBillsUnit: "сметки",
    billsHistoryKpiScopeNote:
      "Показателите горе са за целия период — филтърът по статус, плащане и търсенето менят само списъка и реда „Общо“.",
    billsHistoryIsolateMarked: "Покажи само сметките с този знак",
    billsHistoryKpiRevenue: "Оборот",
    billsHistoryKpiRevenueSub: "затворени сметки",
    billsHistoryKpiAvgTicket: "Средна сметка",
    billsHistoryKpiAvgTime: "Средно време на маса",
    billsHistoryKpiAvgTimeSub: "на закрита сметка",
    billsHistoryHourlyTitle: "Сметки по час",
    billsHistoryDailyTitle: "Сметки по ден",
    billsHistoryDailyPeak: "най-силен {{day}} · {{count}} сметки",
    billsHistoryByHour: "по час",
    billsHistoryByDay: "по ден",
    billsHistoryHourlyHint: "по час на затваряне",
    billsHistoryHourlyPeak: "по час на затваряне · пик {{from}}–{{to}} ч",
    billsHistoryHourlyBar: "{{hour}}:00 · {{count}} бр.",
    billsHistoryInvoicedOnly: "Само с фактура",
    billsHistoryTableKicker: "Сметки",
    billsHistoryTableCount: "{{count}} сметки",
    billsHistoryTableCountOne: "{{count}} сметка",
    billsHistoryTableHint: "Клик върху ред отваря историята на операциите",
    billsHistorySearchPlaceholder: "Търси маса",
    billsHistoryEmptyHint:
      "Изчисти филтрите, разшири периода или потърси друга маса.",

    // Дашборд 0.0.219 — периодна bento подредба.
    // Сторно 0.0.220 — три изгледа върху едни и същи редове.
    cardPaymentsRowOne: "{{count}} движение",
    cardPaymentsRowMany: "{{count}} движения",
    cardPaymentsListHint: "Клик върху ред отваря сметката",
    cardPaymentsEmptyHint: "Няма движения от картовия терминал за този период.",
    cardPaymentsReconcileHint:
      "Сверка в края на деня: „С бон“ трябва да съвпада с картата в отчета на заведението, „С бон + Висящи“ — с „край на деня“ на самия терминал, а банката вижда само „С бон“ (върнатите се нулират помежду си).",
    cardPaymentsTerminalsKicker: "Сверка по апарат",
    cardPaymentsTerminalsTitle: "{{count}} терминала",
    voidsViewList: "Списък",
    voidsByWaiter: "По сервитьор",
    voidsByProduct: "По продукт",
    voidsRowsKicker: "Сторнирани редове",
    voidsInBills: "в {{count}} сметки",
    voidsInBillsOne: "в {{count}} сметка",
    voidsValue: "Стойност",
    voidsShareOfGross: "{{share}} % от затворения оборот",
    voidsValueSub: "сторнирана стойност",
    voidsAfterKitchen: "След кухня",
    voidsRealLoss: "реална загуба на продукт",
    voidsPerRow: "Средно на ред",
    voidsPerRowSub: "на сторниран ред",
    voidsRows: "Сторно редове",
    voidsTime: "Час",
    voidsCancelledBy: "Сторнирал",
    voidsScrap: "Брак",
    voidsScrapShort: "Брак",
    voidsBillOpenFailed: "Сметката не може да се отвори",
    voidsScrapCount: "{{count}} брак",
    voidsPlain: "Сторно",
    voidsSearchPlaceholder: "Маса, продукт, сервитьор, причина…",
    voidsShareOfRevenue: "% от оборота му",
    voidsRowOne: "{{count}} ред",
    voidsRowMany: "{{count}} реда",
    voidsListHint: "Клик върху ред отваря сметката",
    voidsWaiterHint: "Кой колко отписва спрямо оборота си",
    voidsProductHint: "Кое отпада най-често",
    voidsEmptyTitle: "Няма сторно за периода",
    voidsEmptyHint: "Това е добра новина. Смени периода или провери филтрите.",
    voidsBatchHint: "Сторнирани заедно — {{count}} реда с едно действие",
    voidsBatchColumn: "Заедно",
    dashClosed: "Закрити",
    dashBillsCount: "{{count}} сметки",
    dashBillsCountOne: "{{count}} сметка",
    dashAvgCheck: "Средна сметка",
    dashItemsCount: "{{count}} артикула",
    dashItemsCountOne: "{{count}} артикул",
    dashCashCard: "В брой / карта",
    dashVoids: "Сторно",
    dashVoidsCount: "{{count}} бр.",
    dashDiscounts: "Отстъпки",
    dashDiscountsSub: "{{count}} сметки · {{share}} % от брутото",
    dashDiscountsSubOne: "{{count}} сметка · {{share}} % от брутото",
    dashOpen: "Открити",
    dashNoOpenTables: "няма отворени маси",
    dashWaitersTitle: "Оборот по сервитьори",
    dashStationsTitle: "По станции",
    dashTopTitle: "Топ 5 по оборот",
    dashFullReport: "Пълна справка",
    dashAllItems: "Всички артикули",
    dashPieces: "{{count}} бр.",
    dashNoData: "Няма данни за периода",
    dashAlertsTitle: "За внимание",
    dashAlertsNone: "нищо за проверка в този период",
    invoice: "Фактура",
    priceChangesSearchPlaceholder: "Търсене по продукт, маса или потребител",
    priceChangesTableHint: "Клик върху ред отваря историята на операциите",
    priceChangesEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    kmRowsKpi: "Редове",
    kmRowsKpiSub: "с проследени преходи",
    kmTableHint: "периодът е по „Влязла“, времената — до първия преход към статуса",
    kmSearchPlaceholder: "Търси маса, артикул, оператор…",
    kmEmptyHint:
      "Разшири периода или провери дали мониторите отчитат преходите.",
    billsSplitsWaitersSub: "участвали в разделянията",
    billsSplitsProductsSub: "{{count}} прехвърлени продукта",
    billsSplitsAvgSub: "стойност на едно разделяне",
    billsSplitsRowOne: "{{count}} разделяне",
    billsSplitsRowMany: "{{count}} разделяния",
    billsSplitsTableHint: "клик върху ред отваря прехвърлените продукти",
    billsSplitsSearchPlaceholder: "Търси маса, сервитьор или коментар",
    billsSplitsEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    billsSplitsComment: "Коментар",
    billsSplitsNoItems: "Няма записани продукти за това разделяне",
    categoriesOpenItems: "Отвори артикулите в {{name}}",
    itemDaysSubtitle: "Оборот по дни",
    itemDaysQuantity: "Количество",
    itemDaysAvgPrice: "Средна цена",
    itemDaysDayOne: "{{count}} ден с продажби",
    itemDaysDaysMany: "{{count}} дни с продажби",
    itemDaysEmpty: "Няма продажби в избрания период",
    itemDaysFailed: "Разбивката по дни не се зареди.",
    itemDaysClose: "Затвори",
    dashLoadFailed: "Данните не се заредиха.",
    dashPaymentMixTitle: "Как е платено",
    dashPaymentMixEmpty: "Няма закрити сметки за периода.",
    dashPaymentOther: "Друг метод",
    dashAlertOpenLong: "Маса {{table}} е отворена {{time}}",
    dashAlertBigDiscount: "Отстъпка {{percent}} % · маса {{table}}",
    dashDaysTitle: "Оборот по работни дни",
    dashDaysHint: "{{range}} · маркиран е избраният период",
    dashDaysAverage: "средно {{amount}}",
    dashThousandShort: "к",
    dashDaysEmpty: "Няма приключени сметки за {{range}}",
    periodYesterday: "Вчера",
    periodToday: "Днес",
    period7d: "7 дни",
    periodThisMonth: "Този месец",
    periodPrev: "Предишен период",
    periodNext: "Следващ период",
    shift: "Смяна",
    allShifts: "Всички смени",
    shiftNumber: "Смяна {{number}}",
    shiftsDiffer: "Избраните дни са с различно работно време",

    // FiscalIssues
    fiscalIssues: "Фискални проблеми",
    fiscalIssuesTitle: "Фискални проблеми",
    fiscalIssuesSubtitle: "Сметки и сторна без потвърден фискален бон",
    fiscalIssuesListTitle: "Сметки без касова бележка",
    fiscalIssuesListSubtitle:
      "Затворени сметки, при които фискалният бон не е потвърден",
    fiscalIssuesTotal: "Общо проблеми",
    fiscalIssuesFailed: "Отказани от принтера",
    fiscalIssuesUnknown: "Неизвестен изход",
    fiscalIssuesClosedAt: "Затворена",
    fiscalIssuesStatus: "Статус",
    fiscalIssuesError: "Грешка от принтера",
    fiscalIssuesRetry: "Опитай пак",
    fiscalIssuesRetrySuccess: "Касовата бележка е издадена",
    fiscalIssuesStornoListTitle: "Сторно без документ",
    fiscalIssuesStornoListSubtitle:
      "Сметки с касова бележка, чието сторно не е потвърдено на хартия",
    fiscalIssuesStornoRetrySuccess: "Сторно документът е издаден",
    fiscalIssuesReceiptNo: "Бон №",
    fiscalIssuesRetryTimeout:
      "Принтерът не отговори навреме — проверете отново след минута",
    fiscalIssuesRetryError: "Принтерът върна грешка",
    fiscalIssuesEmpty: "Няма проблемни фискализации за избрания период.",
    fiscalIssuesDays1: "Последните 24 часа",
    fiscalIssuesDays7: "Последните 7 дни",
    fiscalIssuesDays30: "Последните 30 дни",
    fiscalStatus_failed: "Отказан",
    fiscalStatus_timeout: "Неизвестен",
    fiscalStatus_pending: "Изчаква",
    fiscalStatusFailedHint:
      "Принтерът отказа печата — бон не е излизал. Отстранете причината и опитайте пак.",
    fiscalStatusUnknownHint:
      "Резултатът не е стигнал до сървъра — документът може вече да е излязъл. Проверете лентата на апарата, преди да повторите; повторението е безопасно само от касата, от която е закрита сметката.",
    fiscalIssuesRetryUnknownTitle: "Документът може вече да е излязъл",
    fiscalIssuesRetryUnknownBody:
      "Изходът е неизвестен. Първо проверете лентата на апарата (КЛЕН) и „Бон №“ в „Справка сметки“ — ако документът е излязъл, не повтаряйте. „Опитай пак“ оттук печата на принтера на ВАШАТА сесия; ако той е друг апарат, ще излезе втори документ.",
    fiscalIssuesStornoRetryUnknownBody:
      "Изходът е неизвестен — сторното може да е излязло на хартия или да чака платено на апарата. Първо проверете лентата на апарата (КЛЕН): ако сторно документът е излязъл, не повтаряйте. „Опитай пак“ праща сторното на принтера, на който е започнало — той довършва недовършеното или го отпечатва.",

    // BillsSplits
    billsSplitsTitle: "Разделени маси",
    totalSplits: "Общо разделяния",
    transferredProducts: "Прехвърлени продукти",
    fromTable: "От маса",
    toTable: "Към маса",
    fromTableId: "От маса (ID)",
    toTableId: "Към маса (ID)",
    products: "Продукти",
    noSplitsData: "Няма данни за разделени маси",
    billsSplitsSummaryKicker: "Разделяния в периода",
    billsSplitsSummaryTitle: "Общ брой",
    billsSplitsWaiters: "Сервитьори",
    billsSplitsAmountTitle: "Обща сума",
    billsSplitsAvg: "Средно на разделяне",
    billsSplitsActivityKicker: "Активност",
    billsSplitsActivityHourly: "Разделяния по час",
    billsSplitsActivityDaily: "Разделяния по ден",
    billsSplitsActivityEmpty: "Няма активност в избрания период",
    billsSplitsListKicker: "Списък разделяния",

    // Cancellations
    cancellationsTitle: "Сторно",
    totalCancelled: "Общо сторнирани",
    defectiveItems: "Бракувани артикули",
    billId: "ID на сметка",
    selectUsers: "Избери потребители",
    defectiveOnly: "Само бракувани продукти",
    noCancellations: "Няма сторнирани продукти",
    bill: "Сметка",
    product: "Продукт",
    qty: "Кол-во",
    unitPrice: "Цена (единична)",
    // Стойността идва от полето „Коментар:" на сторно модала (изпраща се като
    // `reason`) — затова колоната се казва „Коментар", не „Причина".
    comment: "Коментар",
    defective: "✓ Брак",
    cancelled: "Сторно",
    cancellationsSummaryKicker: "Сторнирания в периода",
    cancellationsSummaryTitle: "Общ брой",
    cancellationsAmountKicker: "Сума в периода",
    cancellationsAmountTitle: "Стойност на сторнираното",
    cancellationsAvgLabel: "Средно на артикул",
    cancellationsActivityKicker: "Активност",
    cancellationsActivityHourly: "Сторно по час",
    cancellationsActivityDaily: "Сторно по ден",
    cancellationsActivityEmpty: "Няма сторнирания в избрания период",
    cancellationsListKicker: "Списък сторно",
    cancellationsResults: "{{count}} записа",
    cancellationsResultOne: "{{count}} запис",
    cancellationsClearFilters: "Изчисти филтри",
    cancellationsDefectiveLabel: "Брак",
    cancellationsRegularLabel: "Сторно",

    // AssortmentReport
    assortmentProductsKicker: "Артикули в периода",
    assortmentProductsTitle: "Уникални продукти",
    assortmentQuantityKicker: "Продадено количество",
    assortmentQuantityTitle: "Сбор по всички артикули",
    assortmentAmountKicker: "Оборот в периода",
    assortmentAmountTitle: "Сума от продажби",
    assortmentAvgLabel: "Средно на артикул",
    assortmentListKicker: "Списък артикули",
    assortmentResults: "{{count}} артикула",
    assortmentResultOne: "{{count}} артикул",
    assortmentClearFilters: "Изчисти филтри",
    assortmentSearchPlaceholder: "Търси артикул",
    assortmentNoItems: "Няма артикули в избрания период",
    // Вид на реда: самостоятелна продажба или продадена добавка
    assortmentColKind: "Тип",
    assortmentKindAssortment: "Асортимент",
    assortmentKindRecipe: "Рецепта",
    assortmentKindAddon: "Добавка",
    assortmentKindLunch: "Обедно меню",
    lunchTag: "Обедно",
    lunchScopeAll: "Всички",
    lunchScopeRegular: "Без обедно",
    lunchScopeLunch: "Само обедно",
    lunchScopeLabel: "Обедно меню",
    categoriesKindRegular: "Основно меню",

    // PersonalReportsPage
    allUsers: "Всички потребители",
    noReportsFound: "Няма намерени отчети",
    reportNumber: "№",
    user: "Потребител",
    bills: "Сметки",
    cashAmount: "В брой",
    cardAmount: "Карта",
    details: "Детайли",

    // DiscountsReport
    clientsTitle: "Клиенти",
    discountsBillId: "Сметка",
    discountsClient: "Клиент",
    discountsColType: "Тип",
    discountTag: "Отстъпка",
    discountsType: "Вид отстъпка",
    discountsPercent: "Процент",
    discountsAmount: "Корекция",
    discountsPaid: "Платено",
    discountsBillsCount: "Сметки с отстъпка",
    discountsTotalDiscount: "Обща отстъпка",
    discountsTotalPaid: "Общо платено",
    discountsTotalOriginal: "Обща сума",
    discountsNoData: "Няма данни за отстъпки",
    discountTypeFixedPercent: "Фиксиран процент",
    discountTypeCashback: "Кешбек",
    discountTypeBillAmount: "На цялата сметка",
    surchargeTag: "Надбавка",
    discountsBillsKicker: "Сметки в периода",
    discountsBillsTitle: "С отстъпка или надбавка",
    discountsAmountKicker: "Отстъпки",
    discountsAmountTitle: "Общо дадени отстъпки",
    discountsAmountAvgLabel: "Средно на сметка",
    surchargesKicker: "Надбавки",
    surchargesTitle: "Общо добавени надбавки",
    surchargesCountLabel: "Брой сметки",
    discountsPaidKicker: "Платена сума",
    discountsPaidTitle: "След корекции",
    discountsPaidSharedLabel: "Дял от общото",
    discountsListKicker: "Списък отстъпки и надбавки",
    discountsResults: "{{count}} сметки",
    discountsResultOne: "{{count}} сметка",
    discountsClearFilters: "Изчисти филтри",

    // WaitersReport - Справка по сервитьори
    waitersTitle: "Справка по сервитьори",
    methodCountColumn: "{{method}} · бр.",
    waitersCashCount: "Бр. в брой",
    waitersCardCount: "Бр. с карта",
    waitersMixedCount: "Бр. смесени",
    waitersTotalCash: "Общо в брой",
    waitersTotalCard: "Общо с карта",
    waitersNoData: "Няма данни за сервитьори",
    waitersDetailTitle: "Детайли по дати",
    waitersRevenueKicker: "Оборот в периода",
    waitersRevenueTitle: "Обща сума",
    waitersRevenueAvgLabel: "Средно на сервитьор",
    waitersSplitKicker: "Разпределение",
    waitersSplitTitle: "По методи на плащане",
    waitersListKicker: "Списък сервитьори",
    waitersResults: "{{count}} сервитьори",
    waitersResultOne: "{{count}} сервитьор",
    waitersClearFilters: "Изчисти филтри",

    // StationsReport - Справка по обекти (станции)
    stationsTitle: "Справка по обекти",
    stationsName: "Станция",
    stationsCashCount: "Бр. в брой",
    stationsCardCount: "Бр. с карта",
    stationsMixedCount: "Бр. смесени",
    stationsTotalCash: "Общо в брой",
    stationsTotalCard: "Общо с карта",
    stationsRevenueKicker: "Оборот в периода",
    stationsRevenueTitle: "Обща сума",
    stationsRevenueAvgLabel: "Средно на обект",
    stationsSplitKicker: "Разпределение",
    stationsSplitTitle: "По методи на плащане",
    stationsListKicker: "Списък обекти",
    stationsResults: "{{count}} обекта",
    stationsResultOne: "{{count}} обект",
    stationsClearFilters: "Изчисти филтри",

    // Personal reports list
    personalTitle: "Персонални отчети",
    personalRevenueKicker: "Оборот в периода",
    personalRevenueTitle: "Обща сума",
    personalRevenueAvgLabel: "Средно на отчет",
    personalSplitKicker: "Разпределение",
    personalSplitTitle: "По методи на плащане",
    personalListKicker: "Списък отчети",
    personalResults: "{{count}} отчета",
    personalResultOne: "{{count}} отчет",
    personalClearFilters: "Изчисти филтри",
    personalBillsLabel: "Сметки",

    // EstablishmentReportsPage
    personalReportsCount: "Персонални отчети",
    establishmentTitle: "Отчет на заведението",
    establishmentRevenueKicker: "Оборот в периода",
    establishmentRevenueTitle: "Обща сума",
    establishmentRevenueAvgLabel: "Средно на отчет",
    establishmentSplitKicker: "Разпределение",
    establishmentSplitTitle: "По методи на плащане",
    establishmentListKicker: "Списък отчети",
    establishmentResults: "{{count}} отчета",
    establishmentResultOne: "{{count}} отчет",
    billOpsBillKicker: "Сметка",
    billOpsCancelStockFailedTitle: "Сторното не е направено",
    billOpsCancelStockFailedText:
      "Складът не успя да върне стоката ({{reason}}). Нищо не е отпечатано — опитайте пак или се свържете с поддръжката.",
    billOpsCardNoReceipt: "БЕЗ БОН — не теглете повторно",
    billOpsCardRefunded: "върнато при сторно:",
    billOpsCardSection: "Картови тегления",
    billOpsCardVoided: "върнато на картата",
    billOpsCardWithReceipt: "с бон",
    billOpsClient: "Клиент: {{name}}",
    billOpsClose: "Затвори",
    billOpsDefective: "брак",
    billOpsDuration: "Продължителност {{value}}",
    billOpsEmpty: "Няма операции",
    billOpsEventAddItems: "Добавени артикули",
    billOpsEventCancel: "Сторно",
    billOpsEventClose: "Затваряне",
    billOpsEventPreliminaryBill: "Предварителна сметка",
    billOpsEventDiscountBill: "Отстъпка върху сметката",
    billOpsEventDiscountBillRemoved: "Премахната отстъпка върху сметката",
    billOpsEventAmountDiscount: "Отстъпка на цялата сметка",
    billOpsEventAmountDiscountRemoved: "Премахната отстъпка на цялата сметка",
    billOpsEventDiscountItem: "Отстъпка върху продукт",
    billOpsEventDiscountItemRemoved: "Премахната отстъпка върху продукт",
    billOpsEventOpen: "Отваряне",
    billOpsEventPayment: "Плащане",
    billOpsEventPriceChange: "Промяна на цена",
    billOpsEventPriceRestored: "Върната цена от менюто",
    billOpsEventRestore: "Възстановяване на сметката",
    billOpsKitchenHeldMinutes: "Задържана за кухнята: {{minutes}} мин.",
    billOpsKitchenHeldManual: "Задържана за кухнята: ръчно",
    billOpsKitchenStillHeld: "още не е пусната",
    billOpsKitchenReleasedManual: "пусната ръчно",
    billOpsKitchenReleasedManualBy: "пусната ръчно от {{name}}",
    billOpsKitchenReleasedTimer: "пусната автоматично",
    billOpsKitchenReleasedClose: "пусната автоматично при закриване на сметката",
    billOpsKitchenReleasedEdge: "пусната автоматично от касата — без интернет",
    billOpsRestoreReceipt: "Сторниран бон № {{number}}",
    billOpsRestoreReport: "Изключена от личен отчет № {{number}}",
    billOpsRestoreReportBoth:
      "Изключена от личен отчет № {{number}} и от отчет на заведението № {{establishment}}",
    billOpsRestoredTimes_one: "възстановена {{count}} път",
    billOpsRestoredTimes_other: "възстановена {{count}} пъти",
    billOpsEventSplitIn: "Получено от друга сметка",
    billOpsEventSplitOut: "Разделяне на сметка",
    billOpsEventSurchargeBill: "Надбавка върху сметката",
    billOpsEventSurchargeBillRemoved: "Премахната надбавка върху сметката",
    billOpsEventTransfer: "Преместване на гости",
    billOpsFullTransfer: "Цялата сметка #{{id}} е прехвърлена",
    billOpsPaidCard: "Карта",
    billOpsPaidCash: "В брой",
    billOpsReason: "Причина: {{reason}}",
    billOpsSectionOperations: "Операции",
    billOpsSector: "Сектор: {{name}}",
    billOpsStatusClosed: "затворена",
    billOpsStatusOpen: "отворена",
    billOpsTotalCancelled: "Сторно",
    billOpsTotalDiscount: "Отстъпка",
    billOpsTotalItems: "Артикули",
    billOpsTotalPaid: "Платено",
    billOpsTotalSurcharge: "Надбавка",
    billOpsTotalTransferred: "Прехвърлено",
    categoriesCountKicker: "Групи",
    categoriesItemsSub: "продадени бройки",
    categoriesTableCount: "{{count}} групи",
    categoriesTableCountOne: "{{count}} група",
    categoriesGroupColumn: "Група",
    categoriesTableHint: "клик върху името отваря артикулите",
    dailyBillsMany: "{{count}} сметки",
    dailyBillsOne: "{{count}} сметка",
    dailyColTotal: "Общо",
    dailyEmptyHint: "Смени периода или провери дали отчетите са пуснати.",
    dailyKpiReports: "Отчети",
    dailyKpiReportsSub: "персонални",
    dailyKpiRevenue: "Оборот",
    dailyListHint: "клик отваря отчета",
    dailyOther: "Друго",
    dailyReportsTitle: "Дневни отчети",
    dailySearchPlaceholder: "Търси номер или сервитьор",
    dailyTabEstablishment: "Заведение",
    dailyTabPersonal: "Персонални",
    dailyWorkDay: "Работен ден",
    discountsBefore: "Преди",
    discountsBillOpenFailed: "Сметката не може да се отвори",
    discountsEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    discountsGiven: "Отстъпка",
    discountsAdjustmentColumn: "Отстъпка / надбавка",
    discountsKind: "Вид",
    discountsKpiAboveApproval: "Над {{percent}} %",
    discountsKpiAboveApprovalIsolated: "показани само те",
    discountsKpiAboveApprovalSub: "сметки · изискват одобрение",
    discountsKpiAverage: "Средна отстъпка",
    discountsKpiAverageSub: "на сметка",
    discountsKpiBills: "Сметки с отстъпка",
    discountsKpiBillsShare: "{{share}} % от всички",
    discountsKpiBillsUnit: "сметки в периода",
    discountsKpiGiven: "Дадени отстъпки",
    discountsKpiGivenShare: "{{share}} % от брутото",
    discountsKpiGivenSub: "за периода",
    discountsKpiSurcharges: "Надбавки",
    discountsKpiSurchargesNone: "няма за периода",
    discountsSearchPlaceholder: "Търсене по сметка, сервитьор или клиент",
    discountsTableHint: "Клик върху ред отваря историята на операциите",
    discountsTime: "Час",
    itemsAvgKicker: "Средно на артикул",
    itemsAvgSub: "оборот / бройки",
    itemsCategoryFilterChip: "Категория: {{name}}",
    itemsCategoryFilterClear: "Махни филтъра по категория",
    itemsColCount: "Бройки",
    itemsColPrice: "Цена",
    itemsColRevenue: "Оборот",
    itemsColShare: "Дял",
    itemsEmptyHint: "Смени периода или махни филтрите в колоните.",
    itemsRevenueKicker: "Оборот от артикули",
    itemsRevenueSub: "както е платено",
    itemsSoldKicker: "Продадени бройки",
    itemsTableHint: "клик върху ред отваря дните му",
    itemsTableKicker: "Артикули",
    itemsUniqueKicker: "Уникални артикули",
    itemsUniqueSub: "с продажби",
    stationsBillsColumn: "Сметки",
    stationsCountKpi: "Станции",
    stationsCountKpiSub: "с оборот в периода",
    stationsDetailClose: "Затвори",
    stationsEmptyHint: "В избрания период няма закрити сметки с артикули по станции.",
    stationsEmptyTitle: "Няма оборот по станции",
    stationsPageTitle: "Справка по станции",
    stationsRevenueColumn: "Оборот",
    stationsRevenueKpi: "Оборот от артикули",
    stationsRevenueKpiSub: "от закрити сметки, след отстъпки",
    stationsRowMany: "{{count}} станции",
    stationsRowOne: "{{count}} станция",
    stationsSearchPlaceholder: "Търси станция…",
    stationsShareColumn: "Дял",
    stationsWaiters: "Сервитьори",
    stationsAllWaiters: "Всички сервитьори",
    stationsVoidsColumn: "Сторно",
    stationsVoidsCount: "{{count}} бр.",
    stationsVoidsKpi: "Сторно по станции",
    voidsBatchChip: "×{{count}} заедно",
    waitersAvgBill: "Средна сметка",
    waitersBillsMany: "{{count}} сметки",
    waitersBillsOne: "{{count}} сметка",
    waitersDayMany: "{{count}} дни",
    waitersDayOne: "{{count}} ден",
    waitersDaysHint: "Разбивка по метод на плащане",
    waitersDaysKicker: "По дни",
    waitersDetailSubtitle: "Оборот по дни за избрания период",
    waitersEmptyHint: "Смени периода или провери дали сметките са закрити.",
    waitersEmptyTitle: "Няма закрити сметки в периода",
    waitersKicker: "Сервитьори",
    waitersOnShift: "{{count}} на смяна",
    waitersRevenue: "Оборот",
    waitersRowHint: "Клик отваря детайл по дни",
    waitersSearchPlaceholder: "Търси сервитьор…",
    waitersShare: "Дял",
    dailyKpiReportsEstablishmentSub: "на заведението",
    establishmentPreparedBy: "Съставил",
    establishmentSearchPlaceholder: "Търси номер или съставил",
    invoicesColStatus: "Състояние",
    invoicesColType: "Вид",
    invoicesEmptyHint: "Смени периода или изчисти търсенето.",
    invoicesGrandKpi: "Общо",
    invoicesGrandKpiSub: "с ДДС",
    invoicesStatusCancelled: "Анулирана",
    invoicesStatusIssued: "Издадена",
    invoicesTableHint: "клик отваря фактурата",
    invoicesTaxableKpi: "Данъчна основа",
    invoicesTaxableKpiSub: "без ДДС",
    invoicesVatKpi: "ДДС",
    invoicesVatKpiSub: "начислен данък",
    salesPeriodsReport: "Персонализирани справки",
    salesPeriodsPageTitle: "Персонализирани справки",
    salesPeriodsMode_grouped: "Групирано",
    salesPeriodsMode_timeline: "Във времето",
    salesPeriodsUnit_hour: "Часове",
    salesPeriodsUnit_weekday: "Дни от седмицата",
    salesPeriodsUnit_month: "Месеци",
    salesPeriodsUnit_date: "Дати",
    salesPeriodsUnit_year: "Години",
    salesPeriodsAllUsers: "Всички потребители",
    salesPeriodsUsers: "Потребители",
    salesPeriodsAllClients: "Всички клиенти",
    salesPeriodsClients: "Клиенти",
    salesPeriodsWithoutClient: "Без клиент",
    salesPeriodsAllItems: "Всички артикули",
    salesPeriodsItems: "Артикули",
    salesPeriodsClearFilters: "Изчисти филтрите",
    salesPeriodsChartHint: "един стълб = един ред от таблицата",
    salesPeriodsTableKicker: "Периоди",
    salesPeriodsRowOne: "{{count}} период",
    salesPeriodsRowMany: "{{count}} периода",
    salesPeriodsTableHint: "клик върху ред отваря дните",
    salesPeriodsSearchPlaceholder: "Търси период…",
    salesPeriodsEmptyTitle: "Няма продажби за този период",
    salesPeriodsEmptyHint: "Промени периода или махни филтрите.",
    salesPeriodsPeriodColumn: "Период",
    salesPeriodsBillsColumn: "Сметки",
    salesPeriodsQuantityColumn: "Брой асортименти",
    salesPeriodsQuantityShort: "арт.",
    salesPeriodsRevenueColumn: "Сума",
    salesPeriodsVatColumn: "ДДС",
    salesPeriodsNetColumn: "Нето",
    salesPeriodsAvgPriceColumn: "Ср. цена",
    salesPeriodsAvgBillColumn: "Средна сметка",
    salesPeriodsAvgBillShort: "ср.",
    salesPeriodsClientsColumn: "Клиенти брой",
    salesPeriodsClientRevenueColumn: "Клиенти сума",
    salesPeriodsClientAvgColumn: "Клиенти средна сума",
    salesPeriodsFiscalizedColumn: "Сума ФП",
    salesPeriodsBaseColumn: "По базови цени",
    salesPeriodsDiscountColumn: "Отстъпки",
    salesPeriodsMarkupColumn: "Надбавки",
    salesPeriodsDetailSubtitle: "{{bills}} сметки · {{amount}}",
    // Шаблоните на „Персонализирани справки" (salesByPeriods/templates/)
    salesPeriodsTemplates: "Шаблони",
    salesPeriodsTemplateNew: "Запази като шаблон",
    salesPeriodsTemplateDiscard: "Отхвърли",
    salesPeriodsTemplateModified: "Променен",
    salesPeriodsTemplateRename: "Преименувай",
    salesPeriodsTemplateDelete: "Изтрий",
    salesPeriodsTemplateDeleteTitle: "Изтриване на шаблон",
    salesPeriodsTemplateDeleteDescription:
      "Шаблонът „{{name}}“ ще изчезне за всички в ресторанта. Справката остава настроена както е сега.",
    salesPeriodsTemplateCreateTitle: "Нов шаблон",
    salesPeriodsTemplateCreateSubtitle:
      "Общ за ресторанта — вижда го всеки с достъп до справката.",
    salesPeriodsTemplateRenameTitle: "Преименуване на шаблон",
    salesPeriodsTemplateRenameSubtitle: "Новото име се вижда от всички в ресторанта.",
    salesPeriodsTemplateNameLabel: "Име",
    salesPeriodsTemplateNamePlaceholder: "напр. Кафета по часове",
    salesPeriodsTemplateRemembers: "Шаблонът ще запомни",
    salesPeriodsTemplateGrouping: "Групиране",
    salesPeriodsTemplateFilters: "Филтри",
    salesPeriodsTemplateNoFilters: "без филтри",
    salesPeriodsTemplateColumns: "Колони",
    salesPeriodsTemplateColumnsValue: "{{visible}} от {{total}}",
    salesPeriodsTemplateColumnFiltersOne: "{{count}} филтър в колоните",
    salesPeriodsTemplateColumnFiltersMany: "{{count}} филтъра в колоните",
    salesPeriodsTemplatePeriod: "Период",
    salesPeriodsTemplatePeriodNone: "не се пази — не е избран бутон",
    salesPeriodsTemplateFiltersOne: "{{count}} филтър",
    salesPeriodsTemplateFiltersMany: "{{count}} филтъра",
    salesPeriodsTemplateSaved: "Шаблонът „{{name}}“ е запазен",
    salesPeriodsTemplateUpdated: "Промените са запазени в „{{name}}“",
    salesPeriodsTemplateRenamed: "Шаблонът е преименуван",
    salesPeriodsTemplateDeleted: "Шаблонът е изтрит",
    salesPeriodsTemplateSaveError: "Шаблонът не беше запазен. Опитай пак.",
    methodAmountColumn: "{{method}} (както е платено)",

    // --- Справки за резервации (reservations/) ---
    reservationsReports: "Резервации",
    rvJournal: "Дневник на резервациите",
    rvOccupancy: "Натовареност",
    rvGuests: "Гости",
    rvStatus_upcoming: "Предстояща",
    rvStatus_seated: "Настанена",
    rvStatus_completed: "Приключила",
    rvStatus_cancelled: "Отказана",
    rvStatus_expired: "Неизпълнена",
    rvKpiReservations: "Резервации",
    rvKpiReservationsSub: "предстоящи {{upcoming}} · настанени {{seated}}",
    rvKpiGuests: "Гости",
    rvKpiGuestsSub: "без отказаните и неизпълнените",
    rvKpiAverageParty: "средно {{value}} на резервация",
    rvKpiCompletedSub: "гостите са дошли и са си тръгнали",
    rvKpiCancelledSub: "отказани преди часа",
    rvKpiNoShowNone: "няма неявявания",
    rvKpiNoShowRate: "{{value}} % неявяване",
    rvKpiRevenue: "Оборот",
    rvKpiRevenueSub: "по сметките на настанените",
    rvColumnTime: "Час",
    rvColumnPhone: "Телефон",
    rvColumnGuests: "Гости",
    rvColumnTables: "Маси",
    rvColumnStatus: "Статус",
    rvColumnName: "Име",
    rvColumnDuration: "Продължителност",
    rvColumnSeatedAt: "Настанени в",
    rvColumnReleasedAt: "Тръгнали в",
    rvColumnAvgDuration: "Средна продължителност",
    rvExportDurationMinutes: "Продължителност (мин)",
    rvExportAvgDurationMinutes: "Средна продължителност (мин)",
    rvAllStatuses: "Всички статуси",
    rvStatuses: "Статуси",
    rvAllTables: "Всички маси",
    rvChartTitle: "Резервации по периоди",
    rvChartAverage: "средно {{value}}",
    rvChartEmpty: "Няма резервации за избрания период и филтри.",
    rvKpiPerPeriod: "Средно на {{unit}}",
    rvKpiPerPeriodSub: "{{count}} периода в таблицата",
    rvPerUnit_hour: "час",
    rvPerUnit_weekday: "ден от седмицата",
    rvPerUnit_month: "месец",
    rvPerUnit_date: "ден",
    rvPerUnit_year: "година",
    rvColumnStay: "Реален престой",
    rvColumnBill: "Сметка",
    rvColumnCreatedBy: "Създадена от",
    rvColumnSeatedBy: "Настанена от",
    rvSeatedByNoOrder: "Още няма поръчка",
    rvSeatedByNoOrderClosed: "Без поръчка",
    rvColumnNote: "Забележка",
    rvColumnCreatedAt: "Създадена на",
    rvColumnAvgStay: "Среден реален престой",
    rvColumnNoShowRate: "Неявяване",
    rvColumnLastVisit: "Последно посещение",
    rvColumnLastReservation: "Последна резервация",
    rvColumnFirstReservation: "Първа резервация",
    rvExportEnd: "Край",
    rvExportStayMinutes: "Реален престой (мин)",
    rvExportBillName: "Маса на сметката",
    rvExportAvgStayMinutes: "Среден реален престой (мин)",
    rvJournalKicker: "Резервации по час",
    rvReservationOne: "{{count}} резервация",
    rvReservations: "{{count}} резервации",
    rvJournalHint: "периодът е по часа на резервацията",
    rvJournalSearchPlaceholder: "Търси гост, телефон, маса…",
    rvNoData: "Няма резервации в избрания период",
    rvEmptyHint: "Разшири периода или провери дали модулът „Резервации“ се ползва.",
    rvKpiGuestsCount: "Гости",
    rvKpiGuestsCountSub: "различни телефони",
    rvKpiReservationsOfGuestsSub: "общо в периода",
    rvKpiReturning: "Редовни",
    rvKpiReturningSub: "с повече от една резервация",
    rvKpiWithNoShow: "С неявяване",
    rvKpiWithNoShowSub: "поне една неизпълнена",
    rvGuestsKicker: "Гости по телефон",
    rvGuestOne: "{{count}} гост",
    rvGuestsMany: "{{count}} гости",
    rvGuestsHint: "името е от последната резервация на госта",
    rvGuestsSearchPlaceholder: "Търси име или телефон…",
    rvGuestVisitsPeriod: "период {{period}}",
    rvGuestVisitsKpiVisits: "Посещения",
    rvGuestVisitsOfReservationOne: "от {{count}} резервация",
    rvGuestVisitsOfReservationsMany: "от {{count}} резервации",
    rvGuestVisitsKpiAverageBill: "Средна сметка",
    rvGuestVisitsKpiAverageStay: "Среден престой",
    rvGuestVisitsKpiCompletedSub: "по приключилите посещения",
    rvGuestVisitsKpiRevenue: "Общо похарчено",
    rvGuestVisitsKpiRevenueSub: "всички сметки в периода",
    rvGuestVisitsKpiCancelled: "Отказани",
    rvGuestVisitsKpiNoShow: "Неизпълнени",
    rvGuestVisitsKpiNoShowSub: "резервирали, но не дошли",
    rvGuestVisitsListTitle: "Резервации в периода",
    rvGuestVisitsEmpty: "Няма резервации на този гост в избрания период.",
    rvGuestVisitsFailed: "Историята на госта не се зареди. Опитай пак.",
  },

  restoreBill: {
    title: "Възстановяване на сметка",
    total: "Общо: {{count}}",
    range30: "30 мин",
    range60: "60 мин",
    range120: "2 часа",
    noBills: "Няма закрити сметки за избрания период",
    restore: "Възстанови",
    fiscalize: "Фискализирай",
    changePaymentMethod: "Смяна на плащане",
    success: "Сметката е възстановена успешно",
    error: "Грешка при възстановяване на сметката",
    cardWarning:
      "Сметката е платена с карта (RRN {{rrn}}). Сторното излиза „В брой“ — върнете сумата на госта в брой от касата, не през терминала.",
    cardWarningNoRrn:
      "Сметката е платена с карта. Сторното излиза „В брой“ — върнете сумата на госта в брой от касата, не през терминала.",
    cardRefundPlaceholder: "RRN, ако по изключение е върнато през терминала (по избор)",
  },

  language: {
    bg: "Български",
    en: "English",
  },

  changelog: {
    kicker: "ВЕРСИИ",
    title: "История на промените",
    subtitle:
      "Всички версии, нови функции, поправки и подобрения на системата.",
    currentVersion: "Текуща версия",
    latest: "Последна",
    legend: "Типове промени",
    typeFeature: "Нова функция",
    typeFix: "Поправка",
    typeImprovement: "Подобрение",
    typeBreaking: "Промяна",
    typeSecurity: "Сигурност",
  },

  monitoring: {
    title: "Мониторинг",
    subtitle: "Служебен достъп — одит, фискални проблеми и AI помощник",
    auditLog: "Одит на действията",
    auditLogDesc:
      "Записи за всички операции в системата — кой, кога и какво е променил.",
    fiscalIssues: "Фискални проблеми",
    fiscalIssuesDesc:
      "Сметки и сторна без потвърден фискален бон — преглед и повторен опит.",
    changelog: "История на промените",
    changelogDesc:
      "Всички версии, нови функции, подобрения и поправки на системата — само за тестова организация.",
    assistant: "AI помощник",
    assistantDesc:
      "Въпроси за настройки и проблеми — отговорът е от базата знания и данните на този ресторант.",
    assistantSubtitle: "База знания и данни на живо на ресторанта",
    assistantPlaceholder: "Как да… / Защо не…  (Enter — питай, Shift+Enter — нов ред)",
    assistantPlaceholderShort: "Как да… / Защо не…",
    assistantSend: "Питай",
    assistantNewConversation: "Нов разговор",
    assistantThinking: "Търся в базата и в данните… {{seconds}} s",
    assistantEmptyTitle: "Какво да проверя?",
    assistantEmpty:
      "Питай за настройка, за симптом или за конкретен човек, продукт, станция, устройство.",
    assistantExample1: "Защо Иван не вижда „Сторниране“?",
    assistantExample2: "Защо не печата на станция Бар?",
    assistantExample3: "Кои сметки днес са без касов бон?",
    confidenceConfirmed: "Потвърдено",
    confidenceLikely: "Почти сигурно, непотвърдено",
    confidenceUnknown: "Не знам",
    confidenceClarify: "Нужно уточнение",
    assistantStatsSummary: "{{seconds}} s · {{rounds}} стъпки",
    assistantStatsCost: "~${{cost}}",
    assistantStatsTokens:
      "Вход {{tokensIn}} (кеш {{cacheRead}}) · изход {{tokensOut}} · {{model}}",
    assistantStatsTools: "Инструменти и раздели",
    assistantHelpful: "Полезно ли беше?",
    assistantVoteUp: "Полезно",
    assistantVoteDown: "Не е полезно",
    assistantCommentPlaceholder:
      "Какво не е наред / какъв е верният отговор? (по желание)",
    assistantCommentSend: "Изпрати",
    assistantFeedbackSaved: "Оценката е записана.",
    assistantFeedbackError: "Оценката не се записа.",
    assistantNotRecorded: "Отговорът не е записан — оценка не е възможна.",
    assistantErrNotConfigured:
      "AI помощникът не е конфигуриран на сървъра (липсва ключ за OpenAI).",
    assistantErrExpired: "Разговорът е изтекъл — започваме нов. Задайте въпроса отново.",
    assistantErrTimeout: "Отговорът отне твърде дълго — задайте по-конкретен въпрос.",
    assistantErrUpstream: "OpenAI не отговори — опитайте отново след малко.",
    assistantErrForbidden: "Само служебният акаунт на UnrealSoft има достъп.",
    assistantErrGeneric: "Въпросът не мина — опитайте отново.",
  },

  auditLog: {
    title: "Дневник на действията",
    subtitle: "Кой, кога и какво е направил — по всички модули.",
    searchPlaceholder: "Търси по всички полета…",
    noResults: "Няма намерени записи",
    emptyHint:
      "Разшири периода или махни някой от филтрите. Прегледите (GET) са скрити, докато не се включат.",
    tableKicker: "ДНЕВНИК",
    tableCount: "{{count}} записа",
    tableCountOne: "{{count}} запис",
    tableHint: "клик отваря пълния запис",
    statusClass: {
      "2xx": "Успешни (2xx)",
      "4xx": "Грешка на клиента (4xx)",
      "5xx": "Сървърна грешка (5xx)",
    },
    col: {
      timestamp: "Време",
      outcome: "Резултат",
      operation: "Действие",
      module: "Модул",
      impact: "Вид",
      table: "Маса",
      billId: "Сметка",
      user: "Потребител",
      userId: "Ид на потребител",
      method: "Метод",
      status: "Статус",
      duration: "Латентност",
      path: "URL",
      entryId: "Ид на запис",
    },
    module: {
      ordering: "Маркиране",
      cash: "Каса",
      reports: "Справки",
      invoicing: "Фактури",
      inventory: "Склад",
      configuration: "Конфигурация",
      access: "Достъп",
      system: "Системни",
    },
    impact: {
      money: "Пари",
      settings: "Настройки",
      data: "Данни",
      read: "Четене",
    },
    outcome: {
      ok: "Успешно",
      failed: "Бонът не е излязъл",
      rejected: "Отказано",
      error: "Сървърна грешка",
    },
    quick: {
      problems: "Само проблеми",
      money: "Пари",
      settings: "Настройки",
      slow: "Бавни над {{ms}} ms",
      reads: "С прегледите (GET)",
      live: "На живо",
    },
    stats: {
      actions: "ДЕЙСТВИЯ",
      actionsSub: "промени: {{writes}} · прегледи: {{reads}}",
      problems: "ПРОБЛЕМИ",
      problemsSub: "неуспели или отказани",
      fiscalFailedSub: "в т.ч. {{count}} непечатани бона",
      fiscalFailedSubOne: "в т.ч. 1 непечатан бон",
      money: "ПАРИ",
      moneySub: "плащане, сторно, отстъпка, каса",
      settings: "НАСТРОЙКИ",
      settingsSub: "конфигурация и устройства",
      people: "ХОРА",
      lastAt: "последно в {{when}}",
      slowest: "НАЙ-БАВНО",
      avg: "средно {{value}}",
      byHour: "ПО ЧАС",
      byDay: "ПО ДЕН",
      barsHint: "клик стеснява периода",
      barTitle: "{{when}} · действия: {{count}} · проблеми: {{problems}}",
    },
    breakdown: {
      byModule: "ПО МОДУЛ",
      byUser: "ПО ПОТРЕБИТЕЛ",
      clickHint: "клик стеснява списъка",
      anonymous: "Без потребител",
    },
    trace: {
      kicker: "ПРОСЛЕДЯВАНЕ",
      billTitle: "Сметка #{{id}} · маса {{table}}",
      tableTitle: "Маса {{name}}",
      billHint: "Проследи сметка #{{id}}",
      tableHint: "Проследи маса {{name}}",
      count: "{{count}} записа",
      countOne: "{{count}} запис",
      periodOff: "периодът е изключен — вижда се целият живот",
      exit: "Изход",
    },
  },

  auditLogDetail: {
    request: "Заявка",
    response: "Отговор",
    headers: "Headers",
    query: "Query string",
    body: "Body",
    empty: "Няма",
    getNoBody: "GET заявките нямат body — данните са в Query string",
    copy: "Копирай",
    copied: "Копирано!",
    togglePretty: "Форматирай",
    toggleRaw: "Без форматиране",
    loadError: "Грешка при зареждане на детайлите",
    truncatedTitle: "Данните бяха твърде големи",
    truncatedBody:
      "Тялото беше {{size}} KB. Не сме го запазили цялото, за да не натрупваме излишно в базата (лимит: 10 KB).",
    truncatedBodyUnknown:
      "Тялото надхвърли лимита (10 KB) и не е запазено цяло, за да не натрупваме излишно в базата.",
    human: {
      deposit: "Депозит",
      rawTitle: "Технически детайли (суров запис)",
      summaryKicker: "Какво се случи",
      who: "Потребител",
      when: "Време",
      table: "Маса",
      noDetails:
        "За тази операция няма подробен човешки преглед — виж техническите детайли по-долу.",
      total: "Общо",
      product: "Продукт",
      products: "Продукти",
      unknownProduct: "Непознат продукт",
      method: "Метод",
      modifier: "Модификатор",
      discount: "Отстъпка",
      percent: "Процент",
      client: "Клиент",
      discountType: "Тип отстъпка",
      removedDiscountNote: "Премахната е отстъпката от сметката.",
      cancelled: "Сторнирано",
      reason: "Причина",
      defective: "Брак",
      yes: "Да",
      no: "Не",
      cancelledAllNote: "Сторнирана е цялата сметка.",
      paymentMethod: "Начин на плащане",
      cash: "В брой",
      card: "С карта",
      paidTotal: "Платена сума",
      addedAmount: "Добавена сума",
      restoredNote: "Приключената сметка е отворена наново (същото id).",
      depositAmount: "Сума на депозита",
      depositAttachedNote: "Депозитът е закачен към сметката — приспада се при закриването ѝ.",
      depositDetachedNote: "Депозитът е махнат от сметката — пак е свободен.",
      // „Задържане на поръчка" — нова/добавена поръчка и „Освободи"
      kitchenHold: "Задържана",
      kitchenHoldMinutes: "{{count}} мин",
      kitchenHoldManual: "докато я освободят",
      // Групата с индекси — колко от редовете на поръчката чакат
      kitchenHoldRows_one: "{{count}} от {{total}} реда",
      kitchenHoldRows_other: "{{count}} от {{total}} реда",
      kitchenOrder: "Поръчка",
      kitchenHeldAt: "Задържана в",
      kitchenReleasedAt: "Освободена в",
      kitchenReleasedNote:
        "Задържаната поръчка е пусната — влезе в кухнята (мониторите и кухненският билет).",
      // „Промени" на задържана поръчка (`PUT …/kitchen-hold`)
      kitchenNewTime: "Ново време",
      kitchenEntersAt: "Влиза в",
      kitchenHoldChangedNote:
        "Сменено е времето на задържаната поръчка — новото се брои от момента на промяната; в кухнята още не е влязла.",
      targetTable: "Към маса",
      movedItems: "Преместени продукта",
      movedProducts: "Преместени продукти",
      newName: "Ново име",
      waiter: "Сервитьор",
      cashIn: "Внесено",
      cashOut: "Изтеглено",
      successLabel: "Успешно",
      failedLabel: "Неуспешно",
      prevOp: "Предишна операция по сметката",
      nextOp: "Следваща операция по сметката",
      timelineTitle: "Хронология на сметката",
      billLabel: "Сметка",
      operationsWord: "операции",
      flagDiscountReverted: "Отстъпка приложена и след това премахната",
      flagCancelAfterClose: "Сторно след затваряне на сметката",
      flagFailed: "Операцията е неуспешна",
      // Сметка: премахната отстъпка на ред и промяна на цени
      removedItemDiscountNote: "Премахната е отстъпката от този продукт.",
      newPrices: "Нови цени",
      itemDiscounts: "Отстъпки по продукти",
      additionLine: "добавка",
      // Складова база
      recipe: "Рецепта",
      documentNo: "Документ",
      warehouse: "Склад",
      fromWarehouse: "От склад",
      toWarehouse: "Към склад",
      supplier: "Доставчик",
      invoiceNumber: "Фактура №",
      deliveryValue: "Стойност на доставката",
      writeoffKind: "Вид",
      writeoffKindScrap: "Бракуване",
      writeoffKindNormal: "Изписване",
      substitutions: "Замени",
      countedProducts: "Преброени продукти",
      postedProducts: "Разнесени продукти",
      reportNo: "Отчет",
      hint: "Подсказка",
      coefficient: "Коефициент",
      groupMembers: "Продукти в групата",
      vatRegistered: "Регистрация по ДДС",
      defaultWarehouse: "Склад по подразбиране",
      productWarehouse: "Свой склад на продукта",
      productWarehouseRemovedNote:
        "Своят склад на продукта е махнат — оттук нататък решава складът на станцията.",
      restoredDocument: "Възстановен документ",
      deliveryNotes: "Стокови разписки",
      closeReason: "Причина",
      markedPaid: "Отбелязани като платени",
      detachedNotesNote: "Стоковите са извадени от фактурата си; стоката им остава заприходена.",
      closedNotesNote: "Стоковите са приключени без фактура — вече не чакат фактура.",
      reopenedNotesNote: "Стоковите отново чакат фактура.",
      restoredDocumentNote: "Анулиран складов документ е върнат в действие.",
      cancelledDocumentNote: "Документът е анулиран.",
      deletedGroupNote: "Групата взаимозаменяеми продукти е изтрита окончателно.",
      truncatedBodyNote:
        "Тялото на заявката е било твърде голямо и не е запазено — виж документа в Складова база.",
      // Конфигурация, печат, устройства, глас
      newValue: "Нова стойност",
      turnedOn: "Включено",
      turnedOff: "Изключено",
      invoiceNo: "Фактура",
      result: "Резултат",
      errorLabel: "Грешка",
      requestId: "Ид на заявката",
      device: "Устройство",
      deviceUpdateNote:
        "Изпратена е команда касата да се обнови до последната версия на FiscalAPI.",
      fiscalRetryNote: "Повторен опит за издаване на касовата бележка.",
      stornoRetryNote: "Повторен опит за издаване на кредитното известие.",
      recognizedProducts: "Разпознати продукти",
      voiceAmbiguous: "двусмислено, кандидати",
      voiceNoMatch: "няма съвпадение в менюто",
      // Резервации
      reservationGuest: "Гост",
      reservationTables: "Маси",
      reservationTime: "Час",
      reservationGuests: "Гости",
      reservationDuration: "Продължителност",
      reservationBill: "Сметка",
      reservationBillNew: "№ {{id}} — нова празна сметка",
      reservationBillAttached: "№ {{id}} — закачена към отворена сметка",
      reservationBills: "Сметки",
      reservationBillsSeparate: "{{ids}} — отделна сметка за всяка маса",
      reservationReleasedNote:
        "Гостите си тръгнаха — резервацията е приключена; сметката остава отворена до закриване в Маркиране.",
      reservationUnseatedNote:
        "Настаняването е отменено — резервацията е отново предстояща; сметката не е пипана.",
      reservationUnseatedBillClosedNote:
        "Настаняването е отменено — резервацията е отново предстояща; празната сметка от настаняването (без поръчки) е премахната.",
      reservationCancelledNote: "Резервацията е отказана — масите са освободени.",
      reservationRestoredNote: "Резервацията е върната в предстоящи.",
      reservationOrigin: "Източник",
      reservationOriginEdge: "Касата, без интернет — качено при синхронизацията",
    },
  },

  push: {
    menuLabel: "Известия",
    settingsTitle: "Известия",
    settingsSubtitle: "Известия от кухнята при сготвени и издадени поръчки.",
    toggleLabel: "Получавай известия на това устройство",
    unsupportedHint:
      "Този браузър не поддържа известия. На iPhone приложението първо трябва да се инсталира на началния екран (Сподели → „Добави към началния екран“).",
    permissionDeniedHint:
      "Известията са забранени от браузъра за този сайт. Разрешете ги от настройките на сайта в браузъра и опитайте отново.",
    enableError: "Известията не се включиха. Опитайте отново.",
    disableError: "Известията не се изключиха. Опитайте отново.",
    deviceTitle: "Известия на устройството",
    deviceSubtitle: "Кой получава известия на този терминал.",
    deviceEmpty: "Никой не е абониран за известия на това устройство.",
    remove: "Премахни",
    removeError: "Премахването не успя. Опитайте отново.",
  },
  // Смяна на собствените код и парола от профилното меню
  // (components/profile/ChangeCredentialsModal.tsx, BE router_credentials.py)
  credentials: {
    menuLabel: "Смяна на код или парола",
    menuLabelCode: "Смяна на код",
    menuLabelPassword: "Смяна на парола",
    modal: {
      title: "Смяна на код или парола",
      titleCode: "Смяна на код",
      titlePassword: "Смяна на парола",
      subtitleCode: "Кодът, с който влизате на касата.",
      subtitlePassword: "Паролата, с която влизате в системата.",
      tabCode: "Код",
      tabPassword: "Парола",
      currentCode: "Текущ код",
      newCode: "Нов код",
      confirmCode: "Потвърдете новия код",
      currentPassword: "Текуща парола",
      newPassword: "Нова парола",
      confirmPassword: "Потвърдете новата парола",
      currentCodeRequired: "Въведете текущия код",
      newCodeRequired: "Въведете нов код",
      confirmCodeRequired: "Повторете новия код",
      currentPasswordRequired: "Въведете текущата парола",
      newPasswordRequired: "Въведете нова парола",
      confirmPasswordRequired: "Повторете новата парола",
      passwordMin: "Минимум 3 символа",
      passwordLatin: "Символите трябва да са на латиница",
      codeMismatch: "Кодовете не съвпадат",
      passwordMismatch: "Паролите не съвпадат",
      codeSaved: "Кодът е сменен",
      passwordSaved: "Паролата е сменена",
      saveError: "Смяната не успя. Опитайте отново.",
    },
  },
  // Локален резерв — режим срещу главната каса без интернет (docs/edge.md)
  edge: {
    bannerTitle: "Локален режим",
    bannerText: "без интернет, работиш срещу касата",
    bannerSyncing:
      "интернетът се върна — изчаква се касата да изпрати направеното без връзка",
    bannerRestricted: "влез с код или парола",
    bannerUnresolved_one:
      "{{count}} действие не е стигнало до облака — вижте касата",
    bannerUnresolved_other:
      "{{count}} действия не са стигнали до облака — вижте касата",
    restrictedRequest: "Локален режим — влез с код или парола",
    // Връзката се върна, а локалният билет не можа да се размени за истински
    // токен — човекът пада на ПИН екрана и трябва да прочете ЗАЩО.
    returnedToPin:
      "Интернетът се върна и работата продължава срещу облака — влез отново с кода си.",
    // Ограничен локален режим: единственият път от ПИН екрана към вход с
    // потребител и парола (касата приема само двата входа).
    loginWithPassword: "Влез с потребител и парола",
    unavailableOffline: "Недостъпно без интернет",
    panelKicker: "Офлайн резерв",
    panelTitle: "Локален резерв",
    stateReady: "Готов",
    stateUnreachable: "Няма достъп",
    stateDisabled: "Изключен",
    stateUnknown: "Непроверен",
    stateNoMaster: "Касата не е на връзка",
    stateLocalNow: "В локален режим",
    // Панелът „Офлайн резерв" е на две части (Конфигурация → Устройства):
    // ключът е за ЦЕЛИЯ обект, подготовката — за всяко устройство поотделно.
    sectionSite: "Обектът",
    sectionDevice: "Това устройство",
    stateEnabled: "Включен",
    siteEnabledHint:
      "Загуби ли интернетът, всички подготвени терминали и монитори продължават срещу главната каса.",
    siteOnceHint:
      "Резервът е един за целия обект — включва се веднъж, от който и да е терминал. Изключването също важи за всички.",
    deviceNeedsSite:
      "Първо включи резерва за обекта — после подготви всяко устройство поотделно.",
    disableTitle: "Изключване на офлайн резерва",
    disableQuestion:
      "Резервът се изключва за ЦЕЛИЯ обект — при загуба на интернет спират всички терминали, не само този. Да го изключа ли?",
    disableConfirm: "Да, изключи за обекта",
    compactSummary: "Включен за обекта · това устройство е готово за работа без интернет",
    showDetails: "Подробно",
    hideDetails: "Скрий",
    hintReady:
      "Браузърът стига до главната каса на {{address}}. Загуби ли интернетът, маркирането, кухненските билети и закриването продължават срещу нея.",
    hintUnreachable:
      "Браузърът не стига до касата на {{address}}. Разреши достъпа до локалната мрежа (Chrome/Edge), провери, че FiscalAPI на главната каса е с включен резерв, и натисни „Провери“.",
    hintPublicAddress:
      "Касата е обявила външен адрес ({{address}}) — браузърът не пуска връзка към такъв адрес от друго устройство. Без интернет ще работи само браузърът на самия компютър на касата.",
    thisDeviceIsTill: "Това устройство е касата — връзка през {{address}}",
    hintNoMaster:
      "Нито една инсталация на FiscalAPI не обявява резерв. Включи го в портала на главната каса и изчакай да се обяви.",
    hintDisabled:
      "При загуба на интернет терминалите спират. Включи резерва, за да продължи маркирането срещу главната каса.",
    hintUnknown:
      "Още не е проверено дали браузърът стига до касата — натисни „Провери“.",
    hintLocalNow:
      "Този терминал в момента работи срещу касата. Връщането към облака е автоматично, щом интернетът се върне и касата изпрати дневника си.",
    hintUnresolved_one:
      "Касата държи {{count}} действие, което облакът е отказал — качва се само след намеса на човек при нея („Опитай пак“ или „Отпиши“ в портала ѝ). Дотогава терминалите остават в локален режим, за да не изчезне направеното.",
    hintUnresolved_other:
      "Касата държи {{count}} действия, които облакът е отказал — качват се само след намеса на човек при нея („Опитай пак“ или „Отпиши“ в портала ѝ). Дотогава терминалите остават в локален режим, за да не изчезне направеното.",
    cloudModeLocal:
      "Облакът смята ресторанта за „в локален режим“ — закриването е възможно само от касата, докато тя не изпрати дневника си.",
    forceCloudHint:
      "„Върни към облака“ само ако касата е спряна и няма какво да изпрати — иначе направеното без връзка ще пристигне със закъснение.",
    // Готовността на ОБЕКТА, не на касата: резервът се пали веднъж, но
    // разрешението за локалната мрежа се дава на всяко устройство поотделно.
    clientsSeen_one: "{{count}} устройство я е ползвало през последните 24 ч",
    clientsSeen_other: "{{count}} устройства са я ползвали през последните 24 ч",
    clientsSeenNone:
      "Нито едно устройство не я е ползвало през последните 24 ч — спре ли интернетът, ще мълчат всички. Подготви всеки терминал и монитор от бутона на неговия екран.",
    presenceStale: "Касата мълчи — последно видяна в {{time}}.",
    pendingEvents_one:
      "Касата държи {{count}} събитие, което още не е качила — качва се само.",
    pendingEvents_other:
      "Касата държи {{count}} събития, които още не е качила — качват се сами.",
    // Бутонът, който вдига подканата на браузъра (тя идва само при действие на
    // човек) и сваля наведнъж това, което екранът ще иска без интернет.
    // Излиза заедно с подканата на браузъра, когато тя идва сама при първото
    // докосване (`lib/edge/edgePermission.ts`): отказът е окончателен, а
    // текстът на Chrome не казва защо това устройство има нужда от касата.
    lnaPrompt:
      "Браузърът пита за достъп до касата в локалната мрежа — натисни „Разреши“, за да работи това устройство и без интернет.",
    lnaDenied:
      "Достъпът до касата в локалната мрежа е отказан на това устройство — разреши го от иконата вляво на адреса, иначе без интернет екранът ще мълчи.",
    prepareDevice: "Подготви това устройство",
    prepareDeviceHint:
      "Иска разрешението за локалната мрежа и сваля данните, които този екран ще ползва без интернет.",
    preparing: "Подготвя…",
    prepareReady: "Готово — това устройство ще работи офлайн.",
    prepareBlocked:
      "Браузърът отказа достъп до локалната мрежа — разреши го от иконата вляво на адреса и натисни пак.",
    prepareUnreachable:
      "Касата не отговаря на {{address}} — провери дали FiscalAPI работи и дали адресът ѝ е верен (порталът на касата → Локален режим), после натисни пак.",
    preparePublicAddress:
      "Касата е обявила външен адрес ({{address}}) — браузърът не пуска връзка към такъв адрес. Без интернет ще работи само на компютъра на касата: натисни „Подготви това устройство“ там.",
    prepareDisabled:
      "Локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    prepareNoMaster:
      "Касата още не е обявила адрес — включи резерва в портала ѝ и опитай пак.",
    prepareLocalNow:
      "Този екран вече работи срещу касата — няма какво да се подготвя.",
    masterClientId: "Главна каса",
    address: "Адрес",
    check: "Провери",
    checking: "Проверява…",
    enable: "Включи",
    disable: "Изключи",
    forceCloud: "Върни към облака",
    updateError: "Настройката не се записа",
    // Шестте състояния на връзката (`lib/edge/edgeMode.ts`). Пишат се в
    // `edgeSlice.linkMessage` като КЛЮЧ и се превеждат при рендера.
    // Всяко изречение казва и какво да направи човекът — „грешка" без
    // следваща стъпка е причината сервитьорът да натисне пак и пак.
    // Заглавията („kicker") на лентата — по едно на състояние. Те СЪЩО са тук,
    // а не само като `defaultValue` в компонента: иначе на английски екран
    // човекът чете български в средата на изречението.
    linkTitleSlow: "Бавна връзка",
    linkTitleSuspect: "Проверявам връзката",
    linkTitleDeviceOffline: "Само това устройство",
    linkTitleAppDown: "Облакът се обновява",
    linkSlow: "Връзката е бавна — изчакай, заявката още върви.",
    linkSuspect: "Проверява се връзката с облака…",
    linkDeviceOffline:
      "Само това устройство е без интернет — касата е на линия. Провери Wi-Fi-а му; останалите работят нормално.",
    linkAppDown:
      "Облакът не отговаря, но мрежата е наред — най-вероятно се обновява. Изчакай малко.",
    linkLocal: "Локален режим — работи се срещу касата.",
    tillBackTerminalBlind:
      "Касата вече работи срещу облака, а това устройство още няма интернет — новите действия ще се отказват. Провери Wi-Fi-а на този терминал.",
    linkLostNoFallback:
      "Няма връзка с облака, а локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    // Ръчното превключване (бутонът е на друг екран; текстовете стоят тук,
    // за да са едни и същи, където и да се появи).
    forceLocal: "Включи локален режим",
    forceLocalHint:
      "Замразява ЦЕЛИЯ обект срещу касата — всички терминали започват да работят срещу нея. Използвай само когато обектът стои, а автоматиката не е превключила.",
    forceLocalQuestion:
      "Целият обект минава на работа срещу касата. Да превключа ли сега?",
    forceLocalConfirm: "Да, премини на локален режим",
    forceLocalEntered: "Готово — терминалите работят срещу касата.",
    forceLocalNoPermission:
      "Нямаш право да превключваш режима — извикай отговорника за касата.",
    forceLocalDisabled:
      "Локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    forceLocalNoTill: "Касата не е обявила адрес — няма към кого да се превключи.",
    forceLocalFailed:
      "Касата не пое — провери, че FiscalAPI на главната каса работи, и опитай пак.",
    // Касата е задържана в локален режим по РЪЧНО решение (§19.5) — не „чака
    // да изпрати", а чака човек да я върне.
    bannerManualHold: "касата е в локален режим по ръчно решение",
    bannerManualHoldCloudBack:
      "интернетът се върна, но касата е задържана в локален режим ръчно — върни я към облака",
    releaseLocal: "Върни към облака",
    releaseLocalHint:
      "Касата изпраща направеното без интернет и целият обект се връща към облака. Направи го само ако интернетът работи на терминалите.",
    releaseLocalQuestion: "Да върна ли обекта към облака сега?",
    releaseLocalConfirm: "Да, върни към облака",
    releaseLocalFailed:
      "Връщането не стана. Опитай пак или го направи от касата.",
  },
  lunchMenu: {
    title: "Обедно меню",
    tag: "Обедно",
    backToTables: "Към масите",
    kickerToday: "Днес",
    kickerUpcoming: "Предстоящи",
    kickerPast: "Минали",
    statusLive: "Активно сега",
    statusToday: "По-късно днес",
    statusTomorrow: "Утре",
    statusUpcoming: "Предстои",
    statusRecurring: "Повтарящо се",
    statusPast: "Изтекло",
    newMenu: "Ново обедно меню",
    edit: "Редактирай",
    copy: "Копирай",
    print: "Печат",
    printSetup: {
      title: "Печат на обедно меню",
      settings: "Настройки за печат",
      hideSettings: "Скрий настройките",
      fontSize: "Размер на шрифта",
      subtitle: "Общ шаблон за заведението · промените се виждат веднага в A4 прегледа",
      close: "Затвори",
      content: "Съдържание",
      showVenue: "Име на заведението",
      showTitle: "Заглавие",
      showDate: "Дата и дни",
      showHours: "Часове",
      titleText: "Текст на заглавието",
      typography: "Шрифтове и размери",
      headerAlignment: "Подравняване",
      alignLeft: "Вляво",
      alignCenter: "В центъра",
      alignRight: "Вдясно",
      titleFont: "Шрифт на заглавието",
      venueFont: "Шрифт на заведението",
      bodyFont: "Шрифт на продуктите",
      fontSans: "Модерен",
      fontSerif: "Класически",
      fontMono: "Моноширинен",
      titleSize: "Заглавие",
      venueSize: "Заведение",
      categorySize: "Категории",
      itemSize: "Продукти и цени",
      colors: "Цветове",
      venueColor: "Заведение",
      titleColor: "Заглавие",
      metaColor: "Дата и час",
      categoryColor: "Категории",
      itemColor: "Продукти",
      priceColor: "Цени",
      spacing: "Отстояния",
      topMargin: "Горе и долу",
      sideMargin: "Ляво и дясно",
      sectionSpacing: "Между секциите",
      rowSpacing: "В реда на продукта",
      preview: "Преглед · A4",
      pageNavigation: "Страници на менюто",
      previousPage: "Предишна страница",
      nextPage: "Следваща страница",
      pageSelector: "Страница",
      pageProducts: "Страница {{page}} · продукти: {{count}} от общо {{total}}",
      reset: "Стандартен вид",
      unsaved: "Незапазени промени",
      saveDefault: "Запази за заведението",
      saving: "Запазване…",
      saved: "Шаблонът за печат е запазен",
      saveError: "Шаблонът не можа да се запази",
      serverUnavailable: "Тази версия на сървъра още няма общ шаблон за печат. Можеш да настроиш и отпечаташ това меню, но запазването за заведението е недостъпно.",
      settingsUnavailable: "Общият шаблон за печат не можа да се зареди. Можеш да настроиш и отпечаташ това меню, но запазването за заведението временно е недостъпно.",
      retry: "Опитай пак",
      printNow: "Печат с този вид",
    },
    finishNow: "Приключи сега",
    delete: "Изтрий",
    colProduct: "Продукт",
    colSize: "Размер",
    colPortions: "Порции/ден",
    colMain: "Основна",
    colLunch: "Обедна",
    changedSizeHint: "Зачертано е стойността в асортимента, до нея — обедната. Асортиментът не се променя.",
    createdBy: "Създадено от {{name}}",
    productsCount_one: "{{count}} продукт",
    productsCount_other: "{{count}} продукта",
    pickMenu: "Избери меню от списъка.",
    missingProduct: "Продуктът вече не е в менюто",
    everyWeekdays: "всеки {{days}}",
    everyDay: "всеки ден",
    periodOpenEnded: "от {{from}}",
    defaultName: "Обяд · {{day}} · {{date}}",
    creatingTitle: "Създаване на обедно меню",
    editingTitle: "Редакция на обедно меню",
    emptyTitle: "Още няма обедни менюта",
    emptyText: "Създай първото — избери продукти от каталога, сложи им обедна цена и задай кога да се показва в Маркиране.",
    weekdayShort0: "нд",
    weekdayShort1: "пн",
    weekdayShort2: "вт",
    weekdayShort3: "ср",
    weekdayShort4: "чт",
    weekdayShort5: "пт",
    weekdayShort6: "сб",
    weekdayLong0: "неделя",
    weekdayLong1: "понеделник",
    weekdayLong2: "вторник",
    weekdayLong3: "сряда",
    weekdayLong4: "четвъртък",
    weekdayLong5: "петък",
    weekdayLong6: "събота",
    dayButton0: "Нд",
    dayButton1: "Пн",
    dayButton2: "Вт",
    dayButton3: "Ср",
    dayButton4: "Чт",
    dayButton5: "Пт",
    dayButton6: "Сб",
    confirmDeleteTitle: "Изтриване на обедно меню",
    confirmDeleteMessage: "„{{name}}“ ще изчезне от списъка. Продажбите от него остават в отчетите.",
    confirmFinishTitle: "Приключване на обедно меню",
    confirmFinishMessage: "„{{name}}“ спира веднага и отива в „Минали“.",
    confirmFinish: "Приключи",
    saved: "Обедното меню е запазено",
    deleted: "Обедното меню е изтрито",
    finished: "Обедното меню е приключено",
    loadError: "Обедното меню не можа да се зареди",
    editorKicker: "Обедно меню",
    products: "Продукти",
    priceColumnsHint: "обедна / основна цена",
    emptySelection: "Избери продукти от каталога вляво.",
    emptySelectionNarrow: "Избери продукти от каталога.",
    save: "Запази",
    reviewAndSave: "Преглед и запазване",
    scheduleChange: "Промени",
    scheduleSingleDate: "една дата",
    scheduleTitle: "Кога е активно",
    scheduleSubtitle: "Извън този период менюто не се показва в Маркиране.",
    name: "Име",
    modeSingle: "За една дата",
    modeRecurring: "Повтарящо се",
    date: "Дата",
    today: "Днес",
    tomorrow: "Утре",
    weekdays: "Дни от седмицата",
    period: "Период",
    periodFrom: "от",
    periodTo: "до",
    noEndDate: "без крайна дата",
    hours: "Часове",
    done: "Готово",
    errorName: "Въведи име на менюто.",
    errorItems: "Избери поне един продукт.",
    errorTime: "Началният час трябва да е преди крайния.",
    errorWeekdays: "Избери поне един ден от седмицата.",
    errorPeriod: "Крайната дата е преди началната.",
    errorPastDate: "Датата трябва да е днешна или бъдеща.",
    errorFarDate: "Датата може да е най-много 2 години напред.",
    priceTooHigh: "Най-много {{max}}",
    reorderEnded: "Обедното меню е приключило — този продукт не може да се поръча пак от него.",
    orderEnded: "Обедното меню е приключило — продуктите от него минаха на основната цена. Провери поръчката и я изпрати пак.",
    recipeSizeFixed: "Работите със склад — количеството е това на рецептата и не се сменя. В обедното меню се сменя само цената.",
    cartSwitchedToRegular_one: "Обедното меню приключи — 1 продукт в поръчката вече е с основната цена.",
    cartSwitchedToRegular_other: "Обедното меню приключи — {{count}} продукта в поръчката вече са с основната цена.",
    modalClosedEnded: "Обедното меню приключи — прозорецът на обедния продукт е затворен.",
    cartRemoved_one: "1 продукт от обедното меню вече не е в менюто и отпадна от поръчката.",
    cartRemoved_other: "{{count}} продукта от обедното меню вече не са в менюто и отпаднаха от поръчката.",
    errorPrice: "Провери цените — има празна или невалидна.",
    dailyLimitTitle: "Порции на ден",
    dailyLimitInvalid: "Цяло число от 0 до {{max}}",
    dailyLimitHint: "0 = без ограничение · напр. 20 → след 20 продадени за деня става „Изчерпано“",
    dailyLimitShort: "{{count}}/ден",
    dailyLimitUnlimited: "Без ограничение",
    errorDailyLimit: "Провери порциите на ден — цяло число от 0 до 9 999.",
    countLeft: "{{count}} бр",
    tagSoldOut: "Изчерпано",
    remainingTitle_one: "Остава {{count}} порция за днес",
    remainingTitle_other: "Остават {{count}} порции за днес",
    limitSoldOut: "„{{name}}“ от обедното меню е изчерпан за днес.",
    limitOnlyLeft_one: "„{{name}}“ — от обедното меню остава само {{count}} порция за днес.",
    limitOnlyLeft_other: "„{{name}}“ — от обедното меню остават само {{count}} порции за днес.",
    limitReachedOrder: "Порциите от обедното меню не стигат: {{items}}. Броят е обновен — намали количеството.",
    limitReachedItem: "„{{name}}“ (остават {{count}})",
    lunchPrice: "Обедна цена",
    mainPriceSubtitle: "основна цена {{price}}",
    resetPrice: "Върни основната цена",
    mainPriceShort: "основна",
    sizeTitle: "Единица и размер",
    byLanguage: "по езици",
    inAssortment: "в асортимента: {{value}}",
    fromAssortment: "празно → от асортимента",
    sizeScopeHint: "Промяната важи само за това обедно меню — асортиментът не се пипа.",
    remove: "Махни",
    apply: "Приложи",
    overlapTitle: "Има обедно меню за този период",
    overlapMessage: "„{{name}}“ ({{schedule}}) се застъпва с новото. В един момент може да е активно само едно обедно меню.",
    finishOld: "Приключи старото",
    finishOldHint: "Старото ще важи до {{endDate}} включително, защото новото започва на {{startDate}} и двете не могат да са активни едновременно. После остава в „Минали“.",
    finishOldNowHint: "Спира веднага и остава в „Минали“ — от този момент важи новото.",
    deleteOld: "Изтрий старото",
    deleteOldHint: "Изчезва от списъка. Продажбите от него остават в отчетите.",
    finishAndSave: "Приключи и запази",
    deleteAndSave: "Изтрий и запази",
    printPricesNote: "Цените са в евро с включен ДДС.",
    printAllergensTitle: "Алергени",
  },
  // „Настани" от Маркиране (src/pages/ordering/components/tables/seat/).
  seatReservation: {
    action: "Настани",
    title: "Настани резервация",
    lateShort: "−{{duration}}",
    soonShort: "след {{duration}}",
    now: "сега",
    tables_one: "Маса {{tables}}",
    tables_other: "Маси {{tables}}",
    emptyHint: "Резервациите за днес ще се появят тук.",
    noResults: "Няма резервации по търсенето",
    loadError: "Резервациите не се заредиха",
    retry: "Опитай пак",
    noTable: "Масите на резервацията са изтрити от схемата",
    expired: "Часът на резервацията изтече",
    notUpcoming: "Резервацията вече не е предстояща",
    seat: "Настани",
    takenBy: "Маса {{table}} е заета от {{waiter}}",
    takenByOther: "Маса {{table}} е заета от друг сервитьор",
    // Въпросът „къде да настаним" (SeatChoiceModal.tsx) — вляво резервацията,
    // вдясно изборът; целите — един шаблон за всички случаи (useSeatChoiceText.ts).
    choice: {
      title: "Настани {{guest}}?",
      pickBill: "Към коя сметка",
      pickBillOnTable: "Към коя сметка на маса {{table}}",
      outcome: "Какво ще стане",
      opens: "Ще се отвори",
      open: "Отворена",
      newTable: "Нова маса {{table}}",
      // „Една сметка" в режим „Схема" — пред масите „14 | 13 | 12" (JoinedTableNames).
      newTableJoined: "Нова маса",
      tableJoined: "Маса",
      onWaiter: "на {{waiter}}",
      // Изключеният „Настани", докато при няколко възможности няма избрана.
      pickTable: "Избери сметка",
    },
    // Сметките при резервация с няколко маси (SeatBillsSection.tsx); другите
    // текстове са общите с „Резервации" (reservations.seatBills).
    bills: {
      label: "Как да се водят сметките",
      singleSummary: "Всички маси на една сметка",
    },
    success: "{{guest}} — настанени на маса {{table}}",
    successSeparate: "{{guest}} — настанени на маси {{tables}}, отделна сметка за всяка маса",
  },
  // Модул „Резервации" (src/pages/reservations/).
  reservations: {
    title: "Резервации",
    counts: {
      reservations_one: "{{count}} резервация",
      reservations_other: "{{count}} резервации",
      guests_one: "{{count}} гост",
      guests_other: "{{count}} гости",
      seats_one: "{{count}} място",
      seats_other: "{{count}} места",
    },
    duration: {
      minutes: "{{minutes}} мин",
      hours: "{{hours}} ч",
      hoursMinutes: "{{hours}} ч {{minutes}} мин",
    },
    day: {
      today: "Днес, {{date}}",
      tomorrow: "Утре, {{date}}",
      yesterday: "Вчера, {{date}}",
      previous: "Предишен ден",
      next: "Следващ ден",
      pick: "Избери дата",
    },
    newReservation: "Нова резервация",
    timeline: {
      now: "Сега",
      preview: "Преглед към",
      earlier: "По-рано",
      backToNow: "Сега",
      slider: "Час от деня",
      outside: "Извън {{from}}–{{to}}",
      inFuture: "след {{duration}}",
      inPast: "преди {{duration}}",
    },
    legend: {
      free: "Свободна",
      reserved: "Резервирана",
      occupied: "Заета",
      nextReservation: "Час на следващата резервация",
      fits: "Побира гостите",
      selected: "Избрана",
      blocked: "Заета в този час",
    },
    table: {
      name: "Маса {{name}}",
      hover: "Маса {{name}} · {{seats}}",
      hoverReserved: "резервирана {{time}} · {{guest}}",
      hoverOccupied: "заета {{duration}}",
      hoverNext: "следваща резервация {{time}}",
    },
    popover: {
      close: "Затвори",
      status: {
        free: "Свободна",
        reserved: "Резервирана",
        occupied: "Заета",
      },
      late: "Закъснява {{duration}}",
      arriving: "Пристига след {{duration}}",
      seatedAt: "Настанени в {{time}} · {{duration}}",
      finished: "Приключила резервация",
      reservedMeanwhile: "Резервация в този час",
      occupiedSince: "Заета · от {{time}} · {{duration}}",
      freeUntil: "Свободна до {{time}}",
      freeAllDay: "Свободна до края на деня",
      next: "Следваща резервация",
      nextDetails_one: "{{time}} · {{guest}}, {{count}} гост",
      nextDetails_other: "{{time}} · {{guest}}, {{count}} гости",
      seat: "Настани гостите",
      cancel: "Откажи резервацията",
      release: "Гостите си тръгнаха",
      reserveTable: "Резервирай тази маса",
      seatBlockedOccupied_one: "Маса {{tables}} е заета от настанена резервация",
      seatBlockedOccupied_other: "Масите {{tables}} са заети от настанена резервация",
      seatBlockedEarly: "Може да се настани след {{time}}",
      seatBlockedPreviousBill: "Сметката на предишната резервация на маса {{table}} ({{waiter}}) още не е закрита",
      seatBlockedPreviousBillNoWaiter: "Сметката на предишната резервация на маса {{table}} още не е закрита",
      seatAttachHint: "Ще се закачи към отворената сметка на {{waiter}}",
      seatAttachHintNoWaiter: "Ще се закачи към отворената сметка на масата",
      seatPickHint: "На масата има няколко отворени сметки — ще избереш при кой сервитьор",
      edit: "Редактирай",
      unseat: "Отмени настаняването",
      restore: "Върни в „Предстоящи“",
    },
    confirmCancel: {
      title: "Да откажем ли резервацията?",
      content_one: "{{guest}} · {{time}} · Маса {{tables}}. Масата се освобождава за този час.",
      content_other: "{{guest}} · {{time}} · Масите {{tables}}. Масите се освобождават за този час.",
      ok: "Откажи резервацията",
      back: "Назад",
    },
    confirmUnseat: {
      title: "Да отменим ли настаняването?",
      content_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Сметката остава в Маркиране.",
      content_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Сметката остава в Маркиране.",
      contentBillCloses_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Празната сметка на маса {{billTable}} ще бъде премахната — никой още не е поръчал.",
      contentBillCloses_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Празната сметка на маса {{billTable}} ще бъде премахната — никой още не е поръчал.",
      contentBillsClose_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Празните сметки на маси {{billTables}} ще бъдат премахнати — никой още не е поръчал.",
      contentBillsClose_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Празните сметки на маси {{billTables}} ще бъдат премахнати — никой още не е поръчал.",
      ok: "Отмени настаняването",
      back: "Назад",
    },
    seatBills: {
      group: "Сметките на резервацията",
      single: "Една сметка",
      singlePick: "На масите има няколко отворени сметки — избери към коя",
      separate: "Отделна сметка за всяка маса",
      separateSummary_one: "{{count}} сметка на резервацията",
      separateSummary_other: "{{count}} сметки на резервацията — по една на маса",
      separateLocalMode: "Само с интернет — касата отваря една сметка",
      // „Отделна…" при няколко сметки на маса (seatBills.ts `separatePlanOf`, orderingSeatBills.ts).
      pickOnTable: "На маса {{table}} има няколко отворени сметки — избери към коя",
      noBillOfWaiter: "На маса {{table}} има няколко отворени сметки и нито една не е на {{waiter}}",
      noOwnBill: "На маса {{table}} има няколко отворени сметки и нито една не е твоя",
      confirm: "Настани",
      back: "Назад",
    },
    seatPicker: {
      title: "При кой сервитьор да настаним?",
      subtitle_one: "{{guest}} · Маса {{tables}}. На масата има няколко отворени сметки — резервацията ще се закачи към избраната.",
      subtitle_other: "{{guest}} · Масите {{tables}}. На масите има няколко отворени сметки — резервацията ще се закачи към избраната.",
      unknownWaiter: "Неизвестен сервитьор",
      table: "Маса {{name}}",
      openedAgo: "отворена преди {{duration}}",
      openedJustNow: "отворена току-що",
      close: "Назад",
    },
    messages: {
      seated: "Гостите са настанени — сметката на масата е отворена",
      seatedNewBill: "Гостите са настанени. Масата ще е на сервитьора, който поръча първи",
      seatedAttached: "Гостите са настанени при {{waiter}}",
      seatedAttachedNoWaiter: "Гостите са настанени — резервацията е закачена към отворената сметка",
      seatedSeparate: "Гостите са настанени — отделна сметка за всяка маса ({{tables}})",
      unseated: "Настаняването е отменено",
      unseatedBillClosed: "Настаняването е отменено. Празната сметка на маса {{table}} е премахната",
      unseatedBillsClosed: "Настаняването е отменено. Празните сметки на маси {{tables}} са премахнати",
      unseatedBillClosedNoTable: "Настаняването е отменено. Празната сметка е премахната",
      restored: "Резервацията е върната в „Предстоящи“",
      restoredExpired: "Часът ѝ е минал — резервацията остава в „Минали“ като „Неизпълнена“",
      released: "Резервацията е приключена",
      releasedBillOpen: "Резервацията е приключена. Масата остава заета, докато сметката не се закрие в Маркиране",
      cancelled: "Резервацията е отказана",
      seatUnavailable: "Резервацията вече не може да бъде настанена",
      actionFailed: "Действието не беше изпълнено",
    },
    offlineHint: "Резервациите работят само с интернет — касата няма схемата и резервациите.",
    offlineStaleHint: "Касата няма пресни данни за този ден — избери ден около днешния или изчакай интернета.",
    dataAsOf: "данни към {{time}}",
    loadError: "Резервациите не се заредиха",
    loadErrorHint: "Провери връзката и опитай пак след малко.",
    noSchema: {
      title: "Няма схема на заведението",
      description: "Нарисувай районите и масите в Резервации → Схема на заведението — резервациите се правят върху нея.",
    },
    noTables: {
      title: "Още няма маси",
      description:
        "Резервациите се правят върху масите от схемата на заведението. Подреди там районите и масите — после ще ги виждаш и тук.",
      action: "Към схемата на заведението",
    },
    noTablesInRegion: {
      title: "В този район още няма маси",
      description: "Подреди масите му в схемата на заведението — после ще ги виждаш и тук.",
    },
    regionAll: "Всички",
    emptyRegion: "В този район още няма маси.",
    list: {
      tabs: {
        upcoming: "Предстоящи",
        seated: "Настанени",
        past: "Минали",
      },
      search: "Име, телефон или маса",
      clearSearch: "Изчисти търсенето",
      seat: "Настани",
      release: "Тръгнаха си",
      tableInRegion: "{{table}} · {{region}}",
      late: "Закъснява {{duration}}",
      soon: "След {{duration}}",
      seatedUntil: "Настанени {{time}} – {{until}}",
      completed: "Приключила",
      cancelled: "Отказана",
      expired: "Неизпълнена",
      empty: {
        upcoming: "Няма предстоящи резервации за деня",
        seated: "Няма настанени гости",
        past: "Още няма минали резервации",
      },
      noMatches: "Няма резервации по това търсене",
      noTable: "Без маса",
      cancel: "Откажи",
      restore: "Върни",
      edit: "Редактирай",
      unseat: "Отмени настаняването",
      moment: {
        tabHasActive: "Има резервации на масите към {{time}}",
      },
    },
    form: {
      title: "Нова резервация",
      editTitle: "Редакция на резервация",
      close: "Затвори",
      when: "Кога",
      today: "Днес",
      tomorrow: "Утре",
      otherDate: "Друга дата…",
      guests: "Гости",
      fewerGuests: "По-малко гости",
      moreGuests: "Повече гости",
      duration: "Продължителност",
      tables: "Маси",
      suggest: "Предложи маса",
      noSuggestion_one: "Няма свободна маса за {{count}} гост в този час",
      noSuggestion_other: "Няма свободна маса за {{count}} гости в този час",
      tablesEmpty: "Кликни свободна маса на схемата. Може да избереш няколко за по-голяма група.",
      tableChip: "Маса {{name}} · {{seats}}",
      removeTable: "Махни маса {{name}}",
      seatsEnough: "{{seats}} за {{guests}}",
      seatsShort: "Недостатъчно места: {{seats}} за {{guests}}",
      tablesBusy: "Заета в този час: {{names}} — избери друга маса",
      freeInRegion: "Свободни маси за {{guests}} в „{{region}}“ · {{time}}. Избери една или няколко.",
      noFreeInRegion: "Няма свободна маса за {{guests}} тук — виж друг район или покажи всички маси.",
      showAllTables: "Покажи всички маси ({{count}})",
      showOfferedOnly: "Покажи само свободните",
      regionHasSelected: "Има избрана маса",
      region: "Район",
      freeCount_one: "{{count}} свободна",
      freeCount_other: "{{count}} свободни",
      guest: "Гост",
      phone: "Телефон",
      name: "Име",
      note: "Забележка — повод, алергии, детско столче…",
      cancel: "Отказ",
      create: "Създай резервация",
      created: "Резервацията е създадена",
      createFailed: "Резервацията не беше създадена",
      save: "Запази промените",
      saved: "Промените са запазени",
      saveFailed: "Промените не бяха запазени",
      dayLoading: "Заетостта на масите за деня се зарежда…",
      dayError: "Заетостта на масите за деня не се зареди",
      retry: "Опитай пак",
      slotPast: "Избраният час мина — избери друг",
      dayClosed: "Почивен ден — не се приемат резервации",
      slotOutsideHours: "Часът е извън работното време — избери друг",
      afterMidnightHint: "Часовете след полунощ ({{from}}–{{to}}) са на {{day}}",
      errors: {
        startAt: "Невалиден ден или час на резервацията",
        durationMinutes: "Продължителността трябва да е между 30 и 480 минути",
        guests: "Броят гости трябва да е между 1 и 500",
        guestName: "Въведи име (до 100 знака)",
        phone: "Невалиден телефонен номер",
        nameRequired: "Въведи име",
        phoneInvalid: "Невалиден телефонен номер",
        note: "Невалидна забележка",
        tableIds: "Избери поне една маса",
      },
      // Познатият телефон: чипът в полето „Телефон" и картата с историята.
      guestHistory: {
        title: "История",
        show: "Покажи историята на госта",
        hide: "Скрий историята на госта",
        misses: "Има отказани или неизпълнени резервации",
        reservations_one: "{{count}} резервация",
        reservations_other: "{{count}} резервации",
        visits_one: "{{count}} посещение",
        visits_other: "{{count}} посещения",
        lastVisit: "Последно идване",
        averageBill: "Средна сметка",
        expired_one: "{{count}} неизпълнена",
        expired_other: "{{count}} неизпълнени",
        cancelled_one: "{{count}} отказана",
        cancelled_other: "{{count}} отказани",
        upcoming_one: "{{count}} предстояща",
        upcoming_other: "{{count}} предстоящи",
        seated_one: "{{count}} настанена сега",
        seated_other: "{{count}} настанени сега",
        lastNote: "Последна бележка",
      },
    },
    picker: {
      badgeSelected: "Избрана",
      badgeBusy: "Заета",
      hoverBusy: "заета в този час",
      hoverSelected: "избрана",
      hoverFits: "побира гостите",
    },
  },
  reservationsTable: {
    title: "Таблица на резервациите",
    table: "Маса",
    search: "Търсене по маса или гост…",
    noMatch: "Няма маси за това търсене.",
    hideUntil: "Скрий до 1-ва резервация",
    hideUntilHint: "Крие часовете преди първата предстояща или настанена резервация",
    showWholeDay: "Покажи целия ден",
    hourLoadHint: "Резервации | гости в този час",
    newAt: "Нова резервация — {{table}}, {{time}}",
    now: "сега {{time}}",
    onlyUpcomingEditable: "Може да се редактира само предстояща резервация",
    legend: {
      expired: "Неизпълнена",
      completed: "Приключила",
    },
  },
  // Разделите на прозореца „Инфо" (ordering/components/menu/ItemDetailModal) —
  // в края на файла, за да не местят цитираните редове над тях.
  itemInfo: {
    allergens: "Алергени",
  },
  // Броячът в модала за лиценза (components/license) — в края на файла, за
  // да не местят цитираните редове над тях.
  licenseCountdown: {
    hours: "{{value}} ч",
    minutes: "{{value}} мин",
  },
};

export default bg;
